function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequire02ae"];
parcelRequire.register("acRLA", function(module, exports) {

$parcel$export(module.exports, "OPTIONAL_METHODS", () => $76e4bb4b0df9e886$export$bc85197675500780);
$parcel$export(module.exports, "OPTIONAL_EVENTS", () => $76e4bb4b0df9e886$export$1d352f96d67d51e6);
$parcel$export(module.exports, "EthereumProvider", () => $76e4bb4b0df9e886$export$cdfbbad9b2980226);

var $7etJZ = parcelRequire("7etJZ");

var $eeGmU = parcelRequire("eeGmU");

var $3ch2e = parcelRequire("3ch2e");
const $76e4bb4b0df9e886$var$P = "wc", $76e4bb4b0df9e886$var$S = "ethereum_provider", $76e4bb4b0df9e886$var$$ = `${$76e4bb4b0df9e886$var$P}@2:${$76e4bb4b0df9e886$var$S}:`, $76e4bb4b0df9e886$var$j = "https://rpc.walletconnect.com/v1/", $76e4bb4b0df9e886$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $76e4bb4b0df9e886$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "personal_sign",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
], $76e4bb4b0df9e886$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $76e4bb4b0df9e886$export$1d352f96d67d51e6 = [
    "chainChanged",
    "accountsChanged",
    "message",
    "disconnect",
    "connect"
];
var $76e4bb4b0df9e886$var$N = Object.defineProperty, $76e4bb4b0df9e886$var$q = Object.defineProperties, $76e4bb4b0df9e886$var$D = Object.getOwnPropertyDescriptors, $76e4bb4b0df9e886$var$y = Object.getOwnPropertySymbols, $76e4bb4b0df9e886$var$U = Object.prototype.hasOwnProperty, $76e4bb4b0df9e886$var$Q = Object.prototype.propertyIsEnumerable, $76e4bb4b0df9e886$var$O = (a, t, s)=>t in a ? $76e4bb4b0df9e886$var$N(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s, $76e4bb4b0df9e886$var$p = (a, t)=>{
    for(var s in t || (t = {}))$76e4bb4b0df9e886$var$U.call(t, s) && $76e4bb4b0df9e886$var$O(a, s, t[s]);
    if ($76e4bb4b0df9e886$var$y) for (var s of $76e4bb4b0df9e886$var$y(t))$76e4bb4b0df9e886$var$Q.call(t, s) && $76e4bb4b0df9e886$var$O(a, s, t[s]);
    return a;
}, $76e4bb4b0df9e886$var$M = (a, t)=>$76e4bb4b0df9e886$var$q(a, $76e4bb4b0df9e886$var$D(t));
function $76e4bb4b0df9e886$var$g(a) {
    return Number(a[0].split(":")[1]);
}
function $76e4bb4b0df9e886$var$f(a) {
    return `0x${a.toString(16)}`;
}
function $76e4bb4b0df9e886$var$L(a) {
    const { chains: t, optionalChains: s, methods: i, optionalMethods: n, events: e, optionalEvents: h, rpcMap: c } = a;
    if (!(0, $eeGmU.isValidArray)(t)) throw new Error("Invalid chains");
    const o = {
        chains: t,
        methods: i || $76e4bb4b0df9e886$export$cfec112b6d27bf,
        events: e || $76e4bb4b0df9e886$export$2c607e5ce12221af,
        rpcMap: $76e4bb4b0df9e886$var$p({}, t.length ? {
            [$76e4bb4b0df9e886$var$g(t)]: c[$76e4bb4b0df9e886$var$g(t)]
        } : {})
    }, r = e?.filter((l)=>!$76e4bb4b0df9e886$export$2c607e5ce12221af.includes(l)), d = i?.filter((l)=>!$76e4bb4b0df9e886$export$cfec112b6d27bf.includes(l));
    if (!s && !h && !n && !(r != null && r.length) && !(d != null && d.length)) return {
        required: t.length ? o : void 0
    };
    const C = r?.length && d?.length || !s, I = {
        chains: [
            ...new Set(C ? o.chains.concat(s || []) : s)
        ],
        methods: [
            ...new Set(o.methods.concat(n != null && n.length ? n : $76e4bb4b0df9e886$export$bc85197675500780))
        ],
        events: [
            ...new Set(o.events.concat(h != null && h.length ? h : $76e4bb4b0df9e886$export$1d352f96d67d51e6))
        ],
        rpcMap: c
    };
    return {
        required: t.length ? o : void 0,
        optional: s.length ? I : void 0
    };
}

class $76e4bb4b0df9e886$export$2e2bcd8739ae039 {
    constructor(){
        this.events = new (0, $7etJZ.EventEmitter), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $76e4bb4b0df9e886$var$$, this.on = (t, s)=>(this.events.on(t, s), this), this.once = (t, s)=>(this.events.once(t, s), this), this.removeListener = (t, s)=>(this.events.removeListener(t, s), this), this.off = (t, s)=>(this.events.off(t, s), this), this.parseAccount = (t)=>this.isCompatibleChainId(t) ? this.parseAccountId(t).address : t, this.signer = {}, this.rpc = {};
    }
    static async init(t) {
        const s = new $76e4bb4b0df9e886$export$2e2bcd8739ae039;
        return await s.initialize(t), s;
    }
    async request(t) {
        return await this.signer.request(t, this.formatChainId(this.chainId));
    }
    sendAsync(t, s) {
        this.signer.sendAsync(t, s, this.formatChainId(this.chainId));
    }
    get connected() {
        return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
    get connecting() {
        return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
    async enable() {
        return this.session || await this.connect(), await this.request({
            method: "eth_requestAccounts"
        });
    }
    async connect(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts(t);
        const { required: s, optional: i } = $76e4bb4b0df9e886$var$L(this.rpc);
        try {
            const n = await new Promise(async (h, c)=>{
                var o;
                this.rpc.showQrModal && ((o = this.modal) == null || o.subscribeModal((r)=>{
                    !r.open && !this.signer.session && (this.signer.abortPairingAttempt(), c(new Error("Connection request reset. Please try again.")));
                })), await this.signer.connect($76e4bb4b0df9e886$var$M($76e4bb4b0df9e886$var$p({
                    namespaces: $76e4bb4b0df9e886$var$p({}, s && {
                        [this.namespace]: s
                    })
                }, i && {
                    optionalNamespaces: {
                        [this.namespace]: i
                    }
                }), {
                    pairingTopic: t?.pairingTopic
                })).then((r)=>{
                    h(r);
                }).catch((r)=>{
                    c(new Error(r.message));
                });
            });
            if (!n) return;
            const e = (0, $eeGmU.getAccountsFromNamespaces)(n.namespaces, [
                this.namespace
            ]);
            this.setChainIds(this.rpc.chains.length ? this.rpc.chains : e), this.setAccounts(e), this.events.emit("connect", {
                chainId: $76e4bb4b0df9e886$var$f(this.chainId)
            });
        } catch (n) {
            throw this.signer.logger.error(n), n;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async disconnect() {
        this.session && await this.signer.disconnect(), this.reset();
    }
    get isWalletConnect() {
        return !0;
    }
    get session() {
        return this.signer.session;
    }
    registerEventListeners() {
        this.signer.on("session_event", (t)=>{
            const { params: s } = t, { event: i } = s;
            i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", t);
        }), this.signer.on("chainChanged", (t)=>{
            const s = parseInt(t);
            this.chainId = s, this.events.emit("chainChanged", $76e4bb4b0df9e886$var$f(this.chainId)), this.persist();
        }), this.signer.on("session_update", (t)=>{
            this.events.emit("session_update", t);
        }), this.signer.on("session_delete", (t)=>{
            this.reset(), this.events.emit("session_delete", t), this.events.emit("disconnect", $76e4bb4b0df9e886$var$M($76e4bb4b0df9e886$var$p({}, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), {
                data: t.topic,
                name: "USER_DISCONNECTED"
            }));
        }), this.signer.on("display_uri", (t)=>{
            var s, i;
            this.rpc.showQrModal && ((s = this.modal) == null || s.closeModal(), (i = this.modal) == null || i.openModal({
                uri: t
            })), this.events.emit("display_uri", t);
        });
    }
    switchEthereumChain(t) {
        this.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: t.toString(16)
                }
            ]
        });
    }
    isCompatibleChainId(t) {
        return typeof t == "string" ? t.startsWith(`${this.namespace}:`) : !1;
    }
    formatChainId(t) {
        return `${this.namespace}:${t}`;
    }
    parseChainId(t) {
        return Number(t.split(":")[1]);
    }
    setChainIds(t) {
        const s = t.filter((i)=>this.isCompatibleChainId(i)).map((i)=>this.parseChainId(i));
        s.length && (this.chainId = s[0], this.events.emit("chainChanged", $76e4bb4b0df9e886$var$f(this.chainId)), this.persist());
    }
    setChainId(t) {
        if (this.isCompatibleChainId(t)) {
            const s = this.parseChainId(t);
            this.chainId = s, this.switchEthereumChain(s);
        }
    }
    parseAccountId(t) {
        const [s, i, n] = t.split(":");
        return {
            chainId: `${s}:${i}`,
            address: n
        };
    }
    setAccounts(t) {
        this.accounts = t.filter((s)=>this.parseChainId(this.parseAccountId(s).chainId) === this.chainId).map((s)=>this.parseAccountId(s).address), this.events.emit("accountsChanged", this.accounts);
    }
    getRpcConfig(t) {
        var s, i;
        const n = (s = t?.chains) != null ? s : [], e = (i = t?.optionalChains) != null ? i : [], h = n.concat(e);
        if (!h.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
        const c = n.length ? t?.methods || $76e4bb4b0df9e886$export$cfec112b6d27bf : [], o = n.length ? t?.events || $76e4bb4b0df9e886$export$2c607e5ce12221af : [], r = t?.optionalMethods || [], d = t?.optionalEvents || [], C = t?.rpcMap || this.buildRpcMap(h, t.projectId), I = t?.qrModalOptions || void 0;
        return {
            chains: n?.map((l)=>this.formatChainId(l)),
            optionalChains: e.map((l)=>this.formatChainId(l)),
            methods: c,
            events: o,
            optionalMethods: r,
            optionalEvents: d,
            rpcMap: C,
            showQrModal: !!(t != null && t.showQrModal),
            qrModalOptions: I,
            projectId: t.projectId,
            metadata: t.metadata
        };
    }
    buildRpcMap(t, s) {
        const i = {};
        return t.forEach((n)=>{
            i[n] = this.getRpcUrl(n, s);
        }), i;
    }
    async initialize(t) {
        if (this.rpc = this.getRpcConfig(t), this.chainId = this.rpc.chains.length ? $76e4bb4b0df9e886$var$g(this.rpc.chains) : $76e4bb4b0df9e886$var$g(this.rpc.optionalChains), this.signer = await (0, $3ch2e.UniversalProvider).init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: t.disableProviderPing,
            relayUrl: t.relayUrl,
            storageOptions: t.storageOptions
        }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
            let s;
            try {
                const { WalletConnectModal: i } = await (parcelRequire("yQvku"));
                s = i;
            } catch  {
                throw new Error("To use QR modal, please install @walletconnect/modal package");
            }
            if (s) try {
                this.modal = new s($76e4bb4b0df9e886$var$p({
                    walletConnectVersion: 2,
                    projectId: this.rpc.projectId,
                    standaloneChains: this.rpc.chains
                }, this.rpc.qrModalOptions));
            } catch (i) {
                throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
            }
        }
    }
    loadConnectOpts(t) {
        if (!t) return;
        const { chains: s, optionalChains: i, rpcMap: n } = t;
        s && (0, $eeGmU.isValidArray)(s) && (this.rpc.chains = s.map((e)=>this.formatChainId(e)), s.forEach((e)=>{
            this.rpc.rpcMap[e] = n?.[e] || this.getRpcUrl(e);
        })), i && (0, $eeGmU.isValidArray)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i?.map((e)=>this.formatChainId(e)), i.forEach((e)=>{
            this.rpc.rpcMap[e] = n?.[e] || this.getRpcUrl(e);
        }));
    }
    getRpcUrl(t, s) {
        var i;
        return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || `${$76e4bb4b0df9e886$var$j}?chainId=eip155:${t}&projectId=${s || this.rpc.projectId}`;
    }
    async loadPersistedSession() {
        if (!this.session) return;
        const t = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), s = this.session.namespaces[`${this.namespace}:${t}`] ? this.session.namespaces[`${this.namespace}:${t}`] : this.session.namespaces[this.namespace];
        this.setChainIds(t ? [
            this.formatChainId(t)
        ] : s?.accounts), this.setAccounts(s?.accounts);
    }
    reset() {
        this.chainId = 1, this.accounts = [];
    }
    persist() {
        this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
    }
    parseAccounts(t) {
        return typeof t == "string" || t instanceof String ? [
            this.parseAccount(t)
        ] : t.map((s)=>this.parseAccount(s));
    }
}
const $76e4bb4b0df9e886$export$cdfbbad9b2980226 = $76e4bb4b0df9e886$export$2e2bcd8739ae039;

});
parcelRequire.register("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("3ch2e", function(module, exports) {

$parcel$export(module.exports, "UniversalProvider", () => $253fb4de41dc743b$export$63bc40680ab52599);

var $6nnA0 = parcelRequire("6nnA0");

var $eeGmU = parcelRequire("eeGmU");

var $aY1FL = parcelRequire("aY1FL");

var $dHHSL = parcelRequire("dHHSL");
var $iIS2Z = parcelRequire("iIS2Z");
parcelRequire("7q0i6");
var $1QugC = parcelRequire("1QugC");

var $7etJZ = parcelRequire("7etJZ");
const $253fb4de41dc743b$var$Ia = "error", $253fb4de41dc743b$var$Ug = "wss://relay.walletconnect.com", $253fb4de41dc743b$var$Wg = "wc", $253fb4de41dc743b$var$Fg = "universal_provider", $253fb4de41dc743b$var$xa = `${$253fb4de41dc743b$var$Wg}@2:${$253fb4de41dc743b$var$Fg}:`, $253fb4de41dc743b$var$Mg = "https://rpc.walletconnect.com/v1/", $253fb4de41dc743b$var$at = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
var $253fb4de41dc743b$var$ge = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $253fb4de41dc743b$var$Ui = {
    exports: {}
}; /**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
(function(C, u) {
    (function() {
        var i, d = "4.17.21", w = 200, T = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", U = "Expected a function", En = "Invalid `variable` option passed into `_.template`", zt = "__lodash_hash_undefined__", pr = 500, At = "__lodash_placeholder__", Ln = 1, Fn = 2, Ct = 4, It = 1, ve = 2, vn = 1, ot = 2, qi = 4, Dn = 8, xt = 16, Nn = 32, Et = 64, Mn = 128, Kt = 256, dr = 512, La = 30, Da = "...", Na = 800, Ha = 16, Bi = 1, $a = 2, Ua = 3, ft = 1 / 0, Vn = 9007199254740991, Wa = 17976931348623157e292, _e = 0 / 0, Hn = 4294967295, Fa = Hn - 1, Ma = Hn >>> 1, qa = [
            [
                "ary",
                Mn
            ],
            [
                "bind",
                vn
            ],
            [
                "bindKey",
                ot
            ],
            [
                "curry",
                Dn
            ],
            [
                "curryRight",
                xt
            ],
            [
                "flip",
                dr
            ],
            [
                "partial",
                Nn
            ],
            [
                "partialRight",
                Et
            ],
            [
                "rearg",
                Kt
            ]
        ], yt = "[object Arguments]", me = "[object Array]", Ba = "[object AsyncFunction]", Yt = "[object Boolean]", Zt = "[object Date]", Ga = "[object DOMException]", we = "[object Error]", Pe = "[object Function]", Gi = "[object GeneratorFunction]", yn = "[object Map]", Jt = "[object Number]", za = "[object Null]", qn = "[object Object]", zi = "[object Promise]", Ka = "[object Proxy]", Xt = "[object RegExp]", Sn = "[object Set]", Qt = "[object String]", Ae = "[object Symbol]", Ya = "[object Undefined]", Vt = "[object WeakMap]", Za = "[object WeakSet]", kt = "[object ArrayBuffer]", St = "[object DataView]", gr = "[object Float32Array]", vr = "[object Float64Array]", _r = "[object Int8Array]", mr = "[object Int16Array]", wr = "[object Int32Array]", Pr = "[object Uint8Array]", Ar = "[object Uint8ClampedArray]", Cr = "[object Uint16Array]", Ir = "[object Uint32Array]", Ja = /\b__p \+= '';/g, Xa = /\b(__p \+=) '' \+/g, Qa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ki = /&(?:amp|lt|gt|quot|#39);/g, Yi = /[&<>"']/g, Va = RegExp(Ki.source), ka = RegExp(Yi.source), ja = /<%-([\s\S]+?)%>/g, no = /<%([\s\S]+?)%>/g, Zi = /<%=([\s\S]+?)%>/g, to = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, eo = /^\w*$/, ro = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, xr = /[\\^$.*+?()[\]{}|]/g, io = RegExp(xr.source), Er = /^\s+/, so = /\s/, uo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ao = /\{\n\/\* \[wrapped with (.+)\] \*/, oo = /,? & /, fo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, co = /[()=,{}\[\]\/\s]/, ho = /\\(\\)?/g, lo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ji = /\w*$/, po = /^[-+]0x[0-9a-f]+$/i, go = /^0b[01]+$/i, vo = /^\[object .+?Constructor\]$/, _o = /^0o[0-7]+$/i, mo = /^(?:0|[1-9]\d*)$/, wo = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ce = /($^)/, Po = /['\n\r\u2028\u2029\\]/g, Ie = "\ud800-\udfff", Ao = "\\u0300-\\u036f", Co = "\\ufe20-\\ufe2f", Io = "\\u20d0-\\u20ff", Xi = Ao + Co + Io, Qi = "\\u2700-\\u27bf", Vi = "a-z\\xdf-\\xf6\\xf8-\\xff", xo = "\\xac\\xb1\\xd7\\xf7", Eo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", yo = "\\u2000-\\u206f", So = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ki = "A-Z\\xc0-\\xd6\\xd8-\\xde", ji = "\\ufe0e\\ufe0f", ns = xo + Eo + yo + So, yr = "['’]", Oo = "[" + Ie + "]", ts = "[" + ns + "]", xe = "[" + Xi + "]", es = "\\d+", Ro = "[" + Qi + "]", rs = "[" + Vi + "]", is = "[^" + Ie + ns + es + Qi + Vi + ki + "]", Sr = "\ud83c[\udffb-\udfff]", bo = "(?:" + xe + "|" + Sr + ")", ss = "[^" + Ie + "]", Or = "(?:\ud83c[\udde6-\uddff]){2}", Rr = "[\ud800-\udbff][\udc00-\udfff]", Ot = "[" + ki + "]", us = "\\u200d", as = "(?:" + rs + "|" + is + ")", To = "(?:" + Ot + "|" + is + ")", os = "(?:" + yr + "(?:d|ll|m|re|s|t|ve))?", fs = "(?:" + yr + "(?:D|LL|M|RE|S|T|VE))?", cs = bo + "?", hs = "[" + ji + "]?", Lo = "(?:" + us + "(?:" + [
            ss,
            Or,
            Rr
        ].join("|") + ")" + hs + cs + ")*", Do = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", No = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ls = hs + cs + Lo, Ho = "(?:" + [
            Ro,
            Or,
            Rr
        ].join("|") + ")" + ls, $o = "(?:" + [
            ss + xe + "?",
            xe,
            Or,
            Rr,
            Oo
        ].join("|") + ")", Uo = RegExp(yr, "g"), Wo = RegExp(xe, "g"), br = RegExp(Sr + "(?=" + Sr + ")|" + $o + ls, "g"), Fo = RegExp([
            Ot + "?" + rs + "+" + os + "(?=" + [
                ts,
                Ot,
                "$"
            ].join("|") + ")",
            To + "+" + fs + "(?=" + [
                ts,
                Ot + as,
                "$"
            ].join("|") + ")",
            Ot + "?" + as + "+" + os,
            Ot + "+" + fs,
            No,
            Do,
            es,
            Ho
        ].join("|"), "g"), Mo = RegExp("[" + us + Ie + Xi + ji + "]"), qo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Bo = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Go = -1, B = {};
        B[gr] = B[vr] = B[_r] = B[mr] = B[wr] = B[Pr] = B[Ar] = B[Cr] = B[Ir] = !0, B[yt] = B[me] = B[kt] = B[Yt] = B[St] = B[Zt] = B[we] = B[Pe] = B[yn] = B[Jt] = B[qn] = B[Xt] = B[Sn] = B[Qt] = B[Vt] = !1;
        var q = {};
        q[yt] = q[me] = q[kt] = q[St] = q[Yt] = q[Zt] = q[gr] = q[vr] = q[_r] = q[mr] = q[wr] = q[yn] = q[Jt] = q[qn] = q[Xt] = q[Sn] = q[Qt] = q[Ae] = q[Pr] = q[Ar] = q[Cr] = q[Ir] = !0, q[we] = q[Pe] = q[Vt] = !1;
        var zo = {
            À: "A",
            Á: "A",
            Â: "A",
            Ã: "A",
            Ä: "A",
            Å: "A",
            à: "a",
            á: "a",
            â: "a",
            ã: "a",
            ä: "a",
            å: "a",
            Ç: "C",
            ç: "c",
            Ð: "D",
            ð: "d",
            È: "E",
            É: "E",
            Ê: "E",
            Ë: "E",
            è: "e",
            é: "e",
            ê: "e",
            ë: "e",
            Ì: "I",
            Í: "I",
            Î: "I",
            Ï: "I",
            ì: "i",
            í: "i",
            î: "i",
            ï: "i",
            Ñ: "N",
            ñ: "n",
            Ò: "O",
            Ó: "O",
            Ô: "O",
            Õ: "O",
            Ö: "O",
            Ø: "O",
            ò: "o",
            ó: "o",
            ô: "o",
            õ: "o",
            ö: "o",
            ø: "o",
            Ù: "U",
            Ú: "U",
            Û: "U",
            Ü: "U",
            ù: "u",
            ú: "u",
            û: "u",
            ü: "u",
            Ý: "Y",
            ý: "y",
            ÿ: "y",
            Æ: "Ae",
            æ: "ae",
            Þ: "Th",
            þ: "th",
            ß: "ss",
            Ā: "A",
            Ă: "A",
            Ą: "A",
            ā: "a",
            ă: "a",
            ą: "a",
            Ć: "C",
            Ĉ: "C",
            Ċ: "C",
            Č: "C",
            ć: "c",
            ĉ: "c",
            ċ: "c",
            č: "c",
            Ď: "D",
            Đ: "D",
            ď: "d",
            đ: "d",
            Ē: "E",
            Ĕ: "E",
            Ė: "E",
            Ę: "E",
            Ě: "E",
            ē: "e",
            ĕ: "e",
            ė: "e",
            ę: "e",
            ě: "e",
            Ĝ: "G",
            Ğ: "G",
            Ġ: "G",
            Ģ: "G",
            ĝ: "g",
            ğ: "g",
            ġ: "g",
            ģ: "g",
            Ĥ: "H",
            Ħ: "H",
            ĥ: "h",
            ħ: "h",
            Ĩ: "I",
            Ī: "I",
            Ĭ: "I",
            Į: "I",
            İ: "I",
            ĩ: "i",
            ī: "i",
            ĭ: "i",
            į: "i",
            ı: "i",
            Ĵ: "J",
            ĵ: "j",
            Ķ: "K",
            ķ: "k",
            ĸ: "k",
            Ĺ: "L",
            Ļ: "L",
            Ľ: "L",
            Ŀ: "L",
            Ł: "L",
            ĺ: "l",
            ļ: "l",
            ľ: "l",
            ŀ: "l",
            ł: "l",
            Ń: "N",
            Ņ: "N",
            Ň: "N",
            Ŋ: "N",
            ń: "n",
            ņ: "n",
            ň: "n",
            ŋ: "n",
            Ō: "O",
            Ŏ: "O",
            Ő: "O",
            ō: "o",
            ŏ: "o",
            ő: "o",
            Ŕ: "R",
            Ŗ: "R",
            Ř: "R",
            ŕ: "r",
            ŗ: "r",
            ř: "r",
            Ś: "S",
            Ŝ: "S",
            Ş: "S",
            Š: "S",
            ś: "s",
            ŝ: "s",
            ş: "s",
            š: "s",
            Ţ: "T",
            Ť: "T",
            Ŧ: "T",
            ţ: "t",
            ť: "t",
            ŧ: "t",
            Ũ: "U",
            Ū: "U",
            Ŭ: "U",
            Ů: "U",
            Ű: "U",
            Ų: "U",
            ũ: "u",
            ū: "u",
            ŭ: "u",
            ů: "u",
            ű: "u",
            ų: "u",
            Ŵ: "W",
            ŵ: "w",
            Ŷ: "Y",
            ŷ: "y",
            Ÿ: "Y",
            Ź: "Z",
            Ż: "Z",
            Ž: "Z",
            ź: "z",
            ż: "z",
            ž: "z",
            Ĳ: "IJ",
            ĳ: "ij",
            Œ: "Oe",
            œ: "oe",
            ŉ: "'n",
            ſ: "s"
        }, Ko = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, Yo = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, Zo = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, Jo = parseFloat, Xo = parseInt, ps = typeof $253fb4de41dc743b$var$ge == "object" && $253fb4de41dc743b$var$ge && $253fb4de41dc743b$var$ge.Object === Object && $253fb4de41dc743b$var$ge, Qo = typeof self == "object" && self && self.Object === Object && self, k = ps || Qo || Function("return this")(), Tr = u && !u.nodeType && u, ct = Tr && !0 && C && !C.nodeType && C, ds = ct && ct.exports === Tr, Lr = ds && ps.process, _n = function() {
            try {
                var h = ct && ct.require && ct.require("util").types;
                return h || Lr && Lr.binding && Lr.binding("util");
            } catch  {}
        }(), gs = _n && _n.isArrayBuffer, vs = _n && _n.isDate, _s = _n && _n.isMap, ms = _n && _n.isRegExp, ws = _n && _n.isSet, Ps = _n && _n.isTypedArray;
        function cn(h, g, p) {
            switch(p.length){
                case 0:
                    return h.call(g);
                case 1:
                    return h.call(g, p[0]);
                case 2:
                    return h.call(g, p[0], p[1]);
                case 3:
                    return h.call(g, p[0], p[1], p[2]);
            }
            return h.apply(g, p);
        }
        function Vo(h, g, p, A) {
            for(var S = -1, $ = h == null ? 0 : h.length; ++S < $;){
                var X = h[S];
                g(A, X, p(X), h);
            }
            return A;
        }
        function mn(h, g) {
            for(var p = -1, A = h == null ? 0 : h.length; ++p < A && g(h[p], p, h) !== !1;);
            return h;
        }
        function ko(h, g) {
            for(var p = h == null ? 0 : h.length; p-- && g(h[p], p, h) !== !1;);
            return h;
        }
        function As(h, g) {
            for(var p = -1, A = h == null ? 0 : h.length; ++p < A;)if (!g(h[p], p, h)) return !1;
            return !0;
        }
        function kn(h, g) {
            for(var p = -1, A = h == null ? 0 : h.length, S = 0, $ = []; ++p < A;){
                var X = h[p];
                g(X, p, h) && ($[S++] = X);
            }
            return $;
        }
        function Ee(h, g) {
            var p = h == null ? 0 : h.length;
            return !!p && Rt(h, g, 0) > -1;
        }
        function Dr(h, g, p) {
            for(var A = -1, S = h == null ? 0 : h.length; ++A < S;)if (p(g, h[A])) return !0;
            return !1;
        }
        function G(h, g) {
            for(var p = -1, A = h == null ? 0 : h.length, S = Array(A); ++p < A;)S[p] = g(h[p], p, h);
            return S;
        }
        function jn(h, g) {
            for(var p = -1, A = g.length, S = h.length; ++p < A;)h[S + p] = g[p];
            return h;
        }
        function Nr(h, g, p, A) {
            var S = -1, $ = h == null ? 0 : h.length;
            for(A && $ && (p = h[++S]); ++S < $;)p = g(p, h[S], S, h);
            return p;
        }
        function jo(h, g, p, A) {
            var S = h == null ? 0 : h.length;
            for(A && S && (p = h[--S]); S--;)p = g(p, h[S], S, h);
            return p;
        }
        function Hr(h, g) {
            for(var p = -1, A = h == null ? 0 : h.length; ++p < A;)if (g(h[p], p, h)) return !0;
            return !1;
        }
        var nf = $r("length");
        function tf(h) {
            return h.split("");
        }
        function ef(h) {
            return h.match(fo) || [];
        }
        function Cs(h, g, p) {
            var A;
            return p(h, function(S, $, X) {
                if (g(S, $, X)) return A = $, !1;
            }), A;
        }
        function ye(h, g, p, A) {
            for(var S = h.length, $ = p + (A ? 1 : -1); A ? $-- : ++$ < S;)if (g(h[$], $, h)) return $;
            return -1;
        }
        function Rt(h, g, p) {
            return g === g ? gf(h, g, p) : ye(h, Is, p);
        }
        function rf(h, g, p, A) {
            for(var S = p - 1, $ = h.length; ++S < $;)if (A(h[S], g)) return S;
            return -1;
        }
        function Is(h) {
            return h !== h;
        }
        function xs(h, g) {
            var p = h == null ? 0 : h.length;
            return p ? Wr(h, g) / p : _e;
        }
        function $r(h) {
            return function(g) {
                return g == null ? i : g[h];
            };
        }
        function Ur(h) {
            return function(g) {
                return h == null ? i : h[g];
            };
        }
        function Es(h, g, p, A, S) {
            return S(h, function($, X, M) {
                p = A ? (A = !1, $) : g(p, $, X, M);
            }), p;
        }
        function sf(h, g) {
            var p = h.length;
            for(h.sort(g); p--;)h[p] = h[p].value;
            return h;
        }
        function Wr(h, g) {
            for(var p, A = -1, S = h.length; ++A < S;){
                var $ = g(h[A]);
                $ !== i && (p = p === i ? $ : p + $);
            }
            return p;
        }
        function Fr(h, g) {
            for(var p = -1, A = Array(h); ++p < h;)A[p] = g(p);
            return A;
        }
        function uf(h, g) {
            return G(g, function(p) {
                return [
                    p,
                    h[p]
                ];
            });
        }
        function ys(h) {
            return h && h.slice(0, bs(h) + 1).replace(Er, "");
        }
        function hn(h) {
            return function(g) {
                return h(g);
            };
        }
        function Mr(h, g) {
            return G(g, function(p) {
                return h[p];
            });
        }
        function jt(h, g) {
            return h.has(g);
        }
        function Ss(h, g) {
            for(var p = -1, A = h.length; ++p < A && Rt(g, h[p], 0) > -1;);
            return p;
        }
        function Os(h, g) {
            for(var p = h.length; p-- && Rt(g, h[p], 0) > -1;);
            return p;
        }
        function af(h, g) {
            for(var p = h.length, A = 0; p--;)h[p] === g && ++A;
            return A;
        }
        var of = Ur(zo), ff = Ur(Ko);
        function cf(h) {
            return "\\" + Zo[h];
        }
        function hf(h, g) {
            return h == null ? i : h[g];
        }
        function bt(h) {
            return Mo.test(h);
        }
        function lf(h) {
            return qo.test(h);
        }
        function pf(h) {
            for(var g, p = []; !(g = h.next()).done;)p.push(g.value);
            return p;
        }
        function qr(h) {
            var g = -1, p = Array(h.size);
            return h.forEach(function(A, S) {
                p[++g] = [
                    S,
                    A
                ];
            }), p;
        }
        function Rs(h, g) {
            return function(p) {
                return h(g(p));
            };
        }
        function nt(h, g) {
            for(var p = -1, A = h.length, S = 0, $ = []; ++p < A;){
                var X = h[p];
                (X === g || X === At) && (h[p] = At, $[S++] = p);
            }
            return $;
        }
        function Se(h) {
            var g = -1, p = Array(h.size);
            return h.forEach(function(A) {
                p[++g] = A;
            }), p;
        }
        function df(h) {
            var g = -1, p = Array(h.size);
            return h.forEach(function(A) {
                p[++g] = [
                    A,
                    A
                ];
            }), p;
        }
        function gf(h, g, p) {
            for(var A = p - 1, S = h.length; ++A < S;)if (h[A] === g) return A;
            return -1;
        }
        function vf(h, g, p) {
            for(var A = p + 1; A--;)if (h[A] === g) return A;
            return A;
        }
        function Tt(h) {
            return bt(h) ? mf(h) : nf(h);
        }
        function On(h) {
            return bt(h) ? wf(h) : tf(h);
        }
        function bs(h) {
            for(var g = h.length; g-- && so.test(h.charAt(g)););
            return g;
        }
        var _f = Ur(Yo);
        function mf(h) {
            for(var g = br.lastIndex = 0; br.test(h);)++g;
            return g;
        }
        function wf(h) {
            return h.match(br) || [];
        }
        function Pf(h) {
            return h.match(Fo) || [];
        }
        var Af = function h(g) {
            g = g == null ? k : Lt.defaults(k.Object(), g, Lt.pick(k, Bo));
            var p = g.Array, A = g.Date, S = g.Error, $ = g.Function, X = g.Math, M = g.Object, Br = g.RegExp, Cf = g.String, wn = g.TypeError, Oe = p.prototype, If = $.prototype, Dt = M.prototype, Re = g["__core-js_shared__"], be = If.toString, F = Dt.hasOwnProperty, xf = 0, Ts = function() {
                var n = /[^.]+$/.exec(Re && Re.keys && Re.keys.IE_PROTO || "");
                return n ? "Symbol(src)_1." + n : "";
            }(), Te = Dt.toString, Ef = be.call(M), yf = k._, Sf = Br("^" + be.call(F).replace(xr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Le = ds ? g.Buffer : i, tt = g.Symbol, De = g.Uint8Array, Ls = Le ? Le.allocUnsafe : i, Ne = Rs(M.getPrototypeOf, M), Ds = M.create, Ns = Dt.propertyIsEnumerable, He = Oe.splice, Hs = tt ? tt.isConcatSpreadable : i, ne = tt ? tt.iterator : i, ht = tt ? tt.toStringTag : i, $e = function() {
                try {
                    var n = vt(M, "defineProperty");
                    return n({}, "", {}), n;
                } catch  {}
            }(), Of = g.clearTimeout !== k.clearTimeout && g.clearTimeout, Rf = A && A.now !== k.Date.now && A.now, bf = g.setTimeout !== k.setTimeout && g.setTimeout, Ue = X.ceil, We = X.floor, Gr = M.getOwnPropertySymbols, Tf = Le ? Le.isBuffer : i, $s = g.isFinite, Lf = Oe.join, Df = Rs(M.keys, M), Q = X.max, nn = X.min, Nf = A.now, Hf = g.parseInt, Us = X.random, $f = Oe.reverse, zr = vt(g, "DataView"), te = vt(g, "Map"), Kr = vt(g, "Promise"), Nt = vt(g, "Set"), ee = vt(g, "WeakMap"), re = vt(M, "create"), Fe = ee && new ee, Ht = {}, Uf = _t(zr), Wf = _t(te), Ff = _t(Kr), Mf = _t(Nt), qf = _t(ee), Me = tt ? tt.prototype : i, ie = Me ? Me.valueOf : i, Ws = Me ? Me.toString : i;
            function a(n) {
                if (K(n) && !O(n) && !(n instanceof N)) {
                    if (n instanceof Pn) return n;
                    if (F.call(n, "__wrapped__")) return Fu(n);
                }
                return new Pn(n);
            }
            var $t = function() {
                function n() {}
                return function(t) {
                    if (!z(t)) return {};
                    if (Ds) return Ds(t);
                    n.prototype = t;
                    var e = new n;
                    return n.prototype = i, e;
                };
            }();
            function qe() {}
            function Pn(n, t) {
                this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = i;
            }
            a.templateSettings = {
                escape: ja,
                evaluate: no,
                interpolate: Zi,
                variable: "",
                imports: {
                    _: a
                }
            }, a.prototype = qe.prototype, a.prototype.constructor = a, Pn.prototype = $t(qe.prototype), Pn.prototype.constructor = Pn;
            function N(n) {
                this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Hn, this.__views__ = [];
            }
            function Bf() {
                var n = new N(this.__wrapped__);
                return n.__actions__ = un(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = un(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = un(this.__views__), n;
            }
            function Gf() {
                if (this.__filtered__) {
                    var n = new N(this);
                    n.__dir__ = -1, n.__filtered__ = !0;
                } else n = this.clone(), n.__dir__ *= -1;
                return n;
            }
            function zf() {
                var n = this.__wrapped__.value(), t = this.__dir__, e = O(n), r = t < 0, s = e ? n.length : 0, o = eh(0, s, this.__views__), f = o.start, c = o.end, l = c - f, v = r ? c : f - 1, _ = this.__iteratees__, m = _.length, P = 0, I = nn(l, this.__takeCount__);
                if (!e || !r && s == l && I == l) return ou(n, this.__actions__);
                var E = [];
                n: for(; l-- && P < I;){
                    v += t;
                    for(var b = -1, y = n[v]; ++b < m;){
                        var D = _[b], H = D.iteratee, dn = D.type, sn = H(y);
                        if (dn == $a) y = sn;
                        else if (!sn) {
                            if (dn == Bi) continue n;
                            break n;
                        }
                    }
                    E[P++] = y;
                }
                return E;
            }
            N.prototype = $t(qe.prototype), N.prototype.constructor = N;
            function lt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function Kf() {
                this.__data__ = re ? re(null) : {}, this.size = 0;
            }
            function Yf(n) {
                var t = this.has(n) && delete this.__data__[n];
                return this.size -= t ? 1 : 0, t;
            }
            function Zf(n) {
                var t = this.__data__;
                if (re) {
                    var e = t[n];
                    return e === zt ? i : e;
                }
                return F.call(t, n) ? t[n] : i;
            }
            function Jf(n) {
                var t = this.__data__;
                return re ? t[n] !== i : F.call(t, n);
            }
            function Xf(n, t) {
                var e = this.__data__;
                return this.size += this.has(n) ? 0 : 1, e[n] = re && t === i ? zt : t, this;
            }
            lt.prototype.clear = Kf, lt.prototype.delete = Yf, lt.prototype.get = Zf, lt.prototype.has = Jf, lt.prototype.set = Xf;
            function Bn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function Qf() {
                this.__data__ = [], this.size = 0;
            }
            function Vf(n) {
                var t = this.__data__, e = Be(t, n);
                if (e < 0) return !1;
                var r = t.length - 1;
                return e == r ? t.pop() : He.call(t, e, 1), --this.size, !0;
            }
            function kf(n) {
                var t = this.__data__, e = Be(t, n);
                return e < 0 ? i : t[e][1];
            }
            function jf(n) {
                return Be(this.__data__, n) > -1;
            }
            function nc(n, t) {
                var e = this.__data__, r = Be(e, n);
                return r < 0 ? (++this.size, e.push([
                    n,
                    t
                ])) : e[r][1] = t, this;
            }
            Bn.prototype.clear = Qf, Bn.prototype.delete = Vf, Bn.prototype.get = kf, Bn.prototype.has = jf, Bn.prototype.set = nc;
            function Gn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function tc() {
                this.size = 0, this.__data__ = {
                    hash: new lt,
                    map: new (te || Bn),
                    string: new lt
                };
            }
            function ec(n) {
                var t = nr(this, n).delete(n);
                return this.size -= t ? 1 : 0, t;
            }
            function rc(n) {
                return nr(this, n).get(n);
            }
            function ic(n) {
                return nr(this, n).has(n);
            }
            function sc(n, t) {
                var e = nr(this, n), r = e.size;
                return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
            }
            Gn.prototype.clear = tc, Gn.prototype.delete = ec, Gn.prototype.get = rc, Gn.prototype.has = ic, Gn.prototype.set = sc;
            function pt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.__data__ = new Gn; ++t < e;)this.add(n[t]);
            }
            function uc(n) {
                return this.__data__.set(n, zt), this;
            }
            function ac(n) {
                return this.__data__.has(n);
            }
            pt.prototype.add = pt.prototype.push = uc, pt.prototype.has = ac;
            function Rn(n) {
                var t = this.__data__ = new Bn(n);
                this.size = t.size;
            }
            function oc() {
                this.__data__ = new Bn, this.size = 0;
            }
            function fc(n) {
                var t = this.__data__, e = t.delete(n);
                return this.size = t.size, e;
            }
            function cc(n) {
                return this.__data__.get(n);
            }
            function hc(n) {
                return this.__data__.has(n);
            }
            function lc(n, t) {
                var e = this.__data__;
                if (e instanceof Bn) {
                    var r = e.__data__;
                    if (!te || r.length < w - 1) return r.push([
                        n,
                        t
                    ]), this.size = ++e.size, this;
                    e = this.__data__ = new Gn(r);
                }
                return e.set(n, t), this.size = e.size, this;
            }
            Rn.prototype.clear = oc, Rn.prototype.delete = fc, Rn.prototype.get = cc, Rn.prototype.has = hc, Rn.prototype.set = lc;
            function Fs(n, t) {
                var e = O(n), r = !e && mt(n), s = !e && !r && ut(n), o = !e && !r && !s && Mt(n), f = e || r || s || o, c = f ? Fr(n.length, Cf) : [], l = c.length;
                for(var v in n)(t || F.call(n, v)) && !(f && (v == "length" || s && (v == "offset" || v == "parent") || o && (v == "buffer" || v == "byteLength" || v == "byteOffset") || Zn(v, l))) && c.push(v);
                return c;
            }
            function Ms(n) {
                var t = n.length;
                return t ? n[ei(0, t - 1)] : i;
            }
            function pc(n, t) {
                return tr(un(n), dt(t, 0, n.length));
            }
            function dc(n) {
                return tr(un(n));
            }
            function Yr(n, t, e) {
                (e !== i && !bn(n[t], e) || e === i && !(t in n)) && zn(n, t, e);
            }
            function se(n, t, e) {
                var r = n[t];
                (!(F.call(n, t) && bn(r, e)) || e === i && !(t in n)) && zn(n, t, e);
            }
            function Be(n, t) {
                for(var e = n.length; e--;)if (bn(n[e][0], t)) return e;
                return -1;
            }
            function gc(n, t, e, r) {
                return et(n, function(s, o, f) {
                    t(r, s, e(s), f);
                }), r;
            }
            function qs(n, t) {
                return n && Un(t, V(t), n);
            }
            function vc(n, t) {
                return n && Un(t, on(t), n);
            }
            function zn(n, t, e) {
                t == "__proto__" && $e ? $e(n, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: e,
                    writable: !0
                }) : n[t] = e;
            }
            function Zr(n, t) {
                for(var e = -1, r = t.length, s = p(r), o = n == null; ++e < r;)s[e] = o ? i : Si(n, t[e]);
                return s;
            }
            function dt(n, t, e) {
                return n === n && (e !== i && (n = n <= e ? n : e), t !== i && (n = n >= t ? n : t)), n;
            }
            function An(n, t, e, r, s, o) {
                var f, c = t & Ln, l = t & Fn, v = t & Ct;
                if (e && (f = s ? e(n, r, s, o) : e(n)), f !== i) return f;
                if (!z(n)) return n;
                var _ = O(n);
                if (_) {
                    if (f = ih(n), !c) return un(n, f);
                } else {
                    var m = tn(n), P = m == Pe || m == Gi;
                    if (ut(n)) return hu(n, c);
                    if (m == qn || m == yt || P && !s) {
                        if (f = l || P ? {} : bu(n), !c) return l ? Zc(n, vc(f, n)) : Yc(n, qs(f, n));
                    } else {
                        if (!q[m]) return s ? n : {};
                        f = sh(n, m, c);
                    }
                }
                o || (o = new Rn);
                var I = o.get(n);
                if (I) return I;
                o.set(n, f), sa(n) ? n.forEach(function(y) {
                    f.add(An(y, t, e, y, n, o));
                }) : ra(n) && n.forEach(function(y, D) {
                    f.set(D, An(y, t, e, D, n, o));
                });
                var E = v ? l ? pi : li : l ? on : V, b = _ ? i : E(n);
                return mn(b || n, function(y, D) {
                    b && (D = y, y = n[D]), se(f, D, An(y, t, e, D, n, o));
                }), f;
            }
            function _c(n) {
                var t = V(n);
                return function(e) {
                    return Bs(e, n, t);
                };
            }
            function Bs(n, t, e) {
                var r = e.length;
                if (n == null) return !r;
                for(n = M(n); r--;){
                    var s = e[r], o = t[s], f = n[s];
                    if (f === i && !(s in n) || !o(f)) return !1;
                }
                return !0;
            }
            function Gs(n, t, e) {
                if (typeof n != "function") throw new wn(U);
                return le(function() {
                    n.apply(i, e);
                }, t);
            }
            function ue(n, t, e, r) {
                var s = -1, o = Ee, f = !0, c = n.length, l = [], v = t.length;
                if (!c) return l;
                e && (t = G(t, hn(e))), r ? (o = Dr, f = !1) : t.length >= w && (o = jt, f = !1, t = new pt(t));
                n: for(; ++s < c;){
                    var _ = n[s], m = e == null ? _ : e(_);
                    if (_ = r || _ !== 0 ? _ : 0, f && m === m) {
                        for(var P = v; P--;)if (t[P] === m) continue n;
                        l.push(_);
                    } else o(t, m, r) || l.push(_);
                }
                return l;
            }
            var et = vu($n), zs = vu(Xr, !0);
            function mc(n, t) {
                var e = !0;
                return et(n, function(r, s, o) {
                    return e = !!t(r, s, o), e;
                }), e;
            }
            function Ge(n, t, e) {
                for(var r = -1, s = n.length; ++r < s;){
                    var o = n[r], f = t(o);
                    if (f != null && (c === i ? f === f && !pn(f) : e(f, c))) var c = f, l = o;
                }
                return l;
            }
            function wc(n, t, e, r) {
                var s = n.length;
                for(e = R(e), e < 0 && (e = -e > s ? 0 : s + e), r = r === i || r > s ? s : R(r), r < 0 && (r += s), r = e > r ? 0 : aa(r); e < r;)n[e++] = t;
                return n;
            }
            function Ks(n, t) {
                var e = [];
                return et(n, function(r, s, o) {
                    t(r, s, o) && e.push(r);
                }), e;
            }
            function j(n, t, e, r, s) {
                var o = -1, f = n.length;
                for(e || (e = ah), s || (s = []); ++o < f;){
                    var c = n[o];
                    t > 0 && e(c) ? t > 1 ? j(c, t - 1, e, r, s) : jn(s, c) : r || (s[s.length] = c);
                }
                return s;
            }
            var Jr = _u(), Ys = _u(!0);
            function $n(n, t) {
                return n && Jr(n, t, V);
            }
            function Xr(n, t) {
                return n && Ys(n, t, V);
            }
            function ze(n, t) {
                return kn(t, function(e) {
                    return Jn(n[e]);
                });
            }
            function gt(n, t) {
                t = it(t, n);
                for(var e = 0, r = t.length; n != null && e < r;)n = n[Wn(t[e++])];
                return e && e == r ? n : i;
            }
            function Zs(n, t, e) {
                var r = t(n);
                return O(n) ? r : jn(r, e(n));
            }
            function en(n) {
                return n == null ? n === i ? Ya : za : ht && ht in M(n) ? th(n) : dh(n);
            }
            function Qr(n, t) {
                return n > t;
            }
            function Pc(n, t) {
                return n != null && F.call(n, t);
            }
            function Ac(n, t) {
                return n != null && t in M(n);
            }
            function Cc(n, t, e) {
                return n >= nn(t, e) && n < Q(t, e);
            }
            function Vr(n, t, e) {
                for(var r = e ? Dr : Ee, s = n[0].length, o = n.length, f = o, c = p(o), l = 1 / 0, v = []; f--;){
                    var _ = n[f];
                    f && t && (_ = G(_, hn(t))), l = nn(_.length, l), c[f] = !e && (t || s >= 120 && _.length >= 120) ? new pt(f && _) : i;
                }
                _ = n[0];
                var m = -1, P = c[0];
                n: for(; ++m < s && v.length < l;){
                    var I = _[m], E = t ? t(I) : I;
                    if (I = e || I !== 0 ? I : 0, !(P ? jt(P, E) : r(v, E, e))) {
                        for(f = o; --f;){
                            var b = c[f];
                            if (!(b ? jt(b, E) : r(n[f], E, e))) continue n;
                        }
                        P && P.push(E), v.push(I);
                    }
                }
                return v;
            }
            function Ic(n, t, e, r) {
                return $n(n, function(s, o, f) {
                    t(r, e(s), o, f);
                }), r;
            }
            function ae(n, t, e) {
                t = it(t, n), n = Nu(n, t);
                var r = n == null ? n : n[Wn(In(t))];
                return r == null ? i : cn(r, n, e);
            }
            function Js(n) {
                return K(n) && en(n) == yt;
            }
            function xc(n) {
                return K(n) && en(n) == kt;
            }
            function Ec(n) {
                return K(n) && en(n) == Zt;
            }
            function oe(n, t, e, r, s) {
                return n === t ? !0 : n == null || t == null || !K(n) && !K(t) ? n !== n && t !== t : yc(n, t, e, r, oe, s);
            }
            function yc(n, t, e, r, s, o) {
                var f = O(n), c = O(t), l = f ? me : tn(n), v = c ? me : tn(t);
                l = l == yt ? qn : l, v = v == yt ? qn : v;
                var _ = l == qn, m = v == qn, P = l == v;
                if (P && ut(n)) {
                    if (!ut(t)) return !1;
                    f = !0, _ = !1;
                }
                if (P && !_) return o || (o = new Rn), f || Mt(n) ? Su(n, t, e, r, s, o) : jc(n, t, l, e, r, s, o);
                if (!(e & It)) {
                    var I = _ && F.call(n, "__wrapped__"), E = m && F.call(t, "__wrapped__");
                    if (I || E) {
                        var b = I ? n.value() : n, y = E ? t.value() : t;
                        return o || (o = new Rn), s(b, y, e, r, o);
                    }
                }
                return P ? (o || (o = new Rn), nh(n, t, e, r, s, o)) : !1;
            }
            function Sc(n) {
                return K(n) && tn(n) == yn;
            }
            function kr(n, t, e, r) {
                var s = e.length, o = s, f = !r;
                if (n == null) return !o;
                for(n = M(n); s--;){
                    var c = e[s];
                    if (f && c[2] ? c[1] !== n[c[0]] : !(c[0] in n)) return !1;
                }
                for(; ++s < o;){
                    c = e[s];
                    var l = c[0], v = n[l], _ = c[1];
                    if (f && c[2]) {
                        if (v === i && !(l in n)) return !1;
                    } else {
                        var m = new Rn;
                        if (r) var P = r(v, _, l, n, t, m);
                        if (!(P === i ? oe(_, v, It | ve, r, m) : P)) return !1;
                    }
                }
                return !0;
            }
            function Xs(n) {
                if (!z(n) || fh(n)) return !1;
                var t = Jn(n) ? Sf : vo;
                return t.test(_t(n));
            }
            function Oc(n) {
                return K(n) && en(n) == Xt;
            }
            function Rc(n) {
                return K(n) && tn(n) == Sn;
            }
            function bc(n) {
                return K(n) && ar(n.length) && !!B[en(n)];
            }
            function Qs(n) {
                return typeof n == "function" ? n : n == null ? fn : typeof n == "object" ? O(n) ? js(n[0], n[1]) : ks(n) : ma(n);
            }
            function jr(n) {
                if (!he(n)) return Df(n);
                var t = [];
                for(var e in M(n))F.call(n, e) && e != "constructor" && t.push(e);
                return t;
            }
            function Tc(n) {
                if (!z(n)) return ph(n);
                var t = he(n), e = [];
                for(var r in n)r == "constructor" && (t || !F.call(n, r)) || e.push(r);
                return e;
            }
            function ni(n, t) {
                return n < t;
            }
            function Vs(n, t) {
                var e = -1, r = an(n) ? p(n.length) : [];
                return et(n, function(s, o, f) {
                    r[++e] = t(s, o, f);
                }), r;
            }
            function ks(n) {
                var t = gi(n);
                return t.length == 1 && t[0][2] ? Lu(t[0][0], t[0][1]) : function(e) {
                    return e === n || kr(e, n, t);
                };
            }
            function js(n, t) {
                return _i(n) && Tu(t) ? Lu(Wn(n), t) : function(e) {
                    var r = Si(e, n);
                    return r === i && r === t ? Oi(e, n) : oe(t, r, It | ve);
                };
            }
            function Ke(n, t, e, r, s) {
                n !== t && Jr(t, function(o, f) {
                    if (s || (s = new Rn), z(o)) Lc(n, t, f, e, Ke, r, s);
                    else {
                        var c = r ? r(wi(n, f), o, f + "", n, t, s) : i;
                        c === i && (c = o), Yr(n, f, c);
                    }
                }, on);
            }
            function Lc(n, t, e, r, s, o, f) {
                var c = wi(n, e), l = wi(t, e), v = f.get(l);
                if (v) {
                    Yr(n, e, v);
                    return;
                }
                var _ = o ? o(c, l, e + "", n, t, f) : i, m = _ === i;
                if (m) {
                    var P = O(l), I = !P && ut(l), E = !P && !I && Mt(l);
                    _ = l, P || I || E ? O(c) ? _ = c : Y(c) ? _ = un(c) : I ? (m = !1, _ = hu(l, !0)) : E ? (m = !1, _ = lu(l, !0)) : _ = [] : pe(l) || mt(l) ? (_ = c, mt(c) ? _ = oa(c) : (!z(c) || Jn(c)) && (_ = bu(l))) : m = !1;
                }
                m && (f.set(l, _), s(_, l, r, o, f), f.delete(l)), Yr(n, e, _);
            }
            function nu(n, t) {
                var e = n.length;
                if (e) return t += t < 0 ? e : 0, Zn(t, e) ? n[t] : i;
            }
            function tu(n, t, e) {
                t.length ? t = G(t, function(o) {
                    return O(o) ? function(f) {
                        return gt(f, o.length === 1 ? o[0] : o);
                    } : o;
                }) : t = [
                    fn
                ];
                var r = -1;
                t = G(t, hn(x()));
                var s = Vs(n, function(o, f, c) {
                    var l = G(t, function(v) {
                        return v(o);
                    });
                    return {
                        criteria: l,
                        index: ++r,
                        value: o
                    };
                });
                return sf(s, function(o, f) {
                    return Kc(o, f, e);
                });
            }
            function Dc(n, t) {
                return eu(n, t, function(e, r) {
                    return Oi(n, r);
                });
            }
            function eu(n, t, e) {
                for(var r = -1, s = t.length, o = {}; ++r < s;){
                    var f = t[r], c = gt(n, f);
                    e(c, f) && fe(o, it(f, n), c);
                }
                return o;
            }
            function Nc(n) {
                return function(t) {
                    return gt(t, n);
                };
            }
            function ti(n, t, e, r) {
                var s = r ? rf : Rt, o = -1, f = t.length, c = n;
                for(n === t && (t = un(t)), e && (c = G(n, hn(e))); ++o < f;)for(var l = 0, v = t[o], _ = e ? e(v) : v; (l = s(c, _, l, r)) > -1;)c !== n && He.call(c, l, 1), He.call(n, l, 1);
                return n;
            }
            function ru(n, t) {
                for(var e = n ? t.length : 0, r = e - 1; e--;){
                    var s = t[e];
                    if (e == r || s !== o) {
                        var o = s;
                        Zn(s) ? He.call(n, s, 1) : si(n, s);
                    }
                }
                return n;
            }
            function ei(n, t) {
                return n + We(Us() * (t - n + 1));
            }
            function Hc(n, t, e, r) {
                for(var s = -1, o = Q(Ue((t - n) / (e || 1)), 0), f = p(o); o--;)f[r ? o : ++s] = n, n += e;
                return f;
            }
            function ri(n, t) {
                var e = "";
                if (!n || t < 1 || t > Vn) return e;
                do t % 2 && (e += n), t = We(t / 2), t && (n += n);
                while (t);
                return e;
            }
            function L(n, t) {
                return Pi(Du(n, t, fn), n + "");
            }
            function $c(n) {
                return Ms(qt(n));
            }
            function Uc(n, t) {
                var e = qt(n);
                return tr(e, dt(t, 0, e.length));
            }
            function fe(n, t, e, r) {
                if (!z(n)) return n;
                t = it(t, n);
                for(var s = -1, o = t.length, f = o - 1, c = n; c != null && ++s < o;){
                    var l = Wn(t[s]), v = e;
                    if (l === "__proto__" || l === "constructor" || l === "prototype") return n;
                    if (s != f) {
                        var _ = c[l];
                        v = r ? r(_, l, c) : i, v === i && (v = z(_) ? _ : Zn(t[s + 1]) ? [] : {});
                    }
                    se(c, l, v), c = c[l];
                }
                return n;
            }
            var iu = Fe ? function(n, t) {
                return Fe.set(n, t), n;
            } : fn, Wc = $e ? function(n, t) {
                return $e(n, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: bi(t),
                    writable: !0
                });
            } : fn;
            function Fc(n) {
                return tr(qt(n));
            }
            function Cn(n, t, e) {
                var r = -1, s = n.length;
                t < 0 && (t = -t > s ? 0 : s + t), e = e > s ? s : e, e < 0 && (e += s), s = t > e ? 0 : e - t >>> 0, t >>>= 0;
                for(var o = p(s); ++r < s;)o[r] = n[r + t];
                return o;
            }
            function Mc(n, t) {
                var e;
                return et(n, function(r, s, o) {
                    return e = t(r, s, o), !e;
                }), !!e;
            }
            function Ye(n, t, e) {
                var r = 0, s = n == null ? r : n.length;
                if (typeof t == "number" && t === t && s <= Ma) {
                    for(; r < s;){
                        var o = r + s >>> 1, f = n[o];
                        f !== null && !pn(f) && (e ? f <= t : f < t) ? r = o + 1 : s = o;
                    }
                    return s;
                }
                return ii(n, t, fn, e);
            }
            function ii(n, t, e, r) {
                var s = 0, o = n == null ? 0 : n.length;
                if (o === 0) return 0;
                t = e(t);
                for(var f = t !== t, c = t === null, l = pn(t), v = t === i; s < o;){
                    var _ = We((s + o) / 2), m = e(n[_]), P = m !== i, I = m === null, E = m === m, b = pn(m);
                    if (f) var y = r || E;
                    else v ? y = E && (r || P) : c ? y = E && P && (r || !I) : l ? y = E && P && !I && (r || !b) : I || b ? y = !1 : y = r ? m <= t : m < t;
                    y ? s = _ + 1 : o = _;
                }
                return nn(o, Fa);
            }
            function su(n, t) {
                for(var e = -1, r = n.length, s = 0, o = []; ++e < r;){
                    var f = n[e], c = t ? t(f) : f;
                    if (!e || !bn(c, l)) {
                        var l = c;
                        o[s++] = f === 0 ? 0 : f;
                    }
                }
                return o;
            }
            function uu(n) {
                return typeof n == "number" ? n : pn(n) ? _e : +n;
            }
            function ln(n) {
                if (typeof n == "string") return n;
                if (O(n)) return G(n, ln) + "";
                if (pn(n)) return Ws ? Ws.call(n) : "";
                var t = n + "";
                return t == "0" && 1 / n == -ft ? "-0" : t;
            }
            function rt(n, t, e) {
                var r = -1, s = Ee, o = n.length, f = !0, c = [], l = c;
                if (e) f = !1, s = Dr;
                else if (o >= w) {
                    var v = t ? null : Vc(n);
                    if (v) return Se(v);
                    f = !1, s = jt, l = new pt;
                } else l = t ? [] : c;
                n: for(; ++r < o;){
                    var _ = n[r], m = t ? t(_) : _;
                    if (_ = e || _ !== 0 ? _ : 0, f && m === m) {
                        for(var P = l.length; P--;)if (l[P] === m) continue n;
                        t && l.push(m), c.push(_);
                    } else s(l, m, e) || (l !== c && l.push(m), c.push(_));
                }
                return c;
            }
            function si(n, t) {
                return t = it(t, n), n = Nu(n, t), n == null || delete n[Wn(In(t))];
            }
            function au(n, t, e, r) {
                return fe(n, t, e(gt(n, t)), r);
            }
            function Ze(n, t, e, r) {
                for(var s = n.length, o = r ? s : -1; (r ? o-- : ++o < s) && t(n[o], o, n););
                return e ? Cn(n, r ? 0 : o, r ? o + 1 : s) : Cn(n, r ? o + 1 : 0, r ? s : o);
            }
            function ou(n, t) {
                var e = n;
                return e instanceof N && (e = e.value()), Nr(t, function(r, s) {
                    return s.func.apply(s.thisArg, jn([
                        r
                    ], s.args));
                }, e);
            }
            function ui(n, t, e) {
                var r = n.length;
                if (r < 2) return r ? rt(n[0]) : [];
                for(var s = -1, o = p(r); ++s < r;)for(var f = n[s], c = -1; ++c < r;)c != s && (o[s] = ue(o[s] || f, n[c], t, e));
                return rt(j(o, 1), t, e);
            }
            function fu(n, t, e) {
                for(var r = -1, s = n.length, o = t.length, f = {}; ++r < s;){
                    var c = r < o ? t[r] : i;
                    e(f, n[r], c);
                }
                return f;
            }
            function ai(n) {
                return Y(n) ? n : [];
            }
            function oi(n) {
                return typeof n == "function" ? n : fn;
            }
            function it(n, t) {
                return O(n) ? n : _i(n, t) ? [
                    n
                ] : Wu(W(n));
            }
            var qc = L;
            function st(n, t, e) {
                var r = n.length;
                return e = e === i ? r : e, !t && e >= r ? n : Cn(n, t, e);
            }
            var cu = Of || function(n) {
                return k.clearTimeout(n);
            };
            function hu(n, t) {
                if (t) return n.slice();
                var e = n.length, r = Ls ? Ls(e) : new n.constructor(e);
                return n.copy(r), r;
            }
            function fi(n) {
                var t = new n.constructor(n.byteLength);
                return new De(t).set(new De(n)), t;
            }
            function Bc(n, t) {
                var e = t ? fi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.byteLength);
            }
            function Gc(n) {
                var t = new n.constructor(n.source, Ji.exec(n));
                return t.lastIndex = n.lastIndex, t;
            }
            function zc(n) {
                return ie ? M(ie.call(n)) : {};
            }
            function lu(n, t) {
                var e = t ? fi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.length);
            }
            function pu(n, t) {
                if (n !== t) {
                    var e = n !== i, r = n === null, s = n === n, o = pn(n), f = t !== i, c = t === null, l = t === t, v = pn(t);
                    if (!c && !v && !o && n > t || o && f && l && !c && !v || r && f && l || !e && l || !s) return 1;
                    if (!r && !o && !v && n < t || v && e && s && !r && !o || c && e && s || !f && s || !l) return -1;
                }
                return 0;
            }
            function Kc(n, t, e) {
                for(var r = -1, s = n.criteria, o = t.criteria, f = s.length, c = e.length; ++r < f;){
                    var l = pu(s[r], o[r]);
                    if (l) {
                        if (r >= c) return l;
                        var v = e[r];
                        return l * (v == "desc" ? -1 : 1);
                    }
                }
                return n.index - t.index;
            }
            function du(n, t, e, r) {
                for(var s = -1, o = n.length, f = e.length, c = -1, l = t.length, v = Q(o - f, 0), _ = p(l + v), m = !r; ++c < l;)_[c] = t[c];
                for(; ++s < f;)(m || s < o) && (_[e[s]] = n[s]);
                for(; v--;)_[c++] = n[s++];
                return _;
            }
            function gu(n, t, e, r) {
                for(var s = -1, o = n.length, f = -1, c = e.length, l = -1, v = t.length, _ = Q(o - c, 0), m = p(_ + v), P = !r; ++s < _;)m[s] = n[s];
                for(var I = s; ++l < v;)m[I + l] = t[l];
                for(; ++f < c;)(P || s < o) && (m[I + e[f]] = n[s++]);
                return m;
            }
            function un(n, t) {
                var e = -1, r = n.length;
                for(t || (t = p(r)); ++e < r;)t[e] = n[e];
                return t;
            }
            function Un(n, t, e, r) {
                var s = !e;
                e || (e = {});
                for(var o = -1, f = t.length; ++o < f;){
                    var c = t[o], l = r ? r(e[c], n[c], c, e, n) : i;
                    l === i && (l = n[c]), s ? zn(e, c, l) : se(e, c, l);
                }
                return e;
            }
            function Yc(n, t) {
                return Un(n, vi(n), t);
            }
            function Zc(n, t) {
                return Un(n, Ou(n), t);
            }
            function Je(n, t) {
                return function(e, r) {
                    var s = O(e) ? Vo : gc, o = t ? t() : {};
                    return s(e, n, x(r, 2), o);
                };
            }
            function Ut(n) {
                return L(function(t, e) {
                    var r = -1, s = e.length, o = s > 1 ? e[s - 1] : i, f = s > 2 ? e[2] : i;
                    for(o = n.length > 3 && typeof o == "function" ? (s--, o) : i, f && rn(e[0], e[1], f) && (o = s < 3 ? i : o, s = 1), t = M(t); ++r < s;){
                        var c = e[r];
                        c && n(t, c, r, o);
                    }
                    return t;
                });
            }
            function vu(n, t) {
                return function(e, r) {
                    if (e == null) return e;
                    if (!an(e)) return n(e, r);
                    for(var s = e.length, o = t ? s : -1, f = M(e); (t ? o-- : ++o < s) && r(f[o], o, f) !== !1;);
                    return e;
                };
            }
            function _u(n) {
                return function(t, e, r) {
                    for(var s = -1, o = M(t), f = r(t), c = f.length; c--;){
                        var l = f[n ? c : ++s];
                        if (e(o[l], l, o) === !1) break;
                    }
                    return t;
                };
            }
            function Jc(n, t, e) {
                var r = t & vn, s = ce(n);
                function o() {
                    var f = this && this !== k && this instanceof o ? s : n;
                    return f.apply(r ? e : this, arguments);
                }
                return o;
            }
            function mu(n) {
                return function(t) {
                    t = W(t);
                    var e = bt(t) ? On(t) : i, r = e ? e[0] : t.charAt(0), s = e ? st(e, 1).join("") : t.slice(1);
                    return r[n]() + s;
                };
            }
            function Wt(n) {
                return function(t) {
                    return Nr(va(ga(t).replace(Uo, "")), n, "");
                };
            }
            function ce(n) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new n;
                        case 1:
                            return new n(t[0]);
                        case 2:
                            return new n(t[0], t[1]);
                        case 3:
                            return new n(t[0], t[1], t[2]);
                        case 4:
                            return new n(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new n(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var e = $t(n.prototype), r = n.apply(e, t);
                    return z(r) ? r : e;
                };
            }
            function Xc(n, t, e) {
                var r = ce(n);
                function s() {
                    for(var o = arguments.length, f = p(o), c = o, l = Ft(s); c--;)f[c] = arguments[c];
                    var v = o < 3 && f[0] !== l && f[o - 1] !== l ? [] : nt(f, l);
                    if (o -= v.length, o < e) return Iu(n, t, Xe, s.placeholder, i, f, v, i, i, e - o);
                    var _ = this && this !== k && this instanceof s ? r : n;
                    return cn(_, this, f);
                }
                return s;
            }
            function wu(n) {
                return function(t, e, r) {
                    var s = M(t);
                    if (!an(t)) {
                        var o = x(e, 3);
                        t = V(t), e = function(c) {
                            return o(s[c], c, s);
                        };
                    }
                    var f = n(t, e, r);
                    return f > -1 ? s[o ? t[f] : f] : i;
                };
            }
            function Pu(n) {
                return Yn(function(t) {
                    var e = t.length, r = e, s = Pn.prototype.thru;
                    for(n && t.reverse(); r--;){
                        var o = t[r];
                        if (typeof o != "function") throw new wn(U);
                        if (s && !f && je(o) == "wrapper") var f = new Pn([], !0);
                    }
                    for(r = f ? r : e; ++r < e;){
                        o = t[r];
                        var c = je(o), l = c == "wrapper" ? di(o) : i;
                        l && mi(l[0]) && l[1] == (Mn | Dn | Nn | Kt) && !l[4].length && l[9] == 1 ? f = f[je(l[0])].apply(f, l[3]) : f = o.length == 1 && mi(o) ? f[c]() : f.thru(o);
                    }
                    return function() {
                        var v = arguments, _ = v[0];
                        if (f && v.length == 1 && O(_)) return f.plant(_).value();
                        for(var m = 0, P = e ? t[m].apply(this, v) : _; ++m < e;)P = t[m].call(this, P);
                        return P;
                    };
                });
            }
            function Xe(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & Mn, m = t & vn, P = t & ot, I = t & (Dn | xt), E = t & dr, b = P ? i : ce(n);
                function y() {
                    for(var D = arguments.length, H = p(D), dn = D; dn--;)H[dn] = arguments[dn];
                    if (I) var sn = Ft(y), gn = af(H, sn);
                    if (r && (H = du(H, r, s, I)), o && (H = gu(H, o, f, I)), D -= gn, I && D < v) {
                        var Z = nt(H, sn);
                        return Iu(n, t, Xe, y.placeholder, e, H, Z, c, l, v - D);
                    }
                    var Tn = m ? e : this, Qn = P ? Tn[n] : n;
                    return D = H.length, c ? H = gh(H, c) : E && D > 1 && H.reverse(), _ && l < D && (H.length = l), this && this !== k && this instanceof y && (Qn = b || ce(Qn)), Qn.apply(Tn, H);
                }
                return y;
            }
            function Au(n, t) {
                return function(e, r) {
                    return Ic(e, n, t(r), {});
                };
            }
            function Qe(n, t) {
                return function(e, r) {
                    var s;
                    if (e === i && r === i) return t;
                    if (e !== i && (s = e), r !== i) {
                        if (s === i) return r;
                        typeof e == "string" || typeof r == "string" ? (e = ln(e), r = ln(r)) : (e = uu(e), r = uu(r)), s = n(e, r);
                    }
                    return s;
                };
            }
            function ci(n) {
                return Yn(function(t) {
                    return t = G(t, hn(x())), L(function(e) {
                        var r = this;
                        return n(t, function(s) {
                            return cn(s, r, e);
                        });
                    });
                });
            }
            function Ve(n, t) {
                t = t === i ? " " : ln(t);
                var e = t.length;
                if (e < 2) return e ? ri(t, n) : t;
                var r = ri(t, Ue(n / Tt(t)));
                return bt(t) ? st(On(r), 0, n).join("") : r.slice(0, n);
            }
            function Qc(n, t, e, r) {
                var s = t & vn, o = ce(n);
                function f() {
                    for(var c = -1, l = arguments.length, v = -1, _ = r.length, m = p(_ + l), P = this && this !== k && this instanceof f ? o : n; ++v < _;)m[v] = r[v];
                    for(; l--;)m[v++] = arguments[++c];
                    return cn(P, s ? e : this, m);
                }
                return f;
            }
            function Cu(n) {
                return function(t, e, r) {
                    return r && typeof r != "number" && rn(t, e, r) && (e = r = i), t = Xn(t), e === i ? (e = t, t = 0) : e = Xn(e), r = r === i ? t < e ? 1 : -1 : Xn(r), Hc(t, e, r, n);
                };
            }
            function ke(n) {
                return function(t, e) {
                    return typeof t == "string" && typeof e == "string" || (t = xn(t), e = xn(e)), n(t, e);
                };
            }
            function Iu(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & Dn, m = _ ? f : i, P = _ ? i : f, I = _ ? o : i, E = _ ? i : o;
                t |= _ ? Nn : Et, t &= ~(_ ? Et : Nn), t & qi || (t &= ~(vn | ot));
                var b = [
                    n,
                    t,
                    s,
                    I,
                    m,
                    E,
                    P,
                    c,
                    l,
                    v
                ], y = e.apply(i, b);
                return mi(n) && Hu(y, b), y.placeholder = r, $u(y, n, t);
            }
            function hi(n) {
                var t = X[n];
                return function(e, r) {
                    if (e = xn(e), r = r == null ? 0 : nn(R(r), 292), r && $s(e)) {
                        var s = (W(e) + "e").split("e"), o = t(s[0] + "e" + (+s[1] + r));
                        return s = (W(o) + "e").split("e"), +(s[0] + "e" + (+s[1] - r));
                    }
                    return t(e);
                };
            }
            var Vc = Nt && 1 / Se(new Nt([
                ,
                -0
            ]))[1] == ft ? function(n) {
                return new Nt(n);
            } : Di;
            function xu(n) {
                return function(t) {
                    var e = tn(t);
                    return e == yn ? qr(t) : e == Sn ? df(t) : uf(t, n(t));
                };
            }
            function Kn(n, t, e, r, s, o, f, c) {
                var l = t & ot;
                if (!l && typeof n != "function") throw new wn(U);
                var v = r ? r.length : 0;
                if (v || (t &= ~(Nn | Et), r = s = i), f = f === i ? f : Q(R(f), 0), c = c === i ? c : R(c), v -= s ? s.length : 0, t & Et) {
                    var _ = r, m = s;
                    r = s = i;
                }
                var P = l ? i : di(n), I = [
                    n,
                    t,
                    e,
                    r,
                    s,
                    _,
                    m,
                    o,
                    f,
                    c
                ];
                if (P && lh(I, P), n = I[0], t = I[1], e = I[2], r = I[3], s = I[4], c = I[9] = I[9] === i ? l ? 0 : n.length : Q(I[9] - v, 0), !c && t & (Dn | xt) && (t &= ~(Dn | xt)), !t || t == vn) var E = Jc(n, t, e);
                else t == Dn || t == xt ? E = Xc(n, t, c) : (t == Nn || t == (vn | Nn)) && !s.length ? E = Qc(n, t, e, r) : E = Xe.apply(i, I);
                var b = P ? iu : Hu;
                return $u(b(E, I), n, t);
            }
            function Eu(n, t, e, r) {
                return n === i || bn(n, Dt[e]) && !F.call(r, e) ? t : n;
            }
            function yu(n, t, e, r, s, o) {
                return z(n) && z(t) && (o.set(t, n), Ke(n, t, i, yu, o), o.delete(t)), n;
            }
            function kc(n) {
                return pe(n) ? i : n;
            }
            function Su(n, t, e, r, s, o) {
                var f = e & It, c = n.length, l = t.length;
                if (c != l && !(f && l > c)) return !1;
                var v = o.get(n), _ = o.get(t);
                if (v && _) return v == t && _ == n;
                var m = -1, P = !0, I = e & ve ? new pt : i;
                for(o.set(n, t), o.set(t, n); ++m < c;){
                    var E = n[m], b = t[m];
                    if (r) var y = f ? r(b, E, m, t, n, o) : r(E, b, m, n, t, o);
                    if (y !== i) {
                        if (y) continue;
                        P = !1;
                        break;
                    }
                    if (I) {
                        if (!Hr(t, function(D, H) {
                            if (!jt(I, H) && (E === D || s(E, D, e, r, o))) return I.push(H);
                        })) {
                            P = !1;
                            break;
                        }
                    } else if (!(E === b || s(E, b, e, r, o))) {
                        P = !1;
                        break;
                    }
                }
                return o.delete(n), o.delete(t), P;
            }
            function jc(n, t, e, r, s, o, f) {
                switch(e){
                    case St:
                        if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                        n = n.buffer, t = t.buffer;
                    case kt:
                        return !(n.byteLength != t.byteLength || !o(new De(n), new De(t)));
                    case Yt:
                    case Zt:
                    case Jt:
                        return bn(+n, +t);
                    case we:
                        return n.name == t.name && n.message == t.message;
                    case Xt:
                    case Qt:
                        return n == t + "";
                    case yn:
                        var c = qr;
                    case Sn:
                        var l = r & It;
                        if (c || (c = Se), n.size != t.size && !l) return !1;
                        var v = f.get(n);
                        if (v) return v == t;
                        r |= ve, f.set(n, t);
                        var _ = Su(c(n), c(t), r, s, o, f);
                        return f.delete(n), _;
                    case Ae:
                        if (ie) return ie.call(n) == ie.call(t);
                }
                return !1;
            }
            function nh(n, t, e, r, s, o) {
                var f = e & It, c = li(n), l = c.length, v = li(t), _ = v.length;
                if (l != _ && !f) return !1;
                for(var m = l; m--;){
                    var P = c[m];
                    if (!(f ? P in t : F.call(t, P))) return !1;
                }
                var I = o.get(n), E = o.get(t);
                if (I && E) return I == t && E == n;
                var b = !0;
                o.set(n, t), o.set(t, n);
                for(var y = f; ++m < l;){
                    P = c[m];
                    var D = n[P], H = t[P];
                    if (r) var dn = f ? r(H, D, P, t, n, o) : r(D, H, P, n, t, o);
                    if (!(dn === i ? D === H || s(D, H, e, r, o) : dn)) {
                        b = !1;
                        break;
                    }
                    y || (y = P == "constructor");
                }
                if (b && !y) {
                    var sn = n.constructor, gn = t.constructor;
                    sn != gn && "constructor" in n && "constructor" in t && !(typeof sn == "function" && sn instanceof sn && typeof gn == "function" && gn instanceof gn) && (b = !1);
                }
                return o.delete(n), o.delete(t), b;
            }
            function Yn(n) {
                return Pi(Du(n, i, Bu), n + "");
            }
            function li(n) {
                return Zs(n, V, vi);
            }
            function pi(n) {
                return Zs(n, on, Ou);
            }
            var di = Fe ? function(n) {
                return Fe.get(n);
            } : Di;
            function je(n) {
                for(var t = n.name + "", e = Ht[t], r = F.call(Ht, t) ? e.length : 0; r--;){
                    var s = e[r], o = s.func;
                    if (o == null || o == n) return s.name;
                }
                return t;
            }
            function Ft(n) {
                var t = F.call(a, "placeholder") ? a : n;
                return t.placeholder;
            }
            function x() {
                var n = a.iteratee || Ti;
                return n = n === Ti ? Qs : n, arguments.length ? n(arguments[0], arguments[1]) : n;
            }
            function nr(n, t) {
                var e = n.__data__;
                return oh(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
            }
            function gi(n) {
                for(var t = V(n), e = t.length; e--;){
                    var r = t[e], s = n[r];
                    t[e] = [
                        r,
                        s,
                        Tu(s)
                    ];
                }
                return t;
            }
            function vt(n, t) {
                var e = hf(n, t);
                return Xs(e) ? e : i;
            }
            function th(n) {
                var t = F.call(n, ht), e = n[ht];
                try {
                    n[ht] = i;
                    var r = !0;
                } catch  {}
                var s = Te.call(n);
                return r && (t ? n[ht] = e : delete n[ht]), s;
            }
            var vi = Gr ? function(n) {
                return n == null ? [] : (n = M(n), kn(Gr(n), function(t) {
                    return Ns.call(n, t);
                }));
            } : Ni, Ou = Gr ? function(n) {
                for(var t = []; n;)jn(t, vi(n)), n = Ne(n);
                return t;
            } : Ni, tn = en;
            (zr && tn(new zr(new ArrayBuffer(1))) != St || te && tn(new te) != yn || Kr && tn(Kr.resolve()) != zi || Nt && tn(new Nt) != Sn || ee && tn(new ee) != Vt) && (tn = function(n) {
                var t = en(n), e = t == qn ? n.constructor : i, r = e ? _t(e) : "";
                if (r) switch(r){
                    case Uf:
                        return St;
                    case Wf:
                        return yn;
                    case Ff:
                        return zi;
                    case Mf:
                        return Sn;
                    case qf:
                        return Vt;
                }
                return t;
            });
            function eh(n, t, e) {
                for(var r = -1, s = e.length; ++r < s;){
                    var o = e[r], f = o.size;
                    switch(o.type){
                        case "drop":
                            n += f;
                            break;
                        case "dropRight":
                            t -= f;
                            break;
                        case "take":
                            t = nn(t, n + f);
                            break;
                        case "takeRight":
                            n = Q(n, t - f);
                            break;
                    }
                }
                return {
                    start: n,
                    end: t
                };
            }
            function rh(n) {
                var t = n.match(ao);
                return t ? t[1].split(oo) : [];
            }
            function Ru(n, t, e) {
                t = it(t, n);
                for(var r = -1, s = t.length, o = !1; ++r < s;){
                    var f = Wn(t[r]);
                    if (!(o = n != null && e(n, f))) break;
                    n = n[f];
                }
                return o || ++r != s ? o : (s = n == null ? 0 : n.length, !!s && ar(s) && Zn(f, s) && (O(n) || mt(n)));
            }
            function ih(n) {
                var t = n.length, e = new n.constructor(t);
                return t && typeof n[0] == "string" && F.call(n, "index") && (e.index = n.index, e.input = n.input), e;
            }
            function bu(n) {
                return typeof n.constructor == "function" && !he(n) ? $t(Ne(n)) : {};
            }
            function sh(n, t, e) {
                var r = n.constructor;
                switch(t){
                    case kt:
                        return fi(n);
                    case Yt:
                    case Zt:
                        return new r(+n);
                    case St:
                        return Bc(n, e);
                    case gr:
                    case vr:
                    case _r:
                    case mr:
                    case wr:
                    case Pr:
                    case Ar:
                    case Cr:
                    case Ir:
                        return lu(n, e);
                    case yn:
                        return new r;
                    case Jt:
                    case Qt:
                        return new r(n);
                    case Xt:
                        return Gc(n);
                    case Sn:
                        return new r;
                    case Ae:
                        return zc(n);
                }
            }
            function uh(n, t) {
                var e = t.length;
                if (!e) return n;
                var r = e - 1;
                return t[r] = (e > 1 ? "& " : "") + t[r], t = t.join(e > 2 ? ", " : " "), n.replace(uo, `{
/* [wrapped with ` + t + `] */
`);
            }
            function ah(n) {
                return O(n) || mt(n) || !!(Hs && n && n[Hs]);
            }
            function Zn(n, t) {
                var e = typeof n;
                return t = t ?? Vn, !!t && (e == "number" || e != "symbol" && mo.test(n)) && n > -1 && n % 1 == 0 && n < t;
            }
            function rn(n, t, e) {
                if (!z(e)) return !1;
                var r = typeof t;
                return (r == "number" ? an(e) && Zn(t, e.length) : r == "string" && t in e) ? bn(e[t], n) : !1;
            }
            function _i(n, t) {
                if (O(n)) return !1;
                var e = typeof n;
                return e == "number" || e == "symbol" || e == "boolean" || n == null || pn(n) ? !0 : eo.test(n) || !to.test(n) || t != null && n in M(t);
            }
            function oh(n) {
                var t = typeof n;
                return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
            }
            function mi(n) {
                var t = je(n), e = a[t];
                if (typeof e != "function" || !(t in N.prototype)) return !1;
                if (n === e) return !0;
                var r = di(e);
                return !!r && n === r[0];
            }
            function fh(n) {
                return !!Ts && Ts in n;
            }
            var ch = Re ? Jn : Hi;
            function he(n) {
                var t = n && n.constructor, e = typeof t == "function" && t.prototype || Dt;
                return n === e;
            }
            function Tu(n) {
                return n === n && !z(n);
            }
            function Lu(n, t) {
                return function(e) {
                    return e == null ? !1 : e[n] === t && (t !== i || n in M(e));
                };
            }
            function hh(n) {
                var t = sr(n, function(r) {
                    return e.size === pr && e.clear(), r;
                }), e = t.cache;
                return t;
            }
            function lh(n, t) {
                var e = n[1], r = t[1], s = e | r, o = s < (vn | ot | Mn), f = r == Mn && e == Dn || r == Mn && e == Kt && n[7].length <= t[8] || r == (Mn | Kt) && t[7].length <= t[8] && e == Dn;
                if (!(o || f)) return n;
                r & vn && (n[2] = t[2], s |= e & vn ? 0 : qi);
                var c = t[3];
                if (c) {
                    var l = n[3];
                    n[3] = l ? du(l, c, t[4]) : c, n[4] = l ? nt(n[3], At) : t[4];
                }
                return c = t[5], c && (l = n[5], n[5] = l ? gu(l, c, t[6]) : c, n[6] = l ? nt(n[5], At) : t[6]), c = t[7], c && (n[7] = c), r & Mn && (n[8] = n[8] == null ? t[8] : nn(n[8], t[8])), n[9] == null && (n[9] = t[9]), n[0] = t[0], n[1] = s, n;
            }
            function ph(n) {
                var t = [];
                if (n != null) for(var e in M(n))t.push(e);
                return t;
            }
            function dh(n) {
                return Te.call(n);
            }
            function Du(n, t, e) {
                return t = Q(t === i ? n.length - 1 : t, 0), function() {
                    for(var r = arguments, s = -1, o = Q(r.length - t, 0), f = p(o); ++s < o;)f[s] = r[t + s];
                    s = -1;
                    for(var c = p(t + 1); ++s < t;)c[s] = r[s];
                    return c[t] = e(f), cn(n, this, c);
                };
            }
            function Nu(n, t) {
                return t.length < 2 ? n : gt(n, Cn(t, 0, -1));
            }
            function gh(n, t) {
                for(var e = n.length, r = nn(t.length, e), s = un(n); r--;){
                    var o = t[r];
                    n[r] = Zn(o, e) ? s[o] : i;
                }
                return n;
            }
            function wi(n, t) {
                if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__") return n[t];
            }
            var Hu = Uu(iu), le = bf || function(n, t) {
                return k.setTimeout(n, t);
            }, Pi = Uu(Wc);
            function $u(n, t, e) {
                var r = t + "";
                return Pi(n, uh(r, vh(rh(r), e)));
            }
            function Uu(n) {
                var t = 0, e = 0;
                return function() {
                    var r = Nf(), s = Ha - (r - e);
                    if (e = r, s > 0) {
                        if (++t >= Na) return arguments[0];
                    } else t = 0;
                    return n.apply(i, arguments);
                };
            }
            function tr(n, t) {
                var e = -1, r = n.length, s = r - 1;
                for(t = t === i ? r : t; ++e < t;){
                    var o = ei(e, s), f = n[o];
                    n[o] = n[e], n[e] = f;
                }
                return n.length = t, n;
            }
            var Wu = hh(function(n) {
                var t = [];
                return n.charCodeAt(0) === 46 && t.push(""), n.replace(ro, function(e, r, s, o) {
                    t.push(s ? o.replace(ho, "$1") : r || e);
                }), t;
            });
            function Wn(n) {
                if (typeof n == "string" || pn(n)) return n;
                var t = n + "";
                return t == "0" && 1 / n == -ft ? "-0" : t;
            }
            function _t(n) {
                if (n != null) {
                    try {
                        return be.call(n);
                    } catch  {}
                    try {
                        return n + "";
                    } catch  {}
                }
                return "";
            }
            function vh(n, t) {
                return mn(qa, function(e) {
                    var r = "_." + e[0];
                    t & e[1] && !Ee(n, r) && n.push(r);
                }), n.sort();
            }
            function Fu(n) {
                if (n instanceof N) return n.clone();
                var t = new Pn(n.__wrapped__, n.__chain__);
                return t.__actions__ = un(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
            }
            function _h(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = Q(R(t), 0);
                var r = n == null ? 0 : n.length;
                if (!r || t < 1) return [];
                for(var s = 0, o = 0, f = p(Ue(r / t)); s < r;)f[o++] = Cn(n, s, s += t);
                return f;
            }
            function mh(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = 0, s = []; ++t < e;){
                    var o = n[t];
                    o && (s[r++] = o);
                }
                return s;
            }
            function wh() {
                var n = arguments.length;
                if (!n) return [];
                for(var t = p(n - 1), e = arguments[0], r = n; r--;)t[r - 1] = arguments[r];
                return jn(O(e) ? un(e) : [
                    e
                ], j(t, 1));
            }
            var Ph = L(function(n, t) {
                return Y(n) ? ue(n, j(t, 1, Y, !0)) : [];
            }), Ah = L(function(n, t) {
                var e = In(t);
                return Y(e) && (e = i), Y(n) ? ue(n, j(t, 1, Y, !0), x(e, 2)) : [];
            }), Ch = L(function(n, t) {
                var e = In(t);
                return Y(e) && (e = i), Y(n) ? ue(n, j(t, 1, Y, !0), i, e) : [];
            });
            function Ih(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function xh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function Eh(n, t) {
                return n && n.length ? Ze(n, x(t, 3), !0, !0) : [];
            }
            function yh(n, t) {
                return n && n.length ? Ze(n, x(t, 3), !0) : [];
            }
            function Sh(n, t, e, r) {
                var s = n == null ? 0 : n.length;
                return s ? (e && typeof e != "number" && rn(n, t, e) && (e = 0, r = s), wc(n, t, e, r)) : [];
            }
            function Mu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), ye(n, x(t, 3), s);
            }
            function qu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r - 1;
                return e !== i && (s = R(e), s = e < 0 ? Q(r + s, 0) : nn(s, r - 1)), ye(n, x(t, 3), s, !0);
            }
            function Bu(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, 1) : [];
            }
            function Oh(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, ft) : [];
            }
            function Rh(n, t) {
                var e = n == null ? 0 : n.length;
                return e ? (t = t === i ? 1 : R(t), j(n, t)) : [];
            }
            function bh(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = {}; ++t < e;){
                    var s = n[t];
                    r[s[0]] = s[1];
                }
                return r;
            }
            function Gu(n) {
                return n && n.length ? n[0] : i;
            }
            function Th(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), Rt(n, t, s);
            }
            function Lh(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 0, -1) : [];
            }
            var Dh = L(function(n) {
                var t = G(n, ai);
                return t.length && t[0] === n[0] ? Vr(t) : [];
            }), Nh = L(function(n) {
                var t = In(n), e = G(n, ai);
                return t === In(e) ? t = i : e.pop(), e.length && e[0] === n[0] ? Vr(e, x(t, 2)) : [];
            }), Hh = L(function(n) {
                var t = In(n), e = G(n, ai);
                return t = typeof t == "function" ? t : i, t && e.pop(), e.length && e[0] === n[0] ? Vr(e, i, t) : [];
            });
            function $h(n, t) {
                return n == null ? "" : Lf.call(n, t);
            }
            function In(n) {
                var t = n == null ? 0 : n.length;
                return t ? n[t - 1] : i;
            }
            function Uh(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r;
                return e !== i && (s = R(e), s = s < 0 ? Q(r + s, 0) : nn(s, r - 1)), t === t ? vf(n, t, s) : ye(n, Is, s, !0);
            }
            function Wh(n, t) {
                return n && n.length ? nu(n, R(t)) : i;
            }
            var Fh = L(zu);
            function zu(n, t) {
                return n && n.length && t && t.length ? ti(n, t) : n;
            }
            function Mh(n, t, e) {
                return n && n.length && t && t.length ? ti(n, t, x(e, 2)) : n;
            }
            function qh(n, t, e) {
                return n && n.length && t && t.length ? ti(n, t, i, e) : n;
            }
            var Bh = Yn(function(n, t) {
                var e = n == null ? 0 : n.length, r = Zr(n, t);
                return ru(n, G(t, function(s) {
                    return Zn(s, e) ? +s : s;
                }).sort(pu)), r;
            });
            function Gh(n, t) {
                var e = [];
                if (!(n && n.length)) return e;
                var r = -1, s = [], o = n.length;
                for(t = x(t, 3); ++r < o;){
                    var f = n[r];
                    t(f, r, n) && (e.push(f), s.push(r));
                }
                return ru(n, s), e;
            }
            function Ai(n) {
                return n == null ? n : $f.call(n);
            }
            function zh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (e && typeof e != "number" && rn(n, t, e) ? (t = 0, e = r) : (t = t == null ? 0 : R(t), e = e === i ? r : R(e)), Cn(n, t, e)) : [];
            }
            function Kh(n, t) {
                return Ye(n, t);
            }
            function Yh(n, t, e) {
                return ii(n, t, x(e, 2));
            }
            function Zh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = Ye(n, t);
                    if (r < e && bn(n[r], t)) return r;
                }
                return -1;
            }
            function Jh(n, t) {
                return Ye(n, t, !0);
            }
            function Xh(n, t, e) {
                return ii(n, t, x(e, 2), !0);
            }
            function Qh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = Ye(n, t, !0) - 1;
                    if (bn(n[r], t)) return r;
                }
                return -1;
            }
            function Vh(n) {
                return n && n.length ? su(n) : [];
            }
            function kh(n, t) {
                return n && n.length ? su(n, x(t, 2)) : [];
            }
            function jh(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 1, t) : [];
            }
            function nl(n, t, e) {
                return n && n.length ? (t = e || t === i ? 1 : R(t), Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function tl(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function el(n, t) {
                return n && n.length ? Ze(n, x(t, 3), !1, !0) : [];
            }
            function rl(n, t) {
                return n && n.length ? Ze(n, x(t, 3)) : [];
            }
            var il = L(function(n) {
                return rt(j(n, 1, Y, !0));
            }), sl = L(function(n) {
                var t = In(n);
                return Y(t) && (t = i), rt(j(n, 1, Y, !0), x(t, 2));
            }), ul = L(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, rt(j(n, 1, Y, !0), i, t);
            });
            function al(n) {
                return n && n.length ? rt(n) : [];
            }
            function ol(n, t) {
                return n && n.length ? rt(n, x(t, 2)) : [];
            }
            function fl(n, t) {
                return t = typeof t == "function" ? t : i, n && n.length ? rt(n, i, t) : [];
            }
            function Ci(n) {
                if (!(n && n.length)) return [];
                var t = 0;
                return n = kn(n, function(e) {
                    if (Y(e)) return t = Q(e.length, t), !0;
                }), Fr(t, function(e) {
                    return G(n, $r(e));
                });
            }
            function Ku(n, t) {
                if (!(n && n.length)) return [];
                var e = Ci(n);
                return t == null ? e : G(e, function(r) {
                    return cn(t, i, r);
                });
            }
            var cl = L(function(n, t) {
                return Y(n) ? ue(n, t) : [];
            }), hl = L(function(n) {
                return ui(kn(n, Y));
            }), ll = L(function(n) {
                var t = In(n);
                return Y(t) && (t = i), ui(kn(n, Y), x(t, 2));
            }), pl = L(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, ui(kn(n, Y), i, t);
            }), dl = L(Ci);
            function gl(n, t) {
                return fu(n || [], t || [], se);
            }
            function vl(n, t) {
                return fu(n || [], t || [], fe);
            }
            var _l = L(function(n) {
                var t = n.length, e = t > 1 ? n[t - 1] : i;
                return e = typeof e == "function" ? (n.pop(), e) : i, Ku(n, e);
            });
            function Yu(n) {
                var t = a(n);
                return t.__chain__ = !0, t;
            }
            function ml(n, t) {
                return t(n), n;
            }
            function er(n, t) {
                return t(n);
            }
            var wl = Yn(function(n) {
                var t = n.length, e = t ? n[0] : 0, r = this.__wrapped__, s = function(o) {
                    return Zr(o, n);
                };
                return t > 1 || this.__actions__.length || !(r instanceof N) || !Zn(e) ? this.thru(s) : (r = r.slice(e, +e + (t ? 1 : 0)), r.__actions__.push({
                    func: er,
                    args: [
                        s
                    ],
                    thisArg: i
                }), new Pn(r, this.__chain__).thru(function(o) {
                    return t && !o.length && o.push(i), o;
                }));
            });
            function Pl() {
                return Yu(this);
            }
            function Al() {
                return new Pn(this.value(), this.__chain__);
            }
            function Cl() {
                this.__values__ === i && (this.__values__ = ua(this.value()));
                var n = this.__index__ >= this.__values__.length, t = n ? i : this.__values__[this.__index__++];
                return {
                    done: n,
                    value: t
                };
            }
            function Il() {
                return this;
            }
            function xl(n) {
                for(var t, e = this; e instanceof qe;){
                    var r = Fu(e);
                    r.__index__ = 0, r.__values__ = i, t ? s.__wrapped__ = r : t = r;
                    var s = r;
                    e = e.__wrapped__;
                }
                return s.__wrapped__ = n, t;
            }
            function El() {
                var n = this.__wrapped__;
                if (n instanceof N) {
                    var t = n;
                    return this.__actions__.length && (t = new N(this)), t = t.reverse(), t.__actions__.push({
                        func: er,
                        args: [
                            Ai
                        ],
                        thisArg: i
                    }), new Pn(t, this.__chain__);
                }
                return this.thru(Ai);
            }
            function yl() {
                return ou(this.__wrapped__, this.__actions__);
            }
            var Sl = Je(function(n, t, e) {
                F.call(n, e) ? ++n[e] : zn(n, e, 1);
            });
            function Ol(n, t, e) {
                var r = O(n) ? As : mc;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            function Rl(n, t) {
                var e = O(n) ? kn : Ks;
                return e(n, x(t, 3));
            }
            var bl = wu(Mu), Tl = wu(qu);
            function Ll(n, t) {
                return j(rr(n, t), 1);
            }
            function Dl(n, t) {
                return j(rr(n, t), ft);
            }
            function Nl(n, t, e) {
                return e = e === i ? 1 : R(e), j(rr(n, t), e);
            }
            function Zu(n, t) {
                var e = O(n) ? mn : et;
                return e(n, x(t, 3));
            }
            function Ju(n, t) {
                var e = O(n) ? ko : zs;
                return e(n, x(t, 3));
            }
            var Hl = Je(function(n, t, e) {
                F.call(n, e) ? n[e].push(t) : zn(n, e, [
                    t
                ]);
            });
            function $l(n, t, e, r) {
                n = an(n) ? n : qt(n), e = e && !r ? R(e) : 0;
                var s = n.length;
                return e < 0 && (e = Q(s + e, 0)), or(n) ? e <= s && n.indexOf(t, e) > -1 : !!s && Rt(n, t, e) > -1;
            }
            var Ul = L(function(n, t, e) {
                var r = -1, s = typeof t == "function", o = an(n) ? p(n.length) : [];
                return et(n, function(f) {
                    o[++r] = s ? cn(t, f, e) : ae(f, t, e);
                }), o;
            }), Wl = Je(function(n, t, e) {
                zn(n, e, t);
            });
            function rr(n, t) {
                var e = O(n) ? G : Vs;
                return e(n, x(t, 3));
            }
            function Fl(n, t, e, r) {
                return n == null ? [] : (O(t) || (t = t == null ? [] : [
                    t
                ]), e = r ? i : e, O(e) || (e = e == null ? [] : [
                    e
                ]), tu(n, t, e));
            }
            var Ml = Je(function(n, t, e) {
                n[e ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function ql(n, t, e) {
                var r = O(n) ? Nr : Es, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, et);
            }
            function Bl(n, t, e) {
                var r = O(n) ? jo : Es, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, zs);
            }
            function Gl(n, t) {
                var e = O(n) ? kn : Ks;
                return e(n, ur(x(t, 3)));
            }
            function zl(n) {
                var t = O(n) ? Ms : $c;
                return t(n);
            }
            function Kl(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t);
                var r = O(n) ? pc : Uc;
                return r(n, t);
            }
            function Yl(n) {
                var t = O(n) ? dc : Fc;
                return t(n);
            }
            function Zl(n) {
                if (n == null) return 0;
                if (an(n)) return or(n) ? Tt(n) : n.length;
                var t = tn(n);
                return t == yn || t == Sn ? n.size : jr(n).length;
            }
            function Jl(n, t, e) {
                var r = O(n) ? Hr : Mc;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            var Xl = L(function(n, t) {
                if (n == null) return [];
                var e = t.length;
                return e > 1 && rn(n, t[0], t[1]) ? t = [] : e > 2 && rn(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), tu(n, j(t, 1), []);
            }), ir = Rf || function() {
                return k.Date.now();
            };
            function Ql(n, t) {
                if (typeof t != "function") throw new wn(U);
                return n = R(n), function() {
                    if (--n < 1) return t.apply(this, arguments);
                };
            }
            function Xu(n, t, e) {
                return t = e ? i : t, t = n && t == null ? n.length : t, Kn(n, Mn, i, i, i, i, t);
            }
            function Qu(n, t) {
                var e;
                if (typeof t != "function") throw new wn(U);
                return n = R(n), function() {
                    return --n > 0 && (e = t.apply(this, arguments)), n <= 1 && (t = i), e;
                };
            }
            var Ii = L(function(n, t, e) {
                var r = vn;
                if (e.length) {
                    var s = nt(e, Ft(Ii));
                    r |= Nn;
                }
                return Kn(n, r, t, e, s);
            }), Vu = L(function(n, t, e) {
                var r = vn | ot;
                if (e.length) {
                    var s = nt(e, Ft(Vu));
                    r |= Nn;
                }
                return Kn(t, r, n, e, s);
            });
            function ku(n, t, e) {
                t = e ? i : t;
                var r = Kn(n, Dn, i, i, i, i, i, t);
                return r.placeholder = ku.placeholder, r;
            }
            function ju(n, t, e) {
                t = e ? i : t;
                var r = Kn(n, xt, i, i, i, i, i, t);
                return r.placeholder = ju.placeholder, r;
            }
            function na(n, t, e) {
                var r, s, o, f, c, l, v = 0, _ = !1, m = !1, P = !0;
                if (typeof n != "function") throw new wn(U);
                t = xn(t) || 0, z(e) && (_ = !!e.leading, m = "maxWait" in e, o = m ? Q(xn(e.maxWait) || 0, t) : o, P = "trailing" in e ? !!e.trailing : P);
                function I(Z) {
                    var Tn = r, Qn = s;
                    return r = s = i, v = Z, f = n.apply(Qn, Tn), f;
                }
                function E(Z) {
                    return v = Z, c = le(D, t), _ ? I(Z) : f;
                }
                function b(Z) {
                    var Tn = Z - l, Qn = Z - v, wa = t - Tn;
                    return m ? nn(wa, o - Qn) : wa;
                }
                function y(Z) {
                    var Tn = Z - l, Qn = Z - v;
                    return l === i || Tn >= t || Tn < 0 || m && Qn >= o;
                }
                function D() {
                    var Z = ir();
                    if (y(Z)) return H(Z);
                    c = le(D, b(Z));
                }
                function H(Z) {
                    return c = i, P && r ? I(Z) : (r = s = i, f);
                }
                function dn() {
                    c !== i && cu(c), v = 0, r = l = s = c = i;
                }
                function sn() {
                    return c === i ? f : H(ir());
                }
                function gn() {
                    var Z = ir(), Tn = y(Z);
                    if (r = arguments, s = this, l = Z, Tn) {
                        if (c === i) return E(l);
                        if (m) return cu(c), c = le(D, t), I(l);
                    }
                    return c === i && (c = le(D, t)), f;
                }
                return gn.cancel = dn, gn.flush = sn, gn;
            }
            var Vl = L(function(n, t) {
                return Gs(n, 1, t);
            }), kl = L(function(n, t, e) {
                return Gs(n, xn(t) || 0, e);
            });
            function jl(n) {
                return Kn(n, dr);
            }
            function sr(n, t) {
                if (typeof n != "function" || t != null && typeof t != "function") throw new wn(U);
                var e = function() {
                    var r = arguments, s = t ? t.apply(this, r) : r[0], o = e.cache;
                    if (o.has(s)) return o.get(s);
                    var f = n.apply(this, r);
                    return e.cache = o.set(s, f) || o, f;
                };
                return e.cache = new (sr.Cache || Gn), e;
            }
            sr.Cache = Gn;
            function ur(n) {
                if (typeof n != "function") throw new wn(U);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !n.call(this);
                        case 1:
                            return !n.call(this, t[0]);
                        case 2:
                            return !n.call(this, t[0], t[1]);
                        case 3:
                            return !n.call(this, t[0], t[1], t[2]);
                    }
                    return !n.apply(this, t);
                };
            }
            function np(n) {
                return Qu(2, n);
            }
            var tp = qc(function(n, t) {
                t = t.length == 1 && O(t[0]) ? G(t[0], hn(x())) : G(j(t, 1), hn(x()));
                var e = t.length;
                return L(function(r) {
                    for(var s = -1, o = nn(r.length, e); ++s < o;)r[s] = t[s].call(this, r[s]);
                    return cn(n, this, r);
                });
            }), xi = L(function(n, t) {
                var e = nt(t, Ft(xi));
                return Kn(n, Nn, i, t, e);
            }), ta = L(function(n, t) {
                var e = nt(t, Ft(ta));
                return Kn(n, Et, i, t, e);
            }), ep = Yn(function(n, t) {
                return Kn(n, Kt, i, i, i, t);
            });
            function rp(n, t) {
                if (typeof n != "function") throw new wn(U);
                return t = t === i ? t : R(t), L(n, t);
            }
            function ip(n, t) {
                if (typeof n != "function") throw new wn(U);
                return t = t == null ? 0 : Q(R(t), 0), L(function(e) {
                    var r = e[t], s = st(e, 0, t);
                    return r && jn(s, r), cn(n, this, s);
                });
            }
            function sp(n, t, e) {
                var r = !0, s = !0;
                if (typeof n != "function") throw new wn(U);
                return z(e) && (r = "leading" in e ? !!e.leading : r, s = "trailing" in e ? !!e.trailing : s), na(n, t, {
                    leading: r,
                    maxWait: t,
                    trailing: s
                });
            }
            function up(n) {
                return Xu(n, 1);
            }
            function ap(n, t) {
                return xi(oi(t), n);
            }
            function op() {
                if (!arguments.length) return [];
                var n = arguments[0];
                return O(n) ? n : [
                    n
                ];
            }
            function fp(n) {
                return An(n, Ct);
            }
            function cp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ct, t);
            }
            function hp(n) {
                return An(n, Ln | Ct);
            }
            function lp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ln | Ct, t);
            }
            function pp(n, t) {
                return t == null || Bs(n, t, V(t));
            }
            function bn(n, t) {
                return n === t || n !== n && t !== t;
            }
            var dp = ke(Qr), gp = ke(function(n, t) {
                return n >= t;
            }), mt = Js(function() {
                return arguments;
            }()) ? Js : function(n) {
                return K(n) && F.call(n, "callee") && !Ns.call(n, "callee");
            }, O = p.isArray, vp = gs ? hn(gs) : xc;
            function an(n) {
                return n != null && ar(n.length) && !Jn(n);
            }
            function Y(n) {
                return K(n) && an(n);
            }
            function _p(n) {
                return n === !0 || n === !1 || K(n) && en(n) == Yt;
            }
            var ut = Tf || Hi, mp = vs ? hn(vs) : Ec;
            function wp(n) {
                return K(n) && n.nodeType === 1 && !pe(n);
            }
            function Pp(n) {
                if (n == null) return !0;
                if (an(n) && (O(n) || typeof n == "string" || typeof n.splice == "function" || ut(n) || Mt(n) || mt(n))) return !n.length;
                var t = tn(n);
                if (t == yn || t == Sn) return !n.size;
                if (he(n)) return !jr(n).length;
                for(var e in n)if (F.call(n, e)) return !1;
                return !0;
            }
            function Ap(n, t) {
                return oe(n, t);
            }
            function Cp(n, t, e) {
                e = typeof e == "function" ? e : i;
                var r = e ? e(n, t) : i;
                return r === i ? oe(n, t, i, e) : !!r;
            }
            function Ei(n) {
                if (!K(n)) return !1;
                var t = en(n);
                return t == we || t == Ga || typeof n.message == "string" && typeof n.name == "string" && !pe(n);
            }
            function Ip(n) {
                return typeof n == "number" && $s(n);
            }
            function Jn(n) {
                if (!z(n)) return !1;
                var t = en(n);
                return t == Pe || t == Gi || t == Ba || t == Ka;
            }
            function ea(n) {
                return typeof n == "number" && n == R(n);
            }
            function ar(n) {
                return typeof n == "number" && n > -1 && n % 1 == 0 && n <= Vn;
            }
            function z(n) {
                var t = typeof n;
                return n != null && (t == "object" || t == "function");
            }
            function K(n) {
                return n != null && typeof n == "object";
            }
            var ra = _s ? hn(_s) : Sc;
            function xp(n, t) {
                return n === t || kr(n, t, gi(t));
            }
            function Ep(n, t, e) {
                return e = typeof e == "function" ? e : i, kr(n, t, gi(t), e);
            }
            function yp(n) {
                return ia(n) && n != +n;
            }
            function Sp(n) {
                if (ch(n)) throw new S(T);
                return Xs(n);
            }
            function Op(n) {
                return n === null;
            }
            function Rp(n) {
                return n == null;
            }
            function ia(n) {
                return typeof n == "number" || K(n) && en(n) == Jt;
            }
            function pe(n) {
                if (!K(n) || en(n) != qn) return !1;
                var t = Ne(n);
                if (t === null) return !0;
                var e = F.call(t, "constructor") && t.constructor;
                return typeof e == "function" && e instanceof e && be.call(e) == Ef;
            }
            var yi = ms ? hn(ms) : Oc;
            function bp(n) {
                return ea(n) && n >= -Vn && n <= Vn;
            }
            var sa = ws ? hn(ws) : Rc;
            function or(n) {
                return typeof n == "string" || !O(n) && K(n) && en(n) == Qt;
            }
            function pn(n) {
                return typeof n == "symbol" || K(n) && en(n) == Ae;
            }
            var Mt = Ps ? hn(Ps) : bc;
            function Tp(n) {
                return n === i;
            }
            function Lp(n) {
                return K(n) && tn(n) == Vt;
            }
            function Dp(n) {
                return K(n) && en(n) == Za;
            }
            var Np = ke(ni), Hp = ke(function(n, t) {
                return n <= t;
            });
            function ua(n) {
                if (!n) return [];
                if (an(n)) return or(n) ? On(n) : un(n);
                if (ne && n[ne]) return pf(n[ne]());
                var t = tn(n), e = t == yn ? qr : t == Sn ? Se : qt;
                return e(n);
            }
            function Xn(n) {
                if (!n) return n === 0 ? n : 0;
                if (n = xn(n), n === ft || n === -ft) {
                    var t = n < 0 ? -1 : 1;
                    return t * Wa;
                }
                return n === n ? n : 0;
            }
            function R(n) {
                var t = Xn(n), e = t % 1;
                return t === t ? e ? t - e : t : 0;
            }
            function aa(n) {
                return n ? dt(R(n), 0, Hn) : 0;
            }
            function xn(n) {
                if (typeof n == "number") return n;
                if (pn(n)) return _e;
                if (z(n)) {
                    var t = typeof n.valueOf == "function" ? n.valueOf() : n;
                    n = z(t) ? t + "" : t;
                }
                if (typeof n != "string") return n === 0 ? n : +n;
                n = ys(n);
                var e = go.test(n);
                return e || _o.test(n) ? Xo(n.slice(2), e ? 2 : 8) : po.test(n) ? _e : +n;
            }
            function oa(n) {
                return Un(n, on(n));
            }
            function $p(n) {
                return n ? dt(R(n), -Vn, Vn) : n === 0 ? n : 0;
            }
            function W(n) {
                return n == null ? "" : ln(n);
            }
            var Up = Ut(function(n, t) {
                if (he(t) || an(t)) {
                    Un(t, V(t), n);
                    return;
                }
                for(var e in t)F.call(t, e) && se(n, e, t[e]);
            }), fa = Ut(function(n, t) {
                Un(t, on(t), n);
            }), fr = Ut(function(n, t, e, r) {
                Un(t, on(t), n, r);
            }), Wp = Ut(function(n, t, e, r) {
                Un(t, V(t), n, r);
            }), Fp = Yn(Zr);
            function Mp(n, t) {
                var e = $t(n);
                return t == null ? e : qs(e, t);
            }
            var qp = L(function(n, t) {
                n = M(n);
                var e = -1, r = t.length, s = r > 2 ? t[2] : i;
                for(s && rn(t[0], t[1], s) && (r = 1); ++e < r;)for(var o = t[e], f = on(o), c = -1, l = f.length; ++c < l;){
                    var v = f[c], _ = n[v];
                    (_ === i || bn(_, Dt[v]) && !F.call(n, v)) && (n[v] = o[v]);
                }
                return n;
            }), Bp = L(function(n) {
                return n.push(i, yu), cn(ca, i, n);
            });
            function Gp(n, t) {
                return Cs(n, x(t, 3), $n);
            }
            function zp(n, t) {
                return Cs(n, x(t, 3), Xr);
            }
            function Kp(n, t) {
                return n == null ? n : Jr(n, x(t, 3), on);
            }
            function Yp(n, t) {
                return n == null ? n : Ys(n, x(t, 3), on);
            }
            function Zp(n, t) {
                return n && $n(n, x(t, 3));
            }
            function Jp(n, t) {
                return n && Xr(n, x(t, 3));
            }
            function Xp(n) {
                return n == null ? [] : ze(n, V(n));
            }
            function Qp(n) {
                return n == null ? [] : ze(n, on(n));
            }
            function Si(n, t, e) {
                var r = n == null ? i : gt(n, t);
                return r === i ? e : r;
            }
            function Vp(n, t) {
                return n != null && Ru(n, t, Pc);
            }
            function Oi(n, t) {
                return n != null && Ru(n, t, Ac);
            }
            var kp = Au(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Te.call(t)), n[t] = e;
            }, bi(fn)), jp = Au(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Te.call(t)), F.call(n, t) ? n[t].push(e) : n[t] = [
                    e
                ];
            }, x), nd = L(ae);
            function V(n) {
                return an(n) ? Fs(n) : jr(n);
            }
            function on(n) {
                return an(n) ? Fs(n, !0) : Tc(n);
            }
            function td(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    zn(e, t(r, s, o), r);
                }), e;
            }
            function ed(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    zn(e, s, t(r, s, o));
                }), e;
            }
            var rd = Ut(function(n, t, e) {
                Ke(n, t, e);
            }), ca = Ut(function(n, t, e, r) {
                Ke(n, t, e, r);
            }), id = Yn(function(n, t) {
                var e = {};
                if (n == null) return e;
                var r = !1;
                t = G(t, function(o) {
                    return o = it(o, n), r || (r = o.length > 1), o;
                }), Un(n, pi(n), e), r && (e = An(e, Ln | Fn | Ct, kc));
                for(var s = t.length; s--;)si(e, t[s]);
                return e;
            });
            function sd(n, t) {
                return ha(n, ur(x(t)));
            }
            var ud = Yn(function(n, t) {
                return n == null ? {} : Dc(n, t);
            });
            function ha(n, t) {
                if (n == null) return {};
                var e = G(pi(n), function(r) {
                    return [
                        r
                    ];
                });
                return t = x(t), eu(n, e, function(r, s) {
                    return t(r, s[0]);
                });
            }
            function ad(n, t, e) {
                t = it(t, n);
                var r = -1, s = t.length;
                for(s || (s = 1, n = i); ++r < s;){
                    var o = n == null ? i : n[Wn(t[r])];
                    o === i && (r = s, o = e), n = Jn(o) ? o.call(n) : o;
                }
                return n;
            }
            function od(n, t, e) {
                return n == null ? n : fe(n, t, e);
            }
            function fd(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : fe(n, t, e, r);
            }
            var la = xu(V), pa = xu(on);
            function cd(n, t, e) {
                var r = O(n), s = r || ut(n) || Mt(n);
                if (t = x(t, 4), e == null) {
                    var o = n && n.constructor;
                    s ? e = r ? new o : [] : z(n) ? e = Jn(o) ? $t(Ne(n)) : {} : e = {};
                }
                return (s ? mn : $n)(n, function(f, c, l) {
                    return t(e, f, c, l);
                }), e;
            }
            function hd(n, t) {
                return n == null ? !0 : si(n, t);
            }
            function ld(n, t, e) {
                return n == null ? n : au(n, t, oi(e));
            }
            function pd(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : au(n, t, oi(e), r);
            }
            function qt(n) {
                return n == null ? [] : Mr(n, V(n));
            }
            function dd(n) {
                return n == null ? [] : Mr(n, on(n));
            }
            function gd(n, t, e) {
                return e === i && (e = t, t = i), e !== i && (e = xn(e), e = e === e ? e : 0), t !== i && (t = xn(t), t = t === t ? t : 0), dt(xn(n), t, e);
            }
            function vd(n, t, e) {
                return t = Xn(t), e === i ? (e = t, t = 0) : e = Xn(e), n = xn(n), Cc(n, t, e);
            }
            function _d(n, t, e) {
                if (e && typeof e != "boolean" && rn(n, t, e) && (t = e = i), e === i && (typeof t == "boolean" ? (e = t, t = i) : typeof n == "boolean" && (e = n, n = i)), n === i && t === i ? (n = 0, t = 1) : (n = Xn(n), t === i ? (t = n, n = 0) : t = Xn(t)), n > t) {
                    var r = n;
                    n = t, t = r;
                }
                if (e || n % 1 || t % 1) {
                    var s = Us();
                    return nn(n + s * (t - n + Jo("1e-" + ((s + "").length - 1))), t);
                }
                return ei(n, t);
            }
            var md = Wt(function(n, t, e) {
                return t = t.toLowerCase(), n + (e ? da(t) : t);
            });
            function da(n) {
                return Ri(W(n).toLowerCase());
            }
            function ga(n) {
                return n = W(n), n && n.replace(wo, of).replace(Wo, "");
            }
            function wd(n, t, e) {
                n = W(n), t = ln(t);
                var r = n.length;
                e = e === i ? r : dt(R(e), 0, r);
                var s = e;
                return e -= t.length, e >= 0 && n.slice(e, s) == t;
            }
            function Pd(n) {
                return n = W(n), n && ka.test(n) ? n.replace(Yi, ff) : n;
            }
            function Ad(n) {
                return n = W(n), n && io.test(n) ? n.replace(xr, "\\$&") : n;
            }
            var Cd = Wt(function(n, t, e) {
                return n + (e ? "-" : "") + t.toLowerCase();
            }), Id = Wt(function(n, t, e) {
                return n + (e ? " " : "") + t.toLowerCase();
            }), xd = mu("toLowerCase");
            function Ed(n, t, e) {
                n = W(n), t = R(t);
                var r = t ? Tt(n) : 0;
                if (!t || r >= t) return n;
                var s = (t - r) / 2;
                return Ve(We(s), e) + n + Ve(Ue(s), e);
            }
            function yd(n, t, e) {
                n = W(n), t = R(t);
                var r = t ? Tt(n) : 0;
                return t && r < t ? n + Ve(t - r, e) : n;
            }
            function Sd(n, t, e) {
                n = W(n), t = R(t);
                var r = t ? Tt(n) : 0;
                return t && r < t ? Ve(t - r, e) + n : n;
            }
            function Od(n, t, e) {
                return e || t == null ? t = 0 : t && (t = +t), Hf(W(n).replace(Er, ""), t || 0);
            }
            function Rd(n, t, e) {
                return (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t), ri(W(n), t);
            }
            function bd() {
                var n = arguments, t = W(n[0]);
                return n.length < 3 ? t : t.replace(n[1], n[2]);
            }
            var Td = Wt(function(n, t, e) {
                return n + (e ? "_" : "") + t.toLowerCase();
            });
            function Ld(n, t, e) {
                return e && typeof e != "number" && rn(n, t, e) && (t = e = i), e = e === i ? Hn : e >>> 0, e ? (n = W(n), n && (typeof t == "string" || t != null && !yi(t)) && (t = ln(t), !t && bt(n)) ? st(On(n), 0, e) : n.split(t, e)) : [];
            }
            var Dd = Wt(function(n, t, e) {
                return n + (e ? " " : "") + Ri(t);
            });
            function Nd(n, t, e) {
                return n = W(n), e = e == null ? 0 : dt(R(e), 0, n.length), t = ln(t), n.slice(e, e + t.length) == t;
            }
            function Hd(n, t, e) {
                var r = a.templateSettings;
                e && rn(n, t, e) && (t = i), n = W(n), t = fr({}, t, r, Eu);
                var s = fr({}, t.imports, r.imports, Eu), o = V(s), f = Mr(s, o), c, l, v = 0, _ = t.interpolate || Ce, m = "__p += '", P = Br((t.escape || Ce).source + "|" + _.source + "|" + (_ === Zi ? lo : Ce).source + "|" + (t.evaluate || Ce).source + "|$", "g"), I = "//# sourceURL=" + (F.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Go + "]") + `
`;
                n.replace(P, function(y, D, H, dn, sn, gn) {
                    return H || (H = dn), m += n.slice(v, gn).replace(Po, cf), D && (c = !0, m += `' +
__e(` + D + `) +
'`), sn && (l = !0, m += `';
` + sn + `;
__p += '`), H && (m += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), v = gn + y.length, y;
                }), m += `';
`;
                var E = F.call(t, "variable") && t.variable;
                if (!E) m = `with (obj) {
` + m + `
}
`;
                else if (co.test(E)) throw new S(En);
                m = (l ? m.replace(Ja, "") : m).replace(Xa, "$1").replace(Qa, "$1;"), m = "function(" + (E || "obj") + `) {
` + (E ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + m + `return __p
}`;
                var b = _a(function() {
                    return $(o, I + "return " + m).apply(i, f);
                });
                if (b.source = m, Ei(b)) throw b;
                return b;
            }
            function $d(n) {
                return W(n).toLowerCase();
            }
            function Ud(n) {
                return W(n).toUpperCase();
            }
            function Wd(n, t, e) {
                if (n = W(n), n && (e || t === i)) return ys(n);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = On(t), o = Ss(r, s), f = Os(r, s) + 1;
                return st(r, o, f).join("");
            }
            function Fd(n, t, e) {
                if (n = W(n), n && (e || t === i)) return n.slice(0, bs(n) + 1);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = Os(r, On(t)) + 1;
                return st(r, 0, s).join("");
            }
            function Md(n, t, e) {
                if (n = W(n), n && (e || t === i)) return n.replace(Er, "");
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = Ss(r, On(t));
                return st(r, s).join("");
            }
            function qd(n, t) {
                var e = La, r = Da;
                if (z(t)) {
                    var s = "separator" in t ? t.separator : s;
                    e = "length" in t ? R(t.length) : e, r = "omission" in t ? ln(t.omission) : r;
                }
                n = W(n);
                var o = n.length;
                if (bt(n)) {
                    var f = On(n);
                    o = f.length;
                }
                if (e >= o) return n;
                var c = e - Tt(r);
                if (c < 1) return r;
                var l = f ? st(f, 0, c).join("") : n.slice(0, c);
                if (s === i) return l + r;
                if (f && (c += l.length - c), yi(s)) {
                    if (n.slice(c).search(s)) {
                        var v, _ = l;
                        for(s.global || (s = Br(s.source, W(Ji.exec(s)) + "g")), s.lastIndex = 0; v = s.exec(_);)var m = v.index;
                        l = l.slice(0, m === i ? c : m);
                    }
                } else if (n.indexOf(ln(s), c) != c) {
                    var P = l.lastIndexOf(s);
                    P > -1 && (l = l.slice(0, P));
                }
                return l + r;
            }
            function Bd(n) {
                return n = W(n), n && Va.test(n) ? n.replace(Ki, _f) : n;
            }
            var Gd = Wt(function(n, t, e) {
                return n + (e ? " " : "") + t.toUpperCase();
            }), Ri = mu("toUpperCase");
            function va(n, t, e) {
                return n = W(n), t = e ? i : t, t === i ? lf(n) ? Pf(n) : ef(n) : n.match(t) || [];
            }
            var _a = L(function(n, t) {
                try {
                    return cn(n, i, t);
                } catch (e) {
                    return Ei(e) ? e : new S(e);
                }
            }), zd = Yn(function(n, t) {
                return mn(t, function(e) {
                    e = Wn(e), zn(n, e, Ii(n[e], n));
                }), n;
            });
            function Kd(n) {
                var t = n == null ? 0 : n.length, e = x();
                return n = t ? G(n, function(r) {
                    if (typeof r[1] != "function") throw new wn(U);
                    return [
                        e(r[0]),
                        r[1]
                    ];
                }) : [], L(function(r) {
                    for(var s = -1; ++s < t;){
                        var o = n[s];
                        if (cn(o[0], this, r)) return cn(o[1], this, r);
                    }
                });
            }
            function Yd(n) {
                return _c(An(n, Ln));
            }
            function bi(n) {
                return function() {
                    return n;
                };
            }
            function Zd(n, t) {
                return n == null || n !== n ? t : n;
            }
            var Jd = Pu(), Xd = Pu(!0);
            function fn(n) {
                return n;
            }
            function Ti(n) {
                return Qs(typeof n == "function" ? n : An(n, Ln));
            }
            function Qd(n) {
                return ks(An(n, Ln));
            }
            function Vd(n, t) {
                return js(n, An(t, Ln));
            }
            var kd = L(function(n, t) {
                return function(e) {
                    return ae(e, n, t);
                };
            }), jd = L(function(n, t) {
                return function(e) {
                    return ae(n, e, t);
                };
            });
            function Li(n, t, e) {
                var r = V(t), s = ze(t, r);
                e == null && !(z(t) && (s.length || !r.length)) && (e = t, t = n, n = this, s = ze(t, V(t)));
                var o = !(z(e) && "chain" in e) || !!e.chain, f = Jn(n);
                return mn(s, function(c) {
                    var l = t[c];
                    n[c] = l, f && (n.prototype[c] = function() {
                        var v = this.__chain__;
                        if (o || v) {
                            var _ = n(this.__wrapped__), m = _.__actions__ = un(this.__actions__);
                            return m.push({
                                func: l,
                                args: arguments,
                                thisArg: n
                            }), _.__chain__ = v, _;
                        }
                        return l.apply(n, jn([
                            this.value()
                        ], arguments));
                    });
                }), n;
            }
            function ng() {
                return k._ === this && (k._ = yf), this;
            }
            function Di() {}
            function tg(n) {
                return n = R(n), L(function(t) {
                    return nu(t, n);
                });
            }
            var eg = ci(G), rg = ci(As), ig = ci(Hr);
            function ma(n) {
                return _i(n) ? $r(Wn(n)) : Nc(n);
            }
            function sg(n) {
                return function(t) {
                    return n == null ? i : gt(n, t);
                };
            }
            var ug = Cu(), ag = Cu(!0);
            function Ni() {
                return [];
            }
            function Hi() {
                return !1;
            }
            function og() {
                return {};
            }
            function fg() {
                return "";
            }
            function cg() {
                return !0;
            }
            function hg(n, t) {
                if (n = R(n), n < 1 || n > Vn) return [];
                var e = Hn, r = nn(n, Hn);
                t = x(t), n -= Hn;
                for(var s = Fr(r, t); ++e < n;)t(e);
                return s;
            }
            function lg(n) {
                return O(n) ? G(n, Wn) : pn(n) ? [
                    n
                ] : un(Wu(W(n)));
            }
            function pg(n) {
                var t = ++xf;
                return W(n) + t;
            }
            var dg = Qe(function(n, t) {
                return n + t;
            }, 0), gg = hi("ceil"), vg = Qe(function(n, t) {
                return n / t;
            }, 1), _g = hi("floor");
            function mg(n) {
                return n && n.length ? Ge(n, fn, Qr) : i;
            }
            function wg(n, t) {
                return n && n.length ? Ge(n, x(t, 2), Qr) : i;
            }
            function Pg(n) {
                return xs(n, fn);
            }
            function Ag(n, t) {
                return xs(n, x(t, 2));
            }
            function Cg(n) {
                return n && n.length ? Ge(n, fn, ni) : i;
            }
            function Ig(n, t) {
                return n && n.length ? Ge(n, x(t, 2), ni) : i;
            }
            var xg = Qe(function(n, t) {
                return n * t;
            }, 1), Eg = hi("round"), yg = Qe(function(n, t) {
                return n - t;
            }, 0);
            function Sg(n) {
                return n && n.length ? Wr(n, fn) : 0;
            }
            function Og(n, t) {
                return n && n.length ? Wr(n, x(t, 2)) : 0;
            }
            return a.after = Ql, a.ary = Xu, a.assign = Up, a.assignIn = fa, a.assignInWith = fr, a.assignWith = Wp, a.at = Fp, a.before = Qu, a.bind = Ii, a.bindAll = zd, a.bindKey = Vu, a.castArray = op, a.chain = Yu, a.chunk = _h, a.compact = mh, a.concat = wh, a.cond = Kd, a.conforms = Yd, a.constant = bi, a.countBy = Sl, a.create = Mp, a.curry = ku, a.curryRight = ju, a.debounce = na, a.defaults = qp, a.defaultsDeep = Bp, a.defer = Vl, a.delay = kl, a.difference = Ph, a.differenceBy = Ah, a.differenceWith = Ch, a.drop = Ih, a.dropRight = xh, a.dropRightWhile = Eh, a.dropWhile = yh, a.fill = Sh, a.filter = Rl, a.flatMap = Ll, a.flatMapDeep = Dl, a.flatMapDepth = Nl, a.flatten = Bu, a.flattenDeep = Oh, a.flattenDepth = Rh, a.flip = jl, a.flow = Jd, a.flowRight = Xd, a.fromPairs = bh, a.functions = Xp, a.functionsIn = Qp, a.groupBy = Hl, a.initial = Lh, a.intersection = Dh, a.intersectionBy = Nh, a.intersectionWith = Hh, a.invert = kp, a.invertBy = jp, a.invokeMap = Ul, a.iteratee = Ti, a.keyBy = Wl, a.keys = V, a.keysIn = on, a.map = rr, a.mapKeys = td, a.mapValues = ed, a.matches = Qd, a.matchesProperty = Vd, a.memoize = sr, a.merge = rd, a.mergeWith = ca, a.method = kd, a.methodOf = jd, a.mixin = Li, a.negate = ur, a.nthArg = tg, a.omit = id, a.omitBy = sd, a.once = np, a.orderBy = Fl, a.over = eg, a.overArgs = tp, a.overEvery = rg, a.overSome = ig, a.partial = xi, a.partialRight = ta, a.partition = Ml, a.pick = ud, a.pickBy = ha, a.property = ma, a.propertyOf = sg, a.pull = Fh, a.pullAll = zu, a.pullAllBy = Mh, a.pullAllWith = qh, a.pullAt = Bh, a.range = ug, a.rangeRight = ag, a.rearg = ep, a.reject = Gl, a.remove = Gh, a.rest = rp, a.reverse = Ai, a.sampleSize = Kl, a.set = od, a.setWith = fd, a.shuffle = Yl, a.slice = zh, a.sortBy = Xl, a.sortedUniq = Vh, a.sortedUniqBy = kh, a.split = Ld, a.spread = ip, a.tail = jh, a.take = nl, a.takeRight = tl, a.takeRightWhile = el, a.takeWhile = rl, a.tap = ml, a.throttle = sp, a.thru = er, a.toArray = ua, a.toPairs = la, a.toPairsIn = pa, a.toPath = lg, a.toPlainObject = oa, a.transform = cd, a.unary = up, a.union = il, a.unionBy = sl, a.unionWith = ul, a.uniq = al, a.uniqBy = ol, a.uniqWith = fl, a.unset = hd, a.unzip = Ci, a.unzipWith = Ku, a.update = ld, a.updateWith = pd, a.values = qt, a.valuesIn = dd, a.without = cl, a.words = va, a.wrap = ap, a.xor = hl, a.xorBy = ll, a.xorWith = pl, a.zip = dl, a.zipObject = gl, a.zipObjectDeep = vl, a.zipWith = _l, a.entries = la, a.entriesIn = pa, a.extend = fa, a.extendWith = fr, Li(a, a), a.add = dg, a.attempt = _a, a.camelCase = md, a.capitalize = da, a.ceil = gg, a.clamp = gd, a.clone = fp, a.cloneDeep = hp, a.cloneDeepWith = lp, a.cloneWith = cp, a.conformsTo = pp, a.deburr = ga, a.defaultTo = Zd, a.divide = vg, a.endsWith = wd, a.eq = bn, a.escape = Pd, a.escapeRegExp = Ad, a.every = Ol, a.find = bl, a.findIndex = Mu, a.findKey = Gp, a.findLast = Tl, a.findLastIndex = qu, a.findLastKey = zp, a.floor = _g, a.forEach = Zu, a.forEachRight = Ju, a.forIn = Kp, a.forInRight = Yp, a.forOwn = Zp, a.forOwnRight = Jp, a.get = Si, a.gt = dp, a.gte = gp, a.has = Vp, a.hasIn = Oi, a.head = Gu, a.identity = fn, a.includes = $l, a.indexOf = Th, a.inRange = vd, a.invoke = nd, a.isArguments = mt, a.isArray = O, a.isArrayBuffer = vp, a.isArrayLike = an, a.isArrayLikeObject = Y, a.isBoolean = _p, a.isBuffer = ut, a.isDate = mp, a.isElement = wp, a.isEmpty = Pp, a.isEqual = Ap, a.isEqualWith = Cp, a.isError = Ei, a.isFinite = Ip, a.isFunction = Jn, a.isInteger = ea, a.isLength = ar, a.isMap = ra, a.isMatch = xp, a.isMatchWith = Ep, a.isNaN = yp, a.isNative = Sp, a.isNil = Rp, a.isNull = Op, a.isNumber = ia, a.isObject = z, a.isObjectLike = K, a.isPlainObject = pe, a.isRegExp = yi, a.isSafeInteger = bp, a.isSet = sa, a.isString = or, a.isSymbol = pn, a.isTypedArray = Mt, a.isUndefined = Tp, a.isWeakMap = Lp, a.isWeakSet = Dp, a.join = $h, a.kebabCase = Cd, a.last = In, a.lastIndexOf = Uh, a.lowerCase = Id, a.lowerFirst = xd, a.lt = Np, a.lte = Hp, a.max = mg, a.maxBy = wg, a.mean = Pg, a.meanBy = Ag, a.min = Cg, a.minBy = Ig, a.stubArray = Ni, a.stubFalse = Hi, a.stubObject = og, a.stubString = fg, a.stubTrue = cg, a.multiply = xg, a.nth = Wh, a.noConflict = ng, a.noop = Di, a.now = ir, a.pad = Ed, a.padEnd = yd, a.padStart = Sd, a.parseInt = Od, a.random = _d, a.reduce = ql, a.reduceRight = Bl, a.repeat = Rd, a.replace = bd, a.result = ad, a.round = Eg, a.runInContext = h, a.sample = zl, a.size = Zl, a.snakeCase = Td, a.some = Jl, a.sortedIndex = Kh, a.sortedIndexBy = Yh, a.sortedIndexOf = Zh, a.sortedLastIndex = Jh, a.sortedLastIndexBy = Xh, a.sortedLastIndexOf = Qh, a.startCase = Dd, a.startsWith = Nd, a.subtract = yg, a.sum = Sg, a.sumBy = Og, a.template = Hd, a.times = hg, a.toFinite = Xn, a.toInteger = R, a.toLength = aa, a.toLower = $d, a.toNumber = xn, a.toSafeInteger = $p, a.toString = W, a.toUpper = Ud, a.trim = Wd, a.trimEnd = Fd, a.trimStart = Md, a.truncate = qd, a.unescape = Bd, a.uniqueId = pg, a.upperCase = Gd, a.upperFirst = Ri, a.each = Zu, a.eachRight = Ju, a.first = Gu, Li(a, function() {
                var n = {};
                return $n(a, function(t, e) {
                    F.call(a.prototype, e) || (n[e] = t);
                }), n;
            }(), {
                chain: !1
            }), a.VERSION = d, mn([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(n) {
                a[n].placeholder = a;
            }), mn([
                "drop",
                "take"
            ], function(n, t) {
                N.prototype[n] = function(e) {
                    e = e === i ? 1 : Q(R(e), 0);
                    var r = this.__filtered__ && !t ? new N(this) : this.clone();
                    return r.__filtered__ ? r.__takeCount__ = nn(e, r.__takeCount__) : r.__views__.push({
                        size: nn(e, Hn),
                        type: n + (r.__dir__ < 0 ? "Right" : "")
                    }), r;
                }, N.prototype[n + "Right"] = function(e) {
                    return this.reverse()[n](e).reverse();
                };
            }), mn([
                "filter",
                "map",
                "takeWhile"
            ], function(n, t) {
                var e = t + 1, r = e == Bi || e == Ua;
                N.prototype[n] = function(s) {
                    var o = this.clone();
                    return o.__iteratees__.push({
                        iteratee: x(s, 3),
                        type: e
                    }), o.__filtered__ = o.__filtered__ || r, o;
                };
            }), mn([
                "head",
                "last"
            ], function(n, t) {
                var e = "take" + (t ? "Right" : "");
                N.prototype[n] = function() {
                    return this[e](1).value()[0];
                };
            }), mn([
                "initial",
                "tail"
            ], function(n, t) {
                var e = "drop" + (t ? "" : "Right");
                N.prototype[n] = function() {
                    return this.__filtered__ ? new N(this) : this[e](1);
                };
            }), N.prototype.compact = function() {
                return this.filter(fn);
            }, N.prototype.find = function(n) {
                return this.filter(n).head();
            }, N.prototype.findLast = function(n) {
                return this.reverse().find(n);
            }, N.prototype.invokeMap = L(function(n, t) {
                return typeof n == "function" ? new N(this) : this.map(function(e) {
                    return ae(e, n, t);
                });
            }), N.prototype.reject = function(n) {
                return this.filter(ur(x(n)));
            }, N.prototype.slice = function(n, t) {
                n = R(n);
                var e = this;
                return e.__filtered__ && (n > 0 || t < 0) ? new N(e) : (n < 0 ? e = e.takeRight(-n) : n && (e = e.drop(n)), t !== i && (t = R(t), e = t < 0 ? e.dropRight(-t) : e.take(t - n)), e);
            }, N.prototype.takeRightWhile = function(n) {
                return this.reverse().takeWhile(n).reverse();
            }, N.prototype.toArray = function() {
                return this.take(Hn);
            }, $n(N.prototype, function(n, t) {
                var e = /^(?:filter|find|map|reject)|While$/.test(t), r = /^(?:head|last)$/.test(t), s = a[r ? "take" + (t == "last" ? "Right" : "") : t], o = r || /^find/.test(t);
                s && (a.prototype[t] = function() {
                    var f = this.__wrapped__, c = r ? [
                        1
                    ] : arguments, l = f instanceof N, v = c[0], _ = l || O(f), m = function(D) {
                        var H = s.apply(a, jn([
                            D
                        ], c));
                        return r && P ? H[0] : H;
                    };
                    _ && e && typeof v == "function" && v.length != 1 && (l = _ = !1);
                    var P = this.__chain__, I = !!this.__actions__.length, E = o && !P, b = l && !I;
                    if (!o && _) {
                        f = b ? f : new N(this);
                        var y = n.apply(f, c);
                        return y.__actions__.push({
                            func: er,
                            args: [
                                m
                            ],
                            thisArg: i
                        }), new Pn(y, P);
                    }
                    return E && b ? n.apply(this, c) : (y = this.thru(m), E ? r ? y.value()[0] : y.value() : y);
                });
            }), mn([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(n) {
                var t = Oe[n], e = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(n);
                a.prototype[n] = function() {
                    var s = arguments;
                    if (r && !this.__chain__) {
                        var o = this.value();
                        return t.apply(O(o) ? o : [], s);
                    }
                    return this[e](function(f) {
                        return t.apply(O(f) ? f : [], s);
                    });
                };
            }), $n(N.prototype, function(n, t) {
                var e = a[t];
                if (e) {
                    var r = e.name + "";
                    F.call(Ht, r) || (Ht[r] = []), Ht[r].push({
                        name: t,
                        func: e
                    });
                }
            }), Ht[Xe(i, ot).name] = [
                {
                    name: "wrapper",
                    func: i
                }
            ], N.prototype.clone = Bf, N.prototype.reverse = Gf, N.prototype.value = zf, a.prototype.at = wl, a.prototype.chain = Pl, a.prototype.commit = Al, a.prototype.next = Cl, a.prototype.plant = xl, a.prototype.reverse = El, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = yl, a.prototype.first = a.prototype.head, ne && (a.prototype[ne] = Il), a;
        }, Lt = Af();
        ct ? ((ct.exports = Lt)._ = Lt, Tr._ = Lt) : k._ = Lt;
    }).call($253fb4de41dc743b$var$ge);
})($253fb4de41dc743b$var$Ui, $253fb4de41dc743b$var$Ui.exports);
var $253fb4de41dc743b$var$qg = Object.defineProperty, $253fb4de41dc743b$var$Bg = Object.defineProperties, $253fb4de41dc743b$var$Gg = Object.getOwnPropertyDescriptors, $253fb4de41dc743b$var$Ea = Object.getOwnPropertySymbols, $253fb4de41dc743b$var$zg = Object.prototype.hasOwnProperty, $253fb4de41dc743b$var$Kg = Object.prototype.propertyIsEnumerable, $253fb4de41dc743b$var$ya = (C, u, i)=>u in C ? $253fb4de41dc743b$var$qg(C, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : C[u] = i, $253fb4de41dc743b$var$cr = (C, u)=>{
    for(var i in u || (u = {}))$253fb4de41dc743b$var$zg.call(u, i) && $253fb4de41dc743b$var$ya(C, i, u[i]);
    if ($253fb4de41dc743b$var$Ea) for (var i of $253fb4de41dc743b$var$Ea(u))$253fb4de41dc743b$var$Kg.call(u, i) && $253fb4de41dc743b$var$ya(C, i, u[i]);
    return C;
}, $253fb4de41dc743b$var$Yg = (C, u)=>$253fb4de41dc743b$var$Bg(C, $253fb4de41dc743b$var$Gg(u));
function $253fb4de41dc743b$var$Gt(C, u, i) {
    var d;
    const w = (0, $eeGmU.parseChainId)(C);
    return ((d = u.rpcMap) == null ? void 0 : d[w.reference]) || `${$253fb4de41dc743b$var$Mg}?chainId=${w.namespace}:${w.reference}&projectId=${i}`;
}
function $253fb4de41dc743b$var$Pt(C) {
    return C.includes(":") ? C.split(":")[1] : C;
}
function $253fb4de41dc743b$var$Sa(C) {
    return C.map((u)=>`${u.split(":")[0]}:${u.split(":")[1]}`);
}
function $253fb4de41dc743b$var$Zg(C, u) {
    const i = Object.keys(u.namespaces).filter((w)=>w.includes(C));
    if (!i.length) return [];
    const d = [];
    return i.forEach((w)=>{
        const T = u.namespaces[w].accounts;
        d.push(...T);
    }), d;
}
function $253fb4de41dc743b$var$Jg(C = {}, u = {}) {
    const i = $253fb4de41dc743b$var$Oa(C), d = $253fb4de41dc743b$var$Oa(u);
    return $253fb4de41dc743b$var$Ui.exports.merge(i, d);
}
function $253fb4de41dc743b$var$Oa(C) {
    var u, i, d, w;
    const T = {};
    if (!(0, $eeGmU.isValidObject)(C)) return T;
    for (const [U, En] of Object.entries(C)){
        const zt = (0, $eeGmU.isCaipNamespace)(U) ? [
            U
        ] : En.chains, pr = En.methods || [], At = En.events || [], Ln = En.rpcMap || {}, Fn = (0, $eeGmU.parseNamespaceKey)(U);
        T[Fn] = $253fb4de41dc743b$var$Yg($253fb4de41dc743b$var$cr($253fb4de41dc743b$var$cr({}, T[Fn]), En), {
            chains: (0, $eeGmU.mergeArrays)(zt, (u = T[Fn]) == null ? void 0 : u.chains),
            methods: (0, $eeGmU.mergeArrays)(pr, (i = T[Fn]) == null ? void 0 : i.methods),
            events: (0, $eeGmU.mergeArrays)(At, (d = T[Fn]) == null ? void 0 : d.events),
            rpcMap: $253fb4de41dc743b$var$cr($253fb4de41dc743b$var$cr({}, Ln), (w = T[Fn]) == null ? void 0 : w.rpcMap)
        });
    }
    return T;
}
function $253fb4de41dc743b$var$Xg(C) {
    return C.includes(":") ? C.split(":")[2] : C;
}
function $253fb4de41dc743b$var$Qg(C) {
    const u = {};
    for (const [i, d] of Object.entries(C)){
        const w = d.methods || [], T = d.events || [], U = d.accounts || [], En = (0, $eeGmU.isCaipNamespace)(i) ? [
            i
        ] : d.chains ? d.chains : $253fb4de41dc743b$var$Sa(d.accounts);
        u[i] = {
            chains: En,
            methods: w,
            events: T,
            accounts: U
        };
    }
    return u;
}
function $253fb4de41dc743b$var$Wi(C) {
    return typeof C == "number" ? C : C.includes("0x") ? parseInt(C, 16) : C.includes(":") ? Number(C.split(":")[1]) : Number(C);
}
const $253fb4de41dc743b$var$Ra = {}, $253fb4de41dc743b$var$J = (C)=>$253fb4de41dc743b$var$Ra[C], $253fb4de41dc743b$var$Fi = (C, u)=>{
    $253fb4de41dc743b$var$Ra[C] = u;
};
class $253fb4de41dc743b$var$Vg {
    constructor(u){
        this.name = "polkadot", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var d;
            const w = $253fb4de41dc743b$var$Pt(i);
            u[w] = this.createHttpProvider(w, (d = this.namespace.rpcMap) == null ? void 0 : d[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProvider(u, i) {
        const d = i || $253fb4de41dc743b$var$Gt(u, this.namespace, this.client.core.projectId);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $dHHSL.default)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$kg {
    constructor(u){
        this.name = "eip155", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(u) {
        switch(u.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(u);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
        }
        return this.namespace.methods.includes(u.request.method) ? await this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(parseInt(u), i), this.chainId = parseInt(u), this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    createHttpProvider(u, i) {
        const d = i || $253fb4de41dc743b$var$Gt(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $iIS2Z.HttpConnection)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var d;
            const w = parseInt($253fb4de41dc743b$var$Pt(i));
            u[w] = this.createHttpProvider(w, (d = this.namespace.rpcMap) == null ? void 0 : d[i]);
        }), u;
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const u = this.chainId, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    async handleSwitchChain(u) {
        var i, d;
        let w = u.request.params ? (i = u.request.params[0]) == null ? void 0 : i.chainId : "0x0";
        w = w.startsWith("0x") ? w : `0x${w}`;
        const T = parseInt(w, 16);
        if (this.isChainApproved(T)) this.setDefaultChain(`${T}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: u.topic,
            request: {
                method: u.request.method,
                params: [
                    {
                        chainId: w
                    }
                ]
            },
            chainId: (d = this.namespace.chains) == null ? void 0 : d[0]
        }), this.setDefaultChain(`${T}`);
        else throw new Error(`Failed to switch to chain 'eip155:${T}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(u) {
        return this.namespace.chains.includes(`${this.name}:${u}`);
    }
}
class $253fb4de41dc743b$var$jg {
    constructor(u){
        this.name = "solana", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var d;
            const w = $253fb4de41dc743b$var$Pt(i);
            u[w] = this.createHttpProvider(w, (d = this.namespace.rpcMap) == null ? void 0 : d[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProvider(u, i) {
        const d = i || $253fb4de41dc743b$var$Gt(u, this.namespace, this.client.core.projectId);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $dHHSL.default)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$nv {
    constructor(u){
        this.name = "cosmos", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var d;
            const w = $253fb4de41dc743b$var$Pt(i);
            u[w] = this.createHttpProvider(w, (d = this.namespace.rpcMap) == null ? void 0 : d[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProvider(u, i) {
        const d = i || $253fb4de41dc743b$var$Gt(u, this.namespace, this.client.core.projectId);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $dHHSL.default)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$tv {
    constructor(u){
        this.name = "cip34", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            const d = this.getCardanoRPCUrl(i), w = $253fb4de41dc743b$var$Pt(i);
            u[w] = this.createHttpProvider(w, d);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    getCardanoRPCUrl(u) {
        const i = this.namespace.rpcMap;
        if (i) return i[u];
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProvider(u, i) {
        const d = i || this.getCardanoRPCUrl(u);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $dHHSL.default)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$ev {
    constructor(u){
        this.name = "elrond", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var d;
            const w = $253fb4de41dc743b$var$Pt(i);
            u[w] = this.createHttpProvider(w, (d = this.namespace.rpcMap) == null ? void 0 : d[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProvider(u, i) {
        const d = i || $253fb4de41dc743b$var$Gt(u, this.namespace, this.client.core.projectId);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $dHHSL.default)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$rv {
    constructor(u){
        this.name = "multiversx", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var d;
            const w = $253fb4de41dc743b$var$Pt(i);
            u[w] = this.createHttpProvider(w, (d = this.namespace.rpcMap) == null ? void 0 : d[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const d = this.createHttpProvider(u, i);
        d && (this.httpProviders[u] = d);
    }
    createHttpProvider(u, i) {
        const d = i || $253fb4de41dc743b$var$Gt(u, this.namespace, this.client.core.projectId);
        if (!d) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $1QugC.JsonRpcProvider)(new (0, $dHHSL.default)(d, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
var $253fb4de41dc743b$var$iv = Object.defineProperty, $253fb4de41dc743b$var$sv = Object.defineProperties, $253fb4de41dc743b$var$uv = Object.getOwnPropertyDescriptors, $253fb4de41dc743b$var$ba = Object.getOwnPropertySymbols, $253fb4de41dc743b$var$av = Object.prototype.hasOwnProperty, $253fb4de41dc743b$var$ov = Object.prototype.propertyIsEnumerable, $253fb4de41dc743b$var$Ta = (C, u, i)=>u in C ? $253fb4de41dc743b$var$iv(C, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : C[u] = i, $253fb4de41dc743b$var$hr = (C, u)=>{
    for(var i in u || (u = {}))$253fb4de41dc743b$var$av.call(u, i) && $253fb4de41dc743b$var$Ta(C, i, u[i]);
    if ($253fb4de41dc743b$var$ba) for (var i of $253fb4de41dc743b$var$ba(u))$253fb4de41dc743b$var$ov.call(u, i) && $253fb4de41dc743b$var$Ta(C, i, u[i]);
    return C;
}, $253fb4de41dc743b$var$Mi = (C, u)=>$253fb4de41dc743b$var$sv(C, $253fb4de41dc743b$var$uv(u));
class $253fb4de41dc743b$export$2e2bcd8739ae039 {
    constructor(u){
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = u, this.logger = typeof u?.logger < "u" && typeof u?.logger != "string" ? u.logger : (0, $aY1FL.pino)((0, $aY1FL.getDefaultLoggerOptions)({
            level: u?.logger || $253fb4de41dc743b$var$Ia
        })), this.disableProviderPing = u?.disableProviderPing || !1;
    }
    static async init(u) {
        const i = new $253fb4de41dc743b$export$2e2bcd8739ae039(u);
        return await i.initialize(), i;
    }
    async request(u, i) {
        const [d, w] = this.validateChain(i);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(d).request({
            request: $253fb4de41dc743b$var$hr({}, u),
            chainId: `${d}:${w}`,
            topic: this.session.topic
        });
    }
    sendAsync(u, i, d) {
        this.request(u, d).then((w)=>i(null, w)).catch((w)=>i(w, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var u;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (u = this.session) == null ? void 0 : u.topic,
            reason: (0, $eeGmU.getSdkError)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(u) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(u), await this.cleanupPendingPairings(), !u.skipPairing) return await this.pair(u.pairingTopic);
    }
    on(u, i) {
        this.events.on(u, i);
    }
    once(u, i) {
        this.events.once(u, i);
    }
    removeListener(u, i) {
        this.events.removeListener(u, i);
    }
    off(u, i) {
        this.events.off(u, i);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(u) {
        this.shouldAbortPairingAttempt = !1;
        let i = 0;
        do {
            if (this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
            if (i >= this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
            const { uri: d, approval: w } = await this.client.connect({
                pairingTopic: u,
                requiredNamespaces: this.namespaces,
                optionalNamespaces: this.optionalNamespaces,
                sessionProperties: this.sessionProperties
            });
            d && (this.uri = d, this.events.emit("display_uri", d)), await w().then((T)=>{
                this.session = T, this.namespaces || (this.namespaces = $253fb4de41dc743b$var$Qg(T.namespaces), this.persist("namespaces", this.namespaces));
            }).catch((T)=>{
                if (T.message !== (0, $6nnA0.PROPOSAL_EXPIRY_MESSAGE)) throw T;
                i++;
            });
        }while (!this.session);
        return this.onConnect(), this.session;
    }
    setDefaultChain(u, i) {
        try {
            if (!this.session) return;
            const [d, w] = this.validateChain(u);
            this.getProvider(d).setDefaultChain(w, i);
        } catch (d) {
            if (!/Please call connect/.test(d.message)) throw d;
        }
    }
    async cleanupPendingPairings(u = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const i = this.client.pairing.getAll();
        if ((0, $eeGmU.isValidArray)(i)) {
            for (const d of i)u.deletePairings ? this.client.core.expirer.set(d.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(d.topic);
            this.logger.info(`Inactive pairings cleared: ${i.length}`);
        }
    }
    abortPairingAttempt() {
        this.shouldAbortPairingAttempt = !0;
    }
    async checkStorage() {
        if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
            const u = this.client.session.keys.length - 1;
            this.session = this.client.session.get(this.client.session.keys[u]), this.createProviders();
        }
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        this.client = this.providerOpts.client || await (0, $6nnA0.default).init({
            logger: this.providerOpts.logger || $253fb4de41dc743b$var$Ia,
            relayUrl: this.providerOpts.relayUrl || $253fb4de41dc743b$var$Ug,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name
        }), this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const u = [
            ...new Set(Object.keys(this.session.namespaces).map((i)=>(0, $eeGmU.parseNamespaceKey)(i)))
        ];
        $253fb4de41dc743b$var$Fi("client", this.client), $253fb4de41dc743b$var$Fi("events", this.events), $253fb4de41dc743b$var$Fi("disableProviderPing", this.disableProviderPing), u.forEach((i)=>{
            if (!this.session) return;
            const d = $253fb4de41dc743b$var$Zg(i, this.session), w = $253fb4de41dc743b$var$Sa(d), T = $253fb4de41dc743b$var$Jg(this.namespaces, this.optionalNamespaces), U = $253fb4de41dc743b$var$Mi($253fb4de41dc743b$var$hr({}, T[i]), {
                accounts: d,
                chains: w
            });
            switch(i){
                case "eip155":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$kg({
                        namespace: U
                    });
                    break;
                case "solana":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$jg({
                        namespace: U
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$nv({
                        namespace: U
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Vg({
                        namespace: U
                    });
                    break;
                case "cip34":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$tv({
                        namespace: U
                    });
                    break;
                case "elrond":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$ev({
                        namespace: U
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$rv({
                        namespace: U
                    });
                    break;
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (u)=>{
            this.events.emit("session_ping", u);
        }), this.client.on("session_event", (u)=>{
            const { params: i } = u, { event: d } = i;
            if (d.name === "accountsChanged") {
                const w = d.data;
                w && (0, $eeGmU.isValidArray)(w) && this.events.emit("accountsChanged", w.map($253fb4de41dc743b$var$Xg));
            } else if (d.name === "chainChanged") {
                const w = i.chainId, T = i.event.data, U = (0, $eeGmU.parseNamespaceKey)(w), En = $253fb4de41dc743b$var$Wi(w) !== $253fb4de41dc743b$var$Wi(T) ? `${U}:${$253fb4de41dc743b$var$Wi(T)}` : w;
                this.onChainChanged(En);
            } else this.events.emit(d.name, d.data);
            this.events.emit("session_event", u);
        }), this.client.on("session_update", ({ topic: u, params: i })=>{
            var d;
            const { namespaces: w } = i, T = (d = this.client) == null ? void 0 : d.session.get(u);
            this.session = $253fb4de41dc743b$var$Mi($253fb4de41dc743b$var$hr({}, T), {
                namespaces: w
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: u,
                params: i
            });
        }), this.client.on("session_delete", async (u)=>{
            await this.cleanup(), this.events.emit("session_delete", u), this.events.emit("disconnect", $253fb4de41dc743b$var$Mi($253fb4de41dc743b$var$hr({}, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), {
                data: u.topic
            }));
        }), this.on($253fb4de41dc743b$var$at.DEFAULT_CHAIN_CHANGED, (u)=>{
            this.onChainChanged(u, !0);
        });
    }
    getProvider(u) {
        if (!this.rpcProviders[u]) throw new Error(`Provider not found: ${u}`);
        return this.rpcProviders[u];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((u)=>{
            var i;
            this.getProvider(u).updateNamespace((i = this.session) == null ? void 0 : i.namespaces[u]);
        });
    }
    setNamespaces(u) {
        const { namespaces: i, optionalNamespaces: d, sessionProperties: w } = u;
        i && Object.keys(i).length && (this.namespaces = i), d && Object.keys(d).length && (this.optionalNamespaces = d), this.sessionProperties = w, this.persist("namespaces", i), this.persist("optionalNamespaces", d);
    }
    validateChain(u) {
        const [i, d] = u?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            i,
            d
        ];
        if (i && !Object.keys(this.namespaces || {}).map((U)=>(0, $eeGmU.parseNamespaceKey)(U)).includes(i)) throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);
        if (i && d) return [
            i,
            d
        ];
        const w = (0, $eeGmU.parseNamespaceKey)(Object.keys(this.namespaces)[0]), T = this.rpcProviders[w].getDefaultChain();
        return [
            w,
            T
        ];
    }
    async requestAccounts() {
        const [u] = this.validateChain();
        return await this.getProvider(u).requestAccounts();
    }
    onChainChanged(u, i = !1) {
        var d;
        if (!this.namespaces) return;
        const [w, T] = this.validateChain(u);
        i || this.getProvider(w).setDefaultChain(T), ((d = this.namespaces[w]) != null ? d : this.namespaces[`${w}:${T}`]).defaultChain = T, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", T);
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({
            deletePairings: !0
        });
    }
    persist(u, i) {
        this.client.core.storage.setItem(`${$253fb4de41dc743b$var$xa}/${u}`, i);
    }
    async getFromStore(u) {
        return await this.client.core.storage.getItem(`${$253fb4de41dc743b$var$xa}/${u}`);
    }
}
const $253fb4de41dc743b$export$63bc40680ab52599 = $253fb4de41dc743b$export$2e2bcd8739ae039;

});
parcelRequire.register("6nnA0", function(module, exports) {

$parcel$export(module.exports, "PROPOSAL_EXPIRY_MESSAGE", () => $4a472e843fedf2e2$export$1e6a4dc5172f4830);
$parcel$export(module.exports, "default", () => $4a472e843fedf2e2$export$2e2bcd8739ae039);

var $k4ZW9 = parcelRequire("k4ZW9");

var $aY1FL = parcelRequire("aY1FL");

var $g2mSD = parcelRequire("g2mSD");

var $eeGmU = parcelRequire("eeGmU");

var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");
parcelRequire("2KWby");
var $57Nk6 = parcelRequire("57Nk6");
var $3YiWF = parcelRequire("3YiWF");
const $4a472e843fedf2e2$export$4fa962fc67384e02 = "wc", $4a472e843fedf2e2$export$61085c48796ff049 = 2, $4a472e843fedf2e2$export$94715592c220319a = "client", $4a472e843fedf2e2$export$7fa6f9ee1e2cab96 = `${$4a472e843fedf2e2$export$4fa962fc67384e02}@${$4a472e843fedf2e2$export$61085c48796ff049}:${$4a472e843fedf2e2$export$94715592c220319a}:`, $4a472e843fedf2e2$export$8dffb3242f2c5f72 = {
    name: $4a472e843fedf2e2$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $4a472e843fedf2e2$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire"
}, $4a472e843fedf2e2$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $4a472e843fedf2e2$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $4a472e843fedf2e2$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $4a472e843fedf2e2$export$160142c73cb99dc3 = "history", $4a472e843fedf2e2$export$8eba9ce85616c607 = "0.3", $4a472e843fedf2e2$export$ae6c7a4f7ed730a1 = "proposal", $4a472e843fedf2e2$export$6db28e89b135a53c = (0, $aG48A.THIRTY_DAYS), $4a472e843fedf2e2$export$1e6a4dc5172f4830 = "Proposal expired", $4a472e843fedf2e2$export$a069e98a8dfeec1e = "session", $4a472e843fedf2e2$export$84b1b9dbcdea0475 = (0, $aG48A.SEVEN_DAYS), $4a472e843fedf2e2$export$2db42d5151ad6eb8 = "engine", $4a472e843fedf2e2$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, $4a472e843fedf2e2$export$409f0c0a13a1b7c6 = {
    min: (0, $aG48A.FIVE_MINUTES),
    max: (0, $aG48A.SEVEN_DAYS)
}, $4a472e843fedf2e2$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $4a472e843fedf2e2$export$40b296af21bd38a4 = "request", $4a472e843fedf2e2$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $4a472e843fedf2e2$var$ns = Object.defineProperty, $4a472e843fedf2e2$var$os = Object.defineProperties, $4a472e843fedf2e2$var$as = Object.getOwnPropertyDescriptors, $4a472e843fedf2e2$var$he = Object.getOwnPropertySymbols, $4a472e843fedf2e2$var$cs = Object.prototype.hasOwnProperty, $4a472e843fedf2e2$var$ls = Object.prototype.propertyIsEnumerable, $4a472e843fedf2e2$var$de = (m, r, e)=>r in m ? $4a472e843fedf2e2$var$ns(m, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : m[r] = e, $4a472e843fedf2e2$var$g = (m, r)=>{
    for(var e in r || (r = {}))$4a472e843fedf2e2$var$cs.call(r, e) && $4a472e843fedf2e2$var$de(m, e, r[e]);
    if ($4a472e843fedf2e2$var$he) for (var e of $4a472e843fedf2e2$var$he(r))$4a472e843fedf2e2$var$ls.call(r, e) && $4a472e843fedf2e2$var$de(m, e, r[e]);
    return m;
}, $4a472e843fedf2e2$var$b = (m, r)=>$4a472e843fedf2e2$var$os(m, $4a472e843fedf2e2$var$as(r));
class $4a472e843fedf2e2$var$ps extends (0, $g2mSD.IEngine) {
    constructor(r){
        super(r), this.name = $4a472e843fedf2e2$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $eeGmU.TYPE_1)
        ], this.requestQueue = {
            state: $4a472e843fedf2e2$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $4a472e843fedf2e2$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $aG48A.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($4a472e843fedf2e2$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            await this.isInitialized();
            const s = $4a472e843fedf2e2$var$b($4a472e843fedf2e2$var$g({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let c = t, p, d = !1;
            if (c && (d = this.client.core.pairing.pairings.get(c).active), !c || !d) {
                const { topic: v, uri: S } = await this.client.core.pairing.create();
                c = v, p = S;
            }
            const h = await this.client.core.crypto.generateKeyPair(), R = $4a472e843fedf2e2$var$g({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, $k4ZW9.RELAYER_DEFAULT_PROTOCOL)
                    }
                ],
                proposer: {
                    publicKey: h,
                    metadata: this.client.metadata
                }
            }, o && {
                sessionProperties: o
            }), { reject: w, resolve: T, done: K } = (0, $eeGmU.createDelayedPromise)((0, $aG48A.FIVE_MINUTES), $4a472e843fedf2e2$export$1e6a4dc5172f4830);
            if (this.events.once((0, $eeGmU.engineEvent)("session_connect"), async ({ error: v, session: S })=>{
                if (v) w(v);
                else if (S) {
                    S.self.publicKey = h;
                    const B = $4a472e843fedf2e2$var$b($4a472e843fedf2e2$var$g({}, S), {
                        requiredNamespaces: S.requiredNamespaces,
                        optionalNamespaces: S.optionalNamespaces
                    });
                    await this.client.session.set(S.topic, B), await this.setExpiry(S.topic, S.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: S.peer.metadata
                    }), T(B);
                }
            }), !c) {
                const { message: v } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(v);
            }
            const L = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: R
            }), ue = (0, $eeGmU.calcExpiry)((0, $aG48A.FIVE_MINUTES));
            return await this.setProposal(L, $4a472e843fedf2e2$var$g({
                id: L,
                expiry: ue
            }, R)), {
                uri: p,
                approval: K
            };
        }, this.pair = async (e)=>(await this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            await this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: c, requiredNamespaces: p, optionalNamespaces: d } = o;
            a = a || "", (0, $eeGmU.isValidObject)(p) || (p = (0, $eeGmU.getRequiredNamespacesFromNamespaces)(i, "approve()"));
            const h = await this.client.core.crypto.generateKeyPair(), R = c.publicKey, w = await this.client.core.crypto.generateSharedKey(h, R);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: c.metadata
            }), await this.sendResult({
                id: s,
                topic: a,
                result: {
                    relay: {
                        protocol: t ?? "irn"
                    },
                    responderPublicKey: h
                }
            }), await this.client.proposal.delete(s, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const T = $4a472e843fedf2e2$var$g({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                requiredNamespaces: p,
                optionalNamespaces: d,
                pairingTopic: a,
                controller: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiry: (0, $eeGmU.calcExpiry)($4a472e843fedf2e2$export$84b1b9dbcdea0475)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(w), await this.sendRequest({
                topic: w,
                method: "wc_sessionSettle",
                params: T,
                throwOnFailedPublish: !0
            });
            const K = $4a472e843fedf2e2$var$b($4a472e843fedf2e2$var$g({}, T), {
                topic: w,
                pairingTopic: a,
                acknowledged: !1,
                self: T.controller,
                peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                },
                controller: h
            });
            return await this.client.session.set(w, K), await this.setExpiry(w, (0, $eeGmU.calcExpiry)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                topic: w,
                acknowledged: ()=>new Promise((L)=>setTimeout(()=>L(this.client.session.get(w)), 500))
            };
        }, this.reject = async (e)=>{
            await this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            await this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest({
                topic: s,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: t
                }
            }), { done: n, resolve: o, reject: a } = (0, $eeGmU.createDelayedPromise)();
            return this.events.once((0, $eeGmU.engineEvent)("session_update", i), ({ error: c })=>{
                c ? a(c) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            await this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest({
                topic: s,
                method: "wc_sessionExtend",
                params: {}
            }), { done: i, resolve: n, reject: o } = (0, $eeGmU.createDelayedPromise)();
            return this.events.once((0, $eeGmU.engineEvent)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, $eeGmU.calcExpiry)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            await this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n } = e, o = (0, $57Nk6.payloadId)(), { done: a, resolve: c, reject: p } = (0, $eeGmU.createDelayedPromise)(n);
            return this.events.once((0, $eeGmU.engineEvent)("session_request", o), ({ error: d, result: h })=>{
                d ? p(d) : c(h);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: o,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: t,
                            chainId: s
                        },
                        expiry: n,
                        throwOnFailedPublish: !0
                    }).catch((h)=>p(h)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: t,
                        chainId: s,
                        id: o
                    }), d();
                }),
                new Promise(async (d)=>{
                    const h = await this.client.core.storage.getItem($4a472e843fedf2e2$export$a26ccd6441b7d638);
                    (0, $eeGmU.handleDeeplinkRedirect)({
                        id: o,
                        topic: i,
                        wcDeepLink: h
                    }), d();
                }),
                a()
            ]).then((d)=>d[2]);
        }, this.respond = async (e)=>{
            await this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, $3YiWF.isJsonRpcResult)(t) ? await this.sendResult({
                id: i,
                topic: s,
                result: t.result,
                throwOnFailedPublish: !0
            }) : (0, $3YiWF.isJsonRpcError)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            await this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest({
                    topic: s,
                    method: "wc_sessionPing",
                    params: {}
                }), { done: i, resolve: n, reject: o } = (0, $eeGmU.createDelayedPromise)();
                this.events.once((0, $eeGmU.engineEvent)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            await this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest({
                topic: s,
                method: "wc_sessionEvent",
                params: {
                    event: t,
                    chainId: i
                }
            });
        }, this.disconnect = async (e)=>{
            await this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            this.client.session.keys.includes(s) ? (await this.sendRequest({
                topic: s,
                method: "wc_sessionDelete",
                params: (0, $eeGmU.getSdkError)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession(s)) : await this.client.core.pairing.disconnect({
                topic: s
            });
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, $eeGmU.isSessionCompatible)(s, e))), this.getPendingSessionRequests = ()=>(this.isInitialized(), this.client.pendingRequest.getAll()), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e, s)=>{
            const { self: t } = this.client.session.get(e);
            await this.client.core.relayer.unsubscribe(e), this.client.session.delete(e, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(t.publicKey) && await this.client.core.crypto.deleteKeyPair(t.publicKey), this.client.core.crypto.keychain.has(e) && await this.client.core.crypto.deleteSymKey(e), s || this.client.core.expirer.del(e), this.client.core.storage.removeItem($4a472e843fedf2e2$export$a26ccd6441b7d638).catch((i)=>this.client.logger.warn(i));
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), t && (this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle);
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, s.expiry);
        }, this.setPendingSessionRequest = async (e)=>{
            const s = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl, { id: t, topic: i, params: n, verifyContext: o } = e;
            await this.client.pendingRequest.set(t, {
                id: t,
                topic: i,
                params: n,
                verifyContext: o
            }), s && this.client.core.expirer.set(t, (0, $eeGmU.calcExpiry)(s));
        }, this.sendRequest = async (e)=>{
            const { topic: s, method: t, params: i, expiry: n, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = e, p = (0, $57Nk6.formatJsonRpcRequest)(t, i, a);
            if ((0, $eeGmU.isBrowser)() && $4a472e843fedf2e2$export$63c37d8ae5931ad5.includes(t)) {
                const R = (0, $eeGmU.hashMessage)(JSON.stringify(p));
                this.client.core.verify.register({
                    attestationId: R
                });
            }
            const d = await this.client.core.crypto.encode(s, p), h = $4a472e843fedf2e2$export$4edb1ca37014192d[t].req;
            return n && (h.ttl = n), o && (h.id = o), this.client.core.history.set(s, p), c ? (h.internal = $4a472e843fedf2e2$var$b($4a472e843fedf2e2$var$g({}, h.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, d, h)) : this.client.core.relayer.publish(s, d, h).catch((R)=>this.client.logger.error(R)), p.id;
        }, this.sendResult = async (e)=>{
            const { id: s, topic: t, result: i, throwOnFailedPublish: n } = e, o = (0, $57Nk6.formatJsonRpcResult)(s, i), a = await this.client.core.crypto.encode(t, o), c = await this.client.core.history.get(t, s), p = $4a472e843fedf2e2$export$4edb1ca37014192d[c.request.method].res;
            n ? (p.internal = $4a472e843fedf2e2$var$b($4a472e843fedf2e2$var$g({}, p.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(t, a, p)) : this.client.core.relayer.publish(t, a, p).catch((d)=>this.client.logger.error(d)), await this.client.core.history.resolve(o);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, $57Nk6.formatJsonRpcError)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $4a472e843fedf2e2$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                (0, $eeGmU.isExpired)(t.expiry) && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $eeGmU.isExpired)(t.expiry) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession(t)),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $4a472e843fedf2e2$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    this.processRequest(e), await new Promise((s)=>setTimeout(s, 300));
                } catch (s) {
                    this.client.logger.warn(s);
                }
            }
            this.requestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle;
        }, this.processRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect($4a472e843fedf2e2$var$g({}, s.params));
                const n = (0, $eeGmU.calcExpiry)((0, $aG48A.FIVE_MINUTES)), o = $4a472e843fedf2e2$var$g({
                    id: i,
                    pairingTopic: e,
                    expiry: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, $eeGmU.hashMessage)(JSON.stringify(s)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, $3YiWF.isJsonRpcResult)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const p = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: p
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, $3YiWF.isJsonRpcError)(s) && (await this.client.proposal.delete(t, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, $eeGmU.engineEvent)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: c, requiredNamespaces: p, optionalNamespaces: d, sessionProperties: h, pairingTopic: R } = s.params, w = $4a472e843fedf2e2$var$g({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: R,
                    requiredNamespaces: p,
                    optionalNamespaces: d,
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, h && {
                    sessionProperties: h
                });
                await this.sendResult({
                    id: s.id,
                    topic: e,
                    result: !0
                }), this.events.emit((0, $eeGmU.engineEvent)("session_connect"), {
                    session: w
                }), this.cleanupDuplicatePairings(w);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, $3YiWF.isJsonRpcResult)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $eeGmU.engineEvent)("session_approve", t), {})) : (0, $3YiWF.isJsonRpcError)(s) && (await this.client.session.delete(e, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, $eeGmU.engineEvent)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                const n = `${e}_session_update`, o = (0, $eeGmU.MemoryStore).get(n);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`);
                    return;
                }
                this.isValidUpdate($4a472e843fedf2e2$var$g({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult({
                    id: i,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                }), (0, $eeGmU.MemoryStore).set(n, i);
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.isRequestOutOfSync = (e, s)=>parseInt(s.toString().slice(0, -3)) <= parseInt(e.toString().slice(0, -3)), this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, $3YiWF.isJsonRpcResult)(s) ? this.events.emit((0, $eeGmU.engineEvent)("session_update", t), {}) : (0, $3YiWF.isJsonRpcError)(s) && this.events.emit((0, $eeGmU.engineEvent)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $eeGmU.calcExpiry)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, $3YiWF.isJsonRpcResult)(s) ? this.events.emit((0, $eeGmU.engineEvent)("session_extend", t), {}) : (0, $3YiWF.isJsonRpcError)(s) && this.events.emit((0, $eeGmU.engineEvent)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, $3YiWF.isJsonRpcResult)(s) ? this.events.emit((0, $eeGmU.engineEvent)("session_ping", t), {}) : (0, $3YiWF.isJsonRpcError)(s) && this.events.emit((0, $eeGmU.engineEvent)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $k4ZW9.RELAYER_EVENTS).publish, async ()=>{
                            i(await this.deleteSession(e));
                        });
                    }),
                    this.sendResult({
                        id: t,
                        topic: e,
                        result: !0
                    })
                ]), this.client.events.emit("session_delete", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest($4a472e843fedf2e2$var$g({
                    topic: e
                }, i));
                const n = (0, $eeGmU.hashMessage)(JSON.stringify((0, $57Nk6.formatJsonRpcRequest)("wc_sessionRequest", i, t))), o = this.client.session.get(e), a = await this.getVerifyContext(n, o.peer.metadata), c = {
                    id: t,
                    topic: e,
                    params: i,
                    verifyContext: a
                };
                await this.setPendingSessionRequest(c), this.addSessionRequestToSessionRequestQueue(c), this.processSessionRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, $3YiWF.isJsonRpcResult)(s) ? this.events.emit((0, $eeGmU.engineEvent)("session_request", t), {
                result: s.result
            }) : (0, $3YiWF.isJsonRpcError)(s) && this.events.emit((0, $eeGmU.engineEvent)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                const n = `${e}_session_event_${i.event.name}`, o = (0, $eeGmU.MemoryStore).get(n);
                if (o && this.isRequestOutOfSync(o, t)) {
                    this.client.logger.info(`Discarding out of sync request - ${t}`);
                    return;
                }
                this.isValidEmit($4a472e843fedf2e2$var$g({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                }), (0, $eeGmU.MemoryStore).set(n, t);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addSessionRequestToSessionRequestQueue = (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay));
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $4a472e843fedf2e2$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.active, this.client.events.emit("session_request", e);
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.onPairingCreated = (e)=>{
            if (e.active) return;
            const s = this.client.proposal.getAll().find((t)=>t.pairingTopic === e.topic);
            s && this.onSessionProposeRequest(e.topic, (0, $57Nk6.formatJsonRpcRequest)("wc_sessionPropose", {
                requiredNamespaces: s.requiredNamespaces,
                optionalNamespaces: s.optionalNamespaces,
                relays: s.relays,
                proposer: s.proposer
            }, s.id));
        }, this.isValidConnect = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, $eeGmU.isUndefined)(s) || await this.isValidPairingTopic(s), !(0, $eeGmU.isValidRelays)(o, !0)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $eeGmU.isUndefined)(t) && (0, $eeGmU.isValidObject)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $eeGmU.isUndefined)(i) && (0, $eeGmU.isValidObject)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $eeGmU.isUndefined)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, $eeGmU.isValidRequiredNamespaces)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) throw new Error((0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, $eeGmU.isValidNamespaces)(t, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $eeGmU.isConformingNamespaces)(o.requiredNamespaces, t, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $eeGmU.isValidString)(i, !0)) {
                const { message: p } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(p);
            }
            (0, $eeGmU.isUndefined)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: i } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, $eeGmU.isValidErrorReason)(t)) {
                const { message: i } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: c } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(c);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, $eeGmU.isValidRelay)(s)) {
                const { message: c } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $eeGmU.isValidController)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $eeGmU.isValidNamespaces)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $eeGmU.isExpired)(n)) {
                const { message: c } = (0, $eeGmU.getInternalError)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, $eeGmU.isValidNamespaces)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, $eeGmU.isConformingNamespaces)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: t } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, $eeGmU.isValidNamespacesChainId)(o, i)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $eeGmU.isValidRequest)(t)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $eeGmU.isValidNamespacesRequest)(o, i, t.method)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, $eeGmU.isValidRequestExpiry)(n, $4a472e843fedf2e2$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.min} and ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: i } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(i);
            }
            const { topic: s, response: t } = e;
            if (await this.isValidSessionTopic(s), !(0, $eeGmU.isValidResponse)(t)) {
                const { message: i } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: t } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: o } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, $eeGmU.isValidNamespacesChainId)(n, i)) {
                const { message: o } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $eeGmU.isValidEvent)(t)) {
                const { message: o } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $eeGmU.isValidNamespacesEvent)(n, i, t.name)) {
                const { message: o } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $eeGmU.isValidParams)(e)) {
                const { message: t } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || (0, $k4ZW9.VERIFY_SERVER),
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(s.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, $eeGmU.isValidString)(t, !1)) {
                    const { message: i } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $k4ZW9.RELAYER_EVENTS).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, $3YiWF.isJsonRpcRequest)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, $3YiWF.isJsonRpcResponse)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $k4ZW9.EXPIRER_EVENTS).expired, async (r)=>{
            const { topic: e, id: s } = (0, $eeGmU.parseExpirerTarget)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, $eeGmU.getInternalError)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession(e, !0), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $k4ZW9.PAIRING_EVENTS).create, (r)=>this.onPairingCreated(r));
    }
    isValidPairingTopic(r) {
        if (!(0, $eeGmU.isValidString)(r, !1)) {
            const { message: e } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $eeGmU.isExpired)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, $eeGmU.getInternalError)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, $eeGmU.isValidString)(r, !1)) {
            const { message: e } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $eeGmU.isExpired)(this.client.session.get(r).expiry)) {
            await this.deleteSession(r);
            const { message: e } = (0, $eeGmU.getInternalError)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, $eeGmU.isValidString)(r, !1)) {
            const { message: e } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, $eeGmU.isValidId)(r)) {
            const { message: e } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $eeGmU.isExpired)(this.client.proposal.get(r).expiry)) {
            await this.deleteProposal(r);
            const { message: e } = (0, $eeGmU.getInternalError)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class $4a472e843fedf2e2$var$hs extends (0, $k4ZW9.Store) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$ae6c7a4f7ed730a1, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$ds extends (0, $k4ZW9.Store) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$a069e98a8dfeec1e, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$us extends (0, $k4ZW9.Store) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$40b296af21bd38a4, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$export$2e2bcd8739ae039 extends (0, $g2mSD.ISignClient) {
    constructor(r){
        super(r), this.protocol = $4a472e843fedf2e2$export$4fa962fc67384e02, this.version = $4a472e843fedf2e2$export$61085c48796ff049, this.name = $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.events = new (0, $7etJZ.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.metadata = r?.metadata || (0, $eeGmU.getAppMetadata)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, $aY1FL.pino)((0, $aY1FL.getDefaultLoggerOptions)({
            level: r?.logger || $4a472e843fedf2e2$export$8dffb3242f2c5f72.logger
        }));
        this.core = r?.core || new (0, $k4ZW9.Core)(r), this.logger = (0, $aY1FL.generateChildLogger)(e, this.name), this.session = new $4a472e843fedf2e2$var$ds(this.core, this.logger), this.proposal = new $4a472e843fedf2e2$var$hs(this.core, this.logger), this.pendingRequest = new $4a472e843fedf2e2$var$us(this.core, this.logger), this.engine = new $4a472e843fedf2e2$var$ps(this);
    }
    static async init(r) {
        const e = new $4a472e843fedf2e2$export$2e2bcd8739ae039(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const $4a472e843fedf2e2$export$bdf4ba258ec679dc = $4a472e843fedf2e2$export$2e2bcd8739ae039;

});
parcelRequire.register("k4ZW9", function(module, exports) {

$parcel$export(module.exports, "RELAYER_DEFAULT_PROTOCOL", () => $e9e439c110f17033$export$822d0bd1635d5360);
$parcel$export(module.exports, "RELAYER_EVENTS", () => $e9e439c110f17033$export$d56245796e2837d);
$parcel$export(module.exports, "PAIRING_EVENTS", () => $e9e439c110f17033$export$ca3c0b962acf7b75);
$parcel$export(module.exports, "EXPIRER_EVENTS", () => $e9e439c110f17033$export$9013719d9206b0c1);
$parcel$export(module.exports, "VERIFY_SERVER", () => $e9e439c110f17033$export$7e3b1a28ddecdbaa);
$parcel$export(module.exports, "Store", () => $e9e439c110f17033$export$390f32400eaf98c9);
$parcel$export(module.exports, "Core", () => $e9e439c110f17033$export$4143ab5b91744744);

var $7etJZ = parcelRequire("7etJZ");

var $8uTvE = parcelRequire("8uTvE");

var $2Qwpn = parcelRequire("2Qwpn");

var $aY1FL = parcelRequire("aY1FL");

var $g2mSD = parcelRequire("g2mSD");

var $b8Ion = parcelRequire("b8Ion");
parcelRequire("fVWg2");
var $2XFRM = parcelRequire("2XFRM");
var $lcitG = parcelRequire("lcitG");

var $eeGmU = parcelRequire("eeGmU");

var $a2jTq = parcelRequire("a2jTq");

var $aG48A = parcelRequire("aG48A");
parcelRequire("7q0i6");
var $1QugC = parcelRequire("1QugC");
parcelRequire("2KWby");
var $57Nk6 = parcelRequire("57Nk6");
var $3YiWF = parcelRequire("3YiWF");

var $80onO = parcelRequire("80onO");

var $6cqMT = parcelRequire("6cqMT");
function $e9e439c110f17033$var$Ki(r, e) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < r.length; s++){
        var n = r.charAt(s), a = n.charCodeAt(0);
        if (t[a] !== 255) throw new TypeError(n + " is ambiguous");
        t[a] = s;
    }
    var o = r.length, h = r.charAt(0), u = Math.log(o) / Math.log(256), d = Math.log(256) / Math.log(o);
    function p(c) {
        if (c instanceof Uint8Array || (ArrayBuffer.isView(c) ? c = new Uint8Array(c.buffer, c.byteOffset, c.byteLength) : Array.isArray(c) && (c = Uint8Array.from(c))), !(c instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (c.length === 0) return "";
        for(var b = 0, z = 0, v = 0, _ = c.length; v !== _ && c[v] === 0;)v++, b++;
        for(var T = (_ - v) * d + 1 >>> 0, m = new Uint8Array(T); v !== _;){
            for(var S = c[v], A = 0, I = T - 1; (S !== 0 || A < z) && I !== -1; I--, A++)S += 256 * m[I] >>> 0, m[I] = S % o >>> 0, S = S / o >>> 0;
            if (S !== 0) throw new Error("Non-zero carry");
            z = A, v++;
        }
        for(var O = T - z; O !== T && m[O] === 0;)O++;
        for(var q = h.repeat(b); O < T; ++O)q += r.charAt(m[O]);
        return q;
    }
    function y(c) {
        if (typeof c != "string") throw new TypeError("Expected String");
        if (c.length === 0) return new Uint8Array;
        var b = 0;
        if (c[b] !== " ") {
            for(var z = 0, v = 0; c[b] === h;)z++, b++;
            for(var _ = (c.length - b) * u + 1 >>> 0, T = new Uint8Array(_); c[b];){
                var m = t[c.charCodeAt(b)];
                if (m === 255) return;
                for(var S = 0, A = _ - 1; (m !== 0 || S < v) && A !== -1; A--, S++)m += o * T[A] >>> 0, T[A] = m % 256 >>> 0, m = m / 256 >>> 0;
                if (m !== 0) throw new Error("Non-zero carry");
                v = S, b++;
            }
            if (c[b] !== " ") {
                for(var I = _ - v; I !== _ && T[I] === 0;)I++;
                for(var O = new Uint8Array(z + (_ - I)), q = z; I !== _;)O[q++] = T[I++];
                return O;
            }
        }
    }
    function $(c) {
        var b = y(c);
        if (b) return b;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: p,
        decodeUnsafe: y,
        decode: $
    };
}
var $e9e439c110f17033$var$Bi = $e9e439c110f17033$var$Ki, $e9e439c110f17033$var$Vi = $e9e439c110f17033$var$Bi;
const $e9e439c110f17033$var$ze = (r)=>{
    if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
    if (r instanceof ArrayBuffer) return new Uint8Array(r);
    if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $e9e439c110f17033$var$qi = (r)=>new TextEncoder().encode(r), $e9e439c110f17033$var$ji = (r)=>new TextDecoder().decode(r);
class $e9e439c110f17033$var$Yi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $e9e439c110f17033$var$Gi {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $e9e439c110f17033$var$Ne(this, e);
    }
}
class $e9e439c110f17033$var$Hi {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $e9e439c110f17033$var$Ne(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $e9e439c110f17033$var$Ne = (r, e)=>new $e9e439c110f17033$var$Hi({
        ...r.decoders || {
            [r.prefix]: r
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $e9e439c110f17033$var$Ji {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $e9e439c110f17033$var$Yi(e, t, i), this.decoder = new $e9e439c110f17033$var$Gi(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $e9e439c110f17033$var$W = ({ name: r, prefix: e, encode: t, decode: i })=>new $e9e439c110f17033$var$Ji(r, e, t, i), $e9e439c110f17033$var$K = ({ prefix: r, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $e9e439c110f17033$var$Vi(t, e);
    return $e9e439c110f17033$var$W({
        prefix: r,
        name: e,
        encode: i,
        decode: (n)=>$e9e439c110f17033$var$ze(s(n))
    });
}, $e9e439c110f17033$var$Wi = (r, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let n = r.length;
    for(; r[n - 1] === "=";)--n;
    const a = new Uint8Array(n * t / 8 | 0);
    let o = 0, h = 0, u = 0;
    for(let d = 0; d < n; ++d){
        const p = s[r[d]];
        if (p === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | p, o += t, o >= 8 && (o -= 8, a[u++] = 255 & h >> o);
    }
    if (o >= t || 255 & h << 8 - o) throw new SyntaxError("Unexpected end of data");
    return a;
}, $e9e439c110f17033$var$Xi = (r, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let n = "", a = 0, o = 0;
    for(let h = 0; h < r.length; ++h)for(o = o << 8 | r[h], a += 8; a > t;)a -= t, n += e[s & o >> a];
    if (a && (n += e[s & o << t - a]), i) for(; n.length * t & 7;)n += "=";
    return n;
}, $e9e439c110f17033$var$g = ({ name: r, prefix: e, bitsPerChar: t, alphabet: i })=>$e9e439c110f17033$var$W({
        prefix: e,
        name: r,
        encode (s) {
            return $e9e439c110f17033$var$Xi(s, i, t);
        },
        decode (s) {
            return $e9e439c110f17033$var$Wi(s, i, t, r);
        }
    }), $e9e439c110f17033$var$Qi = $e9e439c110f17033$var$W({
    prefix: "\x00",
    name: "identity",
    encode: (r)=>$e9e439c110f17033$var$ji(r),
    decode: (r)=>$e9e439c110f17033$var$qi(r)
});
var $e9e439c110f17033$var$Zi = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$Qi
});
const $e9e439c110f17033$var$es = $e9e439c110f17033$var$g({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $e9e439c110f17033$var$ts = Object.freeze({
    __proto__: null,
    base2: $e9e439c110f17033$var$es
});
const $e9e439c110f17033$var$is = $e9e439c110f17033$var$g({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $e9e439c110f17033$var$ss = Object.freeze({
    __proto__: null,
    base8: $e9e439c110f17033$var$is
});
const $e9e439c110f17033$var$rs = $e9e439c110f17033$var$K({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $e9e439c110f17033$var$ns = Object.freeze({
    __proto__: null,
    base10: $e9e439c110f17033$var$rs
});
const $e9e439c110f17033$var$as = $e9e439c110f17033$var$g({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $e9e439c110f17033$var$os = $e9e439c110f17033$var$g({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $e9e439c110f17033$var$hs = Object.freeze({
    __proto__: null,
    base16: $e9e439c110f17033$var$as,
    base16upper: $e9e439c110f17033$var$os
});
const $e9e439c110f17033$var$cs = $e9e439c110f17033$var$g({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$us = $e9e439c110f17033$var$g({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ls = $e9e439c110f17033$var$g({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ds = $e9e439c110f17033$var$g({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$gs = $e9e439c110f17033$var$g({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ps = $e9e439c110f17033$var$g({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $e9e439c110f17033$var$Ds = $e9e439c110f17033$var$g({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ys = $e9e439c110f17033$var$g({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$bs = $e9e439c110f17033$var$g({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $e9e439c110f17033$var$ms = Object.freeze({
    __proto__: null,
    base32: $e9e439c110f17033$var$cs,
    base32upper: $e9e439c110f17033$var$us,
    base32pad: $e9e439c110f17033$var$ls,
    base32padupper: $e9e439c110f17033$var$ds,
    base32hex: $e9e439c110f17033$var$gs,
    base32hexupper: $e9e439c110f17033$var$ps,
    base32hexpad: $e9e439c110f17033$var$Ds,
    base32hexpadupper: $e9e439c110f17033$var$ys,
    base32z: $e9e439c110f17033$var$bs
});
const $e9e439c110f17033$var$fs = $e9e439c110f17033$var$K({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $e9e439c110f17033$var$Es = $e9e439c110f17033$var$K({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$ws = Object.freeze({
    __proto__: null,
    base36: $e9e439c110f17033$var$fs,
    base36upper: $e9e439c110f17033$var$Es
});
const $e9e439c110f17033$var$vs = $e9e439c110f17033$var$K({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $e9e439c110f17033$var$Is = $e9e439c110f17033$var$K({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$Cs = Object.freeze({
    __proto__: null,
    base58btc: $e9e439c110f17033$var$vs,
    base58flickr: $e9e439c110f17033$var$Is
});
const $e9e439c110f17033$var$Rs = $e9e439c110f17033$var$g({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $e9e439c110f17033$var$_s = $e9e439c110f17033$var$g({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Ts = $e9e439c110f17033$var$g({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Ss = $e9e439c110f17033$var$g({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $e9e439c110f17033$var$Ps = Object.freeze({
    __proto__: null,
    base64: $e9e439c110f17033$var$Rs,
    base64pad: $e9e439c110f17033$var$_s,
    base64url: $e9e439c110f17033$var$Ts,
    base64urlpad: $e9e439c110f17033$var$Ss
});
const $e9e439c110f17033$var$Ue = Array.from("\uD83D\uDE80\uD83E\uDE90☄\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09☀\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02❤\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09☺\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E✌✨\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D❣\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33✋\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13⭐✅\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6✔\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90☹\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20☝\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B⚽\uD83E\uDD19☕\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81⚡\uD83C\uDF1E\uD83C\uDF88❌✊\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C✈\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74▶➡❓\uD83D\uDC8E\uD83D\uDCB8⬇\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A⚠\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37☎\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51❄\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $e9e439c110f17033$var$Os = $e9e439c110f17033$var$Ue.reduce((r, e, t)=>(r[t] = e, r), []), $e9e439c110f17033$var$xs = $e9e439c110f17033$var$Ue.reduce((r, e, t)=>(r[e.codePointAt(0)] = t, r), []);
function $e9e439c110f17033$var$As(r) {
    return r.reduce((e, t)=>(e += $e9e439c110f17033$var$Os[t], e), "");
}
function $e9e439c110f17033$var$zs(r) {
    const e = [];
    for (const t of r){
        const i = $e9e439c110f17033$var$xs[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $e9e439c110f17033$var$Ns = $e9e439c110f17033$var$W({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e9e439c110f17033$var$As,
    decode: $e9e439c110f17033$var$zs
});
var $e9e439c110f17033$var$Us = Object.freeze({
    __proto__: null,
    base256emoji: $e9e439c110f17033$var$Ns
}), $e9e439c110f17033$var$Ls = $e9e439c110f17033$var$Fe, $e9e439c110f17033$var$Le = 128, $e9e439c110f17033$var$Fs = 127, $e9e439c110f17033$var$$s = ~$e9e439c110f17033$var$Fs, $e9e439c110f17033$var$Ms = Math.pow(2, 31);
function $e9e439c110f17033$var$Fe(r, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; r >= $e9e439c110f17033$var$Ms;)e[t++] = r & 255 | $e9e439c110f17033$var$Le, r /= 128;
    for(; r & $e9e439c110f17033$var$$s;)e[t++] = r & 255 | $e9e439c110f17033$var$Le, r >>>= 7;
    return e[t] = r | 0, $e9e439c110f17033$var$Fe.bytes = t - i + 1, e;
}
var $e9e439c110f17033$var$ks = $e9e439c110f17033$var$oe, $e9e439c110f17033$var$Ks = 128, $e9e439c110f17033$var$$e = 127;
function $e9e439c110f17033$var$oe(r, i) {
    var t = 0, i = i || 0, s = 0, n = i, a, o = r.length;
    do {
        if (n >= o) throw $e9e439c110f17033$var$oe.bytes = 0, new RangeError("Could not decode varint");
        a = r[n++], t += s < 28 ? (a & $e9e439c110f17033$var$$e) << s : (a & $e9e439c110f17033$var$$e) * Math.pow(2, s), s += 7;
    }while (a >= $e9e439c110f17033$var$Ks);
    return $e9e439c110f17033$var$oe.bytes = n - i, t;
}
var $e9e439c110f17033$var$Bs = Math.pow(2, 7), $e9e439c110f17033$var$Vs = Math.pow(2, 14), $e9e439c110f17033$var$qs = Math.pow(2, 21), $e9e439c110f17033$var$js = Math.pow(2, 28), $e9e439c110f17033$var$Ys = Math.pow(2, 35), $e9e439c110f17033$var$Gs = Math.pow(2, 42), $e9e439c110f17033$var$Hs = Math.pow(2, 49), $e9e439c110f17033$var$Js = Math.pow(2, 56), $e9e439c110f17033$var$Ws = Math.pow(2, 63), $e9e439c110f17033$var$Xs = function(r) {
    return r < $e9e439c110f17033$var$Bs ? 1 : r < $e9e439c110f17033$var$Vs ? 2 : r < $e9e439c110f17033$var$qs ? 3 : r < $e9e439c110f17033$var$js ? 4 : r < $e9e439c110f17033$var$Ys ? 5 : r < $e9e439c110f17033$var$Gs ? 6 : r < $e9e439c110f17033$var$Hs ? 7 : r < $e9e439c110f17033$var$Js ? 8 : r < $e9e439c110f17033$var$Ws ? 9 : 10;
}, $e9e439c110f17033$var$Qs = {
    encode: $e9e439c110f17033$var$Ls,
    decode: $e9e439c110f17033$var$ks,
    encodingLength: $e9e439c110f17033$var$Xs
}, $e9e439c110f17033$var$Me = $e9e439c110f17033$var$Qs;
const $e9e439c110f17033$var$ke = (r, e, t = 0)=>($e9e439c110f17033$var$Me.encode(r, e, t), e), $e9e439c110f17033$var$Ke = (r)=>$e9e439c110f17033$var$Me.encodingLength(r), $e9e439c110f17033$var$he = (r, e)=>{
    const t = e.byteLength, i = $e9e439c110f17033$var$Ke(r), s = i + $e9e439c110f17033$var$Ke(t), n = new Uint8Array(s + t);
    return $e9e439c110f17033$var$ke(r, n, 0), $e9e439c110f17033$var$ke(t, n, i), n.set(e, s), new $e9e439c110f17033$var$Zs(r, t, e, n);
};
class $e9e439c110f17033$var$Zs {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $e9e439c110f17033$var$Be = ({ name: r, code: e, encode: t })=>new $e9e439c110f17033$var$er(r, e, t);
class $e9e439c110f17033$var$er {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $e9e439c110f17033$var$he(this.code, t) : t.then((i)=>$e9e439c110f17033$var$he(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $e9e439c110f17033$var$Ve = (r)=>async (e)=>new Uint8Array(await crypto.subtle.digest(r, e)), $e9e439c110f17033$var$tr = $e9e439c110f17033$var$Be({
    name: "sha2-256",
    code: 18,
    encode: $e9e439c110f17033$var$Ve("SHA-256")
}), $e9e439c110f17033$var$ir = $e9e439c110f17033$var$Be({
    name: "sha2-512",
    code: 19,
    encode: $e9e439c110f17033$var$Ve("SHA-512")
});
var $e9e439c110f17033$var$sr = Object.freeze({
    __proto__: null,
    sha256: $e9e439c110f17033$var$tr,
    sha512: $e9e439c110f17033$var$ir
});
const $e9e439c110f17033$var$qe = 0, $e9e439c110f17033$var$rr = "identity", $e9e439c110f17033$var$je = $e9e439c110f17033$var$ze, $e9e439c110f17033$var$nr = (r)=>$e9e439c110f17033$var$he($e9e439c110f17033$var$qe, $e9e439c110f17033$var$je(r)), $e9e439c110f17033$var$ar = {
    code: $e9e439c110f17033$var$qe,
    name: $e9e439c110f17033$var$rr,
    encode: $e9e439c110f17033$var$je,
    digest: $e9e439c110f17033$var$nr
};
var $e9e439c110f17033$var$or = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$ar
});
new TextEncoder, new TextDecoder;
const $e9e439c110f17033$var$Ye = {
    ...$e9e439c110f17033$var$Zi,
    ...$e9e439c110f17033$var$ts,
    ...$e9e439c110f17033$var$ss,
    ...$e9e439c110f17033$var$ns,
    ...$e9e439c110f17033$var$hs,
    ...$e9e439c110f17033$var$ms,
    ...$e9e439c110f17033$var$ws,
    ...$e9e439c110f17033$var$Cs,
    ...$e9e439c110f17033$var$Ps,
    ...$e9e439c110f17033$var$Us
};
({
    ...$e9e439c110f17033$var$sr,
    ...$e9e439c110f17033$var$or
});
function $e9e439c110f17033$var$Ge(r) {
    return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}
function $e9e439c110f17033$var$hr(r = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $e9e439c110f17033$var$Ge(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}
function $e9e439c110f17033$var$He(r, e, t, i) {
    return {
        name: r,
        prefix: e,
        encoder: {
            name: r,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $e9e439c110f17033$var$Je = $e9e439c110f17033$var$He("utf8", "u", (r)=>"u" + new TextDecoder("utf8").decode(r), (r)=>new TextEncoder().encode(r.substring(1))), $e9e439c110f17033$var$ce = $e9e439c110f17033$var$He("ascii", "a", (r)=>{
    let e = "a";
    for(let t = 0; t < r.length; t++)e += String.fromCharCode(r[t]);
    return e;
}, (r)=>{
    r = r.substring(1);
    const e = $e9e439c110f17033$var$hr(r.length);
    for(let t = 0; t < r.length; t++)e[t] = r.charCodeAt(t);
    return e;
}), $e9e439c110f17033$var$cr = {
    utf8: $e9e439c110f17033$var$Je,
    "utf-8": $e9e439c110f17033$var$Je,
    hex: $e9e439c110f17033$var$Ye.base16,
    latin1: $e9e439c110f17033$var$ce,
    ascii: $e9e439c110f17033$var$ce,
    binary: $e9e439c110f17033$var$ce,
    ...$e9e439c110f17033$var$Ye
};
function $e9e439c110f17033$var$ur(r, e = "utf8") {
    const t = $e9e439c110f17033$var$cr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $e9e439c110f17033$var$Ge(globalThis.Buffer.from(r, "utf-8")) : t.decoder.decode(`${t.prefix}${r}`);
}
const $e9e439c110f17033$export$51b1c900ac262bdf = "wc", $e9e439c110f17033$export$f30bd3c8747cdfbe = 2, $e9e439c110f17033$export$d47601f9de5ee22b = "core", $e9e439c110f17033$export$f258d29ae5e3d545 = `${$e9e439c110f17033$export$51b1c900ac262bdf}@2:${$e9e439c110f17033$export$d47601f9de5ee22b}:`, $e9e439c110f17033$export$db0fdb6d486555c2 = {
    name: $e9e439c110f17033$export$d47601f9de5ee22b,
    logger: "error"
}, $e9e439c110f17033$export$ba920abfe854b85d = {
    database: ":memory:"
}, $e9e439c110f17033$export$92a79f21481c803d = "crypto", $e9e439c110f17033$export$3613aa6e652146e4 = "client_ed25519_seed", $e9e439c110f17033$export$c4bc5e31a4d0ec78 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$9d7218f72e8dc49b = "keychain", $e9e439c110f17033$export$34f82f4ba0c3d769 = "0.3", $e9e439c110f17033$export$9662bbc7d10cf481 = "messages", $e9e439c110f17033$export$19dfd1896412c038 = "0.3", $e9e439c110f17033$export$8ddbe6611b67d926 = (0, $aG48A.SIX_HOURS), $e9e439c110f17033$export$9d92662178f2abd1 = "publisher", $e9e439c110f17033$export$822d0bd1635d5360 = "irn", $e9e439c110f17033$export$5176ffa6778d6637 = "error", $e9e439c110f17033$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $e9e439c110f17033$export$27fee22bec112637 = "wss://relay.walletconnect.org", $e9e439c110f17033$export$602d6e27611c3fcb = "relayer", $e9e439c110f17033$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $e9e439c110f17033$export$119b4645f6b233c8 = "_subscription", $e9e439c110f17033$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $e9e439c110f17033$export$11ccd39be2c57d6 = (0, $aG48A.ONE_SECOND), $e9e439c110f17033$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $e9e439c110f17033$export$5f30917a6f8c9025 = "2.10.1", $e9e439c110f17033$export$fb3eab7adf12329d = 1e4, $e9e439c110f17033$export$629a342182ba24b = "0.3", $e9e439c110f17033$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $e9e439c110f17033$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $e9e439c110f17033$export$9d35d0a6a3599be = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$9c3a96bb670cddb8 = "subscription", $e9e439c110f17033$export$fb57e03bef4c4cea = "0.3", $e9e439c110f17033$export$9a2ddbfe54f8af77 = (0, $aG48A.FIVE_SECONDS) * 1e3, $e9e439c110f17033$export$390360ea476c6145 = "pairing", $e9e439c110f17033$export$5593ec74b27d1b18 = "0.3", $e9e439c110f17033$export$ee4b1978d0aedfad = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $e9e439c110f17033$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $e9e439c110f17033$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $e9e439c110f17033$export$160142c73cb99dc3 = "history", $e9e439c110f17033$export$8eba9ce85616c607 = "0.3", $e9e439c110f17033$export$4ddf883392bbc828 = "expirer", $e9e439c110f17033$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $e9e439c110f17033$export$717295846191925d = "0.3", $e9e439c110f17033$export$3cfe73d6765db74 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$3b58f2450f2297e3 = "verify-api", $e9e439c110f17033$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com", $e9e439c110f17033$export$4fe83ee8f9aec7b6 = "https://verify.walletconnect.org";
class $e9e439c110f17033$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $e9e439c110f17033$export$9d7218f72e8dc49b, this.version = $e9e439c110f17033$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: n } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(n);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $eeGmU.mapToObj)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $eeGmU.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), n = $2XFRM.generateKeyPair(s);
            return $lcitG.encodeIss(n.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $eeGmU.generateKeyPair)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const n = await this.getClientSeed(), a = $2XFRM.generateKeyPair(n), o = (0, $eeGmU.generateRandomBytes32)(), h = $e9e439c110f17033$export$c4bc5e31a4d0ec78;
            return await $2XFRM.signJWT(o, s, h, a);
        }, this.generateSharedKey = (s, n, a)=>{
            this.isInitialized();
            const o = this.getPrivateKey(s), h = (0, $eeGmU.deriveSymKey)(o, n);
            return this.setSymKey(h, a);
        }, this.setSymKey = async (s, n)=>{
            this.isInitialized();
            const a = n || (0, $eeGmU.hashKey)(s);
            return await this.keychain.set(a, s), a;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, $eeGmU.validateEncoding)(a), h = (0, $b8Ion.safeJsonStringify)(n);
            if ((0, $eeGmU.isTypeOneEnvelope)(o)) {
                const y = o.senderPublicKey, $ = o.receiverPublicKey;
                s = await this.generateSharedKey(y, $);
            }
            const u = this.getSymKey(s), { type: d, senderPublicKey: p } = o;
            return (0, $eeGmU.encrypt)({
                type: d,
                symKey: u,
                message: h,
                senderPublicKey: p
            });
        }, this.decode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, $eeGmU.validateDecoding)(n, a);
            if ((0, $eeGmU.isTypeOneEnvelope)(o)) {
                const h = o.receiverPublicKey, u = o.senderPublicKey;
                s = await this.generateSharedKey(h, u);
            }
            try {
                const h = this.getSymKey(s), u = (0, $eeGmU.decrypt)({
                    symKey: h,
                    encoded: n
                });
                return (0, $b8Ion.safeJsonParse)(u);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const n = (0, $eeGmU.deserialize)(s);
            return (0, $eeGmU.decodeTypeByte)(n.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const n = (0, $eeGmU.deserialize)(s);
            return n.senderPublicKey ? (0, $a2jTq.toString)(n.senderPublicKey, (0, $eeGmU.BASE16)) : void 0;
        }, this.core = e, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.keychain = i || new $e9e439c110f17033$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($e9e439c110f17033$export$3613aa6e652146e4);
        } catch  {
            e = (0, $eeGmU.generateRandomBytes32)(), await this.keychain.set($e9e439c110f17033$export$3613aa6e652146e4, e);
        }
        return $e9e439c110f17033$var$ur(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$4a2542d0790ac2fd extends (0, $g2mSD.IMessageTracker) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $e9e439c110f17033$export$9662bbc7d10cf481, this.version = $e9e439c110f17033$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const n = (0, $eeGmU.hashMessage)(s);
            let a = this.messages.get(i);
            return typeof a > "u" && (a = {}), typeof a[n] < "u" || (a[n] = s, this.messages.set(i, a), await this.persist()), n;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const n = this.get(i), a = (0, $eeGmU.hashMessage)(s);
            return typeof n[a] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $aY1FL.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $eeGmU.mapToObj)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $eeGmU.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$var$Dr extends (0, $g2mSD.IPublisher) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.TEN_SECONDS)), this.needsTransportRestart = !1, this.publish = async (i, s, n)=>{
            var a;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: n
                }
            });
            try {
                const o = n?.ttl || $e9e439c110f17033$export$8ddbe6611b67d926, h = (0, $eeGmU.getRelayProtocolName)(n), u = n?.prompt || !1, d = n?.tag || 0, p = n?.id || (0, $57Nk6.getBigIntRpcId)().toString(), y = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: o,
                        relay: h,
                        prompt: u,
                        tag: d,
                        id: p
                    }
                }, $ = setTimeout(()=>this.queue.set(p, y), this.publishTimeout);
                try {
                    await await (0, $eeGmU.createExpiringPromise)(this.rpcPublish(i, s, o, h, u, d, p), this.publishTimeout, "Failed to publish payload, please try again."), this.removeRequestFromQueue(p), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.publish, y);
                } catch (c) {
                    if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (a = n?.internal) != null && a.throwOnFailedPublish) throw this.removeRequestFromQueue(p), c;
                    return;
                } finally{
                    clearTimeout($);
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: n
                    }
                });
            } catch (o) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(o), o;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, n, a, o) {
        var h, u, d, p;
        const y = {
            method: (0, $eeGmU.getRelayProtocolApi)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: n,
                tag: a
            },
            id: o
        };
        return (0, $eeGmU.isUndefined)((h = y.params) == null ? void 0 : h.prompt) && ((u = y.params) == null || delete u.prompt), (0, $eeGmU.isUndefined)((d = y.params) == null ? void 0 : d.tag) && ((p = y.params) == null || delete p.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $2Qwpn.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $e9e439c110f17033$var$yr {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((n)=>n !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $e9e439c110f17033$var$br = Object.defineProperty, $e9e439c110f17033$var$mr = Object.defineProperties, $e9e439c110f17033$var$fr = Object.getOwnPropertyDescriptors, $e9e439c110f17033$var$St = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Er = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$wr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Pt = (r, e, t)=>e in r ? $e9e439c110f17033$var$br(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$V = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Er.call(e, t) && $e9e439c110f17033$var$Pt(r, t, e[t]);
    if ($e9e439c110f17033$var$St) for (var t of $e9e439c110f17033$var$St(e))$e9e439c110f17033$var$wr.call(e, t) && $e9e439c110f17033$var$Pt(r, t, e[t]);
    return r;
}, $e9e439c110f17033$var$De = (r, e)=>$e9e439c110f17033$var$mr(r, $e9e439c110f17033$var$fr(e));
class $e9e439c110f17033$export$60959659b2c22881 extends (0, $g2mSD.ISubscriber) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $e9e439c110f17033$var$yr, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9c3a96bb670cddb8, this.version = $e9e439c110f17033$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const n = (0, $eeGmU.getRelayProtocolName)(s), a = {
                    topic: i,
                    relay: n
                };
                this.pending.set(i, a);
                const o = await this.rpcSubscribe(i, n);
                return this.onSubscribe(o, a), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), o;
            } catch (n) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>this.topics.includes(i) ? !0 : await new Promise((s, n)=>{
                const a = new (0, $aG48A.Watch);
                a.start(this.pendingSubscriptionWatchLabel);
                const o = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), s(!0)), a.elapsed(this.pendingSubscriptionWatchLabel) >= $e9e439c110f17033$export$9a2ddbfe54f8af77 && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $eeGmU.getRelayProtocolName)(i);
            await this.rpcUnsubscribe(e, t, s);
            const n = (0, $eeGmU.getSdkError)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $eeGmU.getRelayProtocolApi)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $eeGmU.createExpiringPromise)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
        return (0, $eeGmU.hashMessage)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $eeGmU.getRelayProtocolApi)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $eeGmU.createExpiringPromise)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $eeGmU.getRelayProtocolApi)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $e9e439c110f17033$var$De($e9e439c110f17033$var$V({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $e9e439c110f17033$var$V({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $e9e439c110f17033$var$V({}, t)), this.topicMap.set(t.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.deleted, $e9e439c110f17033$var$De($e9e439c110f17033$var$V({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $eeGmU.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $eeGmU.isValidArray)(t) && this.onBatchSubscribe(t.map((i, s)=>$e9e439c110f17033$var$De($e9e439c110f17033$var$V({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $2Qwpn.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $e9e439c110f17033$var$vr = Object.defineProperty, $e9e439c110f17033$var$xt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Ir = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Cr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$At = (r, e, t)=>e in r ? $e9e439c110f17033$var$vr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$Rr = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Ir.call(e, t) && $e9e439c110f17033$var$At(r, t, e[t]);
    if ($e9e439c110f17033$var$xt) for (var t of $e9e439c110f17033$var$xt(e))$e9e439c110f17033$var$Cr.call(e, t) && $e9e439c110f17033$var$At(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$70e73aa29a3d4407 extends (0, $g2mSD.IRelayer) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.hasExperiencedNetworkDisruption = !1, this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            try {
                return await this.toEstablishConnection(), await this.provider.request(t);
            } catch (i) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(i), i;
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t);
        }, this.onConnectHandler = ()=>{
            this.events.emit($e9e439c110f17033$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($e9e439c110f17033$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $aY1FL.generateChildLogger)(e.logger, this.name) : (0, $aY1FL.pino)((0, $aY1FL.getDefaultLoggerOptions)({
            level: e.logger || $e9e439c110f17033$export$5176ffa6778d6637
        })), this.messages = new $e9e439c110f17033$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $e9e439c110f17033$export$60959659b2c22881(this, this.logger), this.publisher = new $e9e439c110f17033$var$Dr(this, this.logger), this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.projectId = e.projectId, this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$e9e439c110f17033$export$27fee22bec112637}...`), await this.restartTransport($e9e439c110f17033$export$27fee22bec112637);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $e9e439c110f17033$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        return s || (await Promise.all([
            new Promise((n)=>{
                this.subscriber.once($e9e439c110f17033$export$24ff3e54e94ef413.created, (a)=>{
                    a.topic === e && n();
                });
            }),
            new Promise(async (n)=>{
                s = await this.subscriber.subscribe(e, t), n();
            })
        ]), s);
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await (0, $eeGmU.createExpiringPromise)(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
            e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        if (!this.initialized) return t();
                        this.subscriber.once($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed, ()=>{
                            t();
                        });
                    }),
                    new Promise(async (t, i)=>{
                        try {
                            await (0, $eeGmU.createExpiringPromise)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
                        } catch (s) {
                            i(s);
                            return;
                        }
                        t();
                    })
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.provider.events.emit($e9e439c110f17033$export$58062acf2f31ddf8.disconnect);
            } finally{
                this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
            }
        }
    }
    async restartTransport(e) {
        await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $eeGmU.isOnline)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $1QugC.JsonRpcProvider)(new (0, $80onO.default)((0, $eeGmU.formatRelayRpcUrl)({
            sdkVersion: $e9e439c110f17033$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $3YiWF.isJsonRpcRequest)(e)) {
            if (!e.method.endsWith($e9e439c110f17033$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: n } = t.data, a = {
                topic: i,
                message: s,
                publishedAt: n
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($e9e439c110f17033$var$Rr({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $3YiWF.isJsonRpcResponse)(e) && this.events.emit($e9e439c110f17033$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($e9e439c110f17033$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $57Nk6.formatJsonRpcResult)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
    }
    async registerEventListeners() {
        this.events.on($e9e439c110f17033$export$d56245796e2837d.connection_stalled, ()=>{
            this.restartTransport().catch((t)=>this.logger.error(t));
        });
        let e = await (0, $eeGmU.isOnline)();
        (0, $eeGmU.subscribeToNetworkChange)(async (t)=>{
            this.initialized && e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((i)=>this.logger.error(i))));
        });
    }
    onProviderDisconnect() {
        this.events.emit($e9e439c110f17033$export$d56245796e2837d.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async ()=>{
            await this.restartTransport().catch((e)=>this.logger.error(e));
        }, (0, $aG48A.toMiliseconds)($e9e439c110f17033$export$11ccd39be2c57d6)));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (await this.confirmOnlineStateOrThrow(), !this.connected) {
            if (this.connectionAttemptInProgress) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var $e9e439c110f17033$var$_r = Object.defineProperty, $e9e439c110f17033$var$Nt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Tr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Sr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Ut = (r, e, t)=>e in r ? $e9e439c110f17033$var$_r(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$Lt = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Tr.call(e, t) && $e9e439c110f17033$var$Ut(r, t, e[t]);
    if ($e9e439c110f17033$var$Nt) for (var t of $e9e439c110f17033$var$Nt(e))$e9e439c110f17033$var$Sr.call(e, t) && $e9e439c110f17033$var$Ut(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$390f32400eaf98c9 extends (0, $g2mSD.IStore) {
    constructor(e, t, i, s = $e9e439c110f17033$export$f258d29ae5e3d545, n){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $e9e439c110f17033$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((a)=>{
                this.getKey && a !== null && !(0, $eeGmU.isUndefined)(a) ? this.map.set(this.getKey(a), a) : (0, $eeGmU.isProposalStruct)(a) ? this.map.set(a.id, a) : (0, $eeGmU.isSessionStruct)(a) && this.map.set(a.topic, a);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (a, o)=>{
            this.isInitialized(), this.map.has(a) ? await this.update(a, o) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: a,
                value: o
            }), this.map.set(a, o), await this.persist());
        }, this.get = (a)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: a
            }), this.getData(a)), this.getAll = (a)=>(this.isInitialized(), a ? this.values.filter((o)=>Object.keys(a).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($6cqMT)))(o[h], a[h]))) : this.values), this.update = async (a, o)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: a,
                update: o
            });
            const h = $e9e439c110f17033$var$Lt($e9e439c110f17033$var$Lt({}, this.getData(a)), o);
            this.map.set(a, h), await this.persist();
        }, this.delete = async (a, o)=>{
            this.isInitialized(), this.map.has(a) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: a,
                reason: o
            }), this.map.delete(a), await this.persist());
        }, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = n;
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $eeGmU.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$390360ea476c6145, this.version = $e9e439c110f17033$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $eeGmU.TYPE_1)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $eeGmU.generateRandomBytes32)(), s = await this.core.crypto.setSymKey(i), n = (0, $eeGmU.calcExpiry)((0, $aG48A.FIVE_MINUTES)), a = {
                protocol: $e9e439c110f17033$export$822d0bd1635d5360
            }, o = {
                topic: s,
                expiry: n,
                relay: a,
                active: !1
            }, h = (0, $eeGmU.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: a
            });
            return await this.pairings.set(s, o), await this.core.relayer.subscribe(s), this.core.expirer.set(s, n), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: n, relay: a } = (0, $eeGmU.parseUri)(i.uri);
            let o;
            if (this.pairings.keys.includes(s) && (o = this.pairings.get(s), o.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            this.core.crypto.keychain.has(s) || (await this.core.crypto.setSymKey(n, s), await this.core.relayer.subscribe(s, {
                relay: a
            }));
            const h = (0, $eeGmU.calcExpiry)((0, $aG48A.FIVE_MINUTES)), u = {
                topic: s,
                relay: a,
                expiry: h,
                active: !1
            };
            return await this.pairings.set(s, u), this.core.expirer.set(s, h), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.create, u), u;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $eeGmU.calcExpiry)((0, $aG48A.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: a, resolve: o, reject: h } = (0, $eeGmU.createDelayedPromise)();
                this.events.once((0, $eeGmU.engineEvent)("pairing_ping", n), ({ error: u })=>{
                    u ? h(u) : o();
                }), await a();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $eeGmU.getSdkError)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, n)=>{
            const a = (0, $57Nk6.formatJsonRpcRequest)(s, n), o = await this.core.crypto.encode(i, a), h = $e9e439c110f17033$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, a), this.core.relayer.publish(i, o, h), a.id;
        }, this.sendResult = async (i, s, n)=>{
            const a = (0, $57Nk6.formatJsonRpcResult)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), u = $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, o, u), await this.core.history.resolve(a);
        }, this.sendError = async (i, s, n)=>{
            const a = (0, $57Nk6.formatJsonRpcError)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), u = $e9e439c110f17033$export$d94d6986a8185883[h.request.method] ? $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res : $e9e439c110f17033$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, o, u), await this.core.history.resolve(a);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $eeGmU.getSdkError)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $eeGmU.isExpired)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: n } = i;
            switch(n.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, n);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, n);
                default:
                    return this.onUnknownRpcMethodRequest(s, n);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: n } = i, a = (await this.core.history.get(s, n.id)).request.method;
            switch(a){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, n);
                default:
                    return this.onUnknownRpcMethodResponse(a);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(n, i, !0), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.ping, {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: n } = s;
            setTimeout(()=>{
                (0, $3YiWF.isJsonRpcResult)(s) ? this.events.emit((0, $eeGmU.engineEvent)("pairing_ping", n), {}) : (0, $3YiWF.isJsonRpcError)(s) && this.events.emit((0, $eeGmU.engineEvent)("pairing_ping", n), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.delete, {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: n, method: a } = s;
            try {
                if (this.registeredMethods.includes(a)) return;
                const o = (0, $eeGmU.getSdkError)("WC_METHOD_UNSUPPORTED", a);
                await this.sendError(n, i, o), this.logger.error(o);
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $eeGmU.getSdkError)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            if (!(0, $eeGmU.isValidParams)(i)) {
                const { message: s } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(s);
            }
            if (!(0, $eeGmU.isValidUrl)(i.uri)) {
                const { message: s } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(s);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $eeGmU.isValidParams)(i)) {
                const { message: n } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $eeGmU.isValidParams)(i)) {
                const { message: n } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $eeGmU.isValidString)(i, !1)) {
                const { message: s } = (0, $eeGmU.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $eeGmU.isExpired)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $eeGmU.getInternalError)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.pairings = new $e9e439c110f17033$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($e9e439c110f17033$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $3YiWF.isJsonRpcRequest)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $3YiWF.isJsonRpcResponse)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($e9e439c110f17033$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $eeGmU.parseExpirerTarget)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $e9e439c110f17033$export$eeb4f10f25d479cb extends (0, $g2mSD.IJsonRpcHistory) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$160142c73cb99dc3, this.version = $e9e439c110f17033$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, n)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: n
            }), this.records.has(s.id)) return;
            const a = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: n,
                expiry: (0, $eeGmU.calcExpiry)((0, $aG48A.THIRTY_DAYS))
            };
            this.records.set(a.id, a), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.created, a);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $3YiWF.isJsonRpcError)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((n)=>{
                if (n.topic === i) {
                    if (typeof s < "u" && n.id !== s) return;
                    this.records.delete(n.id), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.deleted, n);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $57Nk6.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $eeGmU.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$a682338b5ffca937.created, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.updated, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.deleted, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $2Qwpn.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $aG48A.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$e76805ce609031cb extends (0, $g2mSD.IExpirer) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$4ddf883392bbc828, this.version = $e9e439c110f17033$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const n = this.formatTarget(i), a = {
                target: n,
                expiry: s
            };
            this.expirations.set(n, a), this.checkExpiry(n, a), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.created, {
                target: n,
                expiration: a
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), n = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: n
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $eeGmU.formatTopicTarget)(e);
        if (typeof e == "number") return (0, $eeGmU.formatIdTarget)(e);
        const { message: t } = (0, $eeGmU.getInternalError)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $eeGmU.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $eeGmU.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $aG48A.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $2Qwpn.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.created, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.expired, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $eeGmU.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$91a8e56769aeb334 extends (0, $g2mSD.IVerify) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $e9e439c110f17033$export$3b58f2450f2297e3, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (i)=>{
            if (this.verifyDisabled || (0, $eeGmU.isReactNative)() || !(0, $eeGmU.isBrowser)()) return;
            const s = i?.verifyUrl || $e9e439c110f17033$export$7e3b1a28ddecdbaa;
            this.verifyUrl !== s && this.removeIframe(), this.verifyUrl = s;
            try {
                await this.createIframe();
            } catch (n) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(n);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = $e9e439c110f17033$export$4fe83ee8f9aec7b6;
                try {
                    await this.createIframe();
                } catch (n) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(n), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = i?.verifyUrl || $e9e439c110f17033$export$7e3b1a28ddecdbaa;
            let n;
            try {
                n = await this.fetchAttestation(i.attestationId, s);
            } catch (a) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(a), n = await this.fetchAttestation(i.attestationId, $e9e439c110f17033$export$4fe83ee8f9aec7b6);
            }
            return n;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const n = this.startAbortTimer((0, $aG48A.ONE_SECOND) * 2), a = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(n), a.status === 200 ? await a.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (n)=>{
                n.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((n)=>{
                    if (document.getElementById($e9e439c110f17033$export$3b58f2450f2297e3)) return n();
                    window.addEventListener("message", s);
                    const a = document.createElement("iframe");
                    a.id = $e9e439c110f17033$export$3b58f2450f2297e3, a.src = `${this.verifyUrl}/${this.projectId}`, a.style.display = "none", document.body.append(a), this.iframe = a, i = n;
                }),
                new Promise((n, a)=>setTimeout(()=>{
                        window.removeEventListener("message", s), a("verify iframe load timeout");
                    }, (0, $aG48A.toMiliseconds)((0, $aG48A.FIVE_SECONDS))))
            ]);
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.verifyUrl = $e9e439c110f17033$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $eeGmU.isNode)() && undefined;
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $aG48A.toMiliseconds)(e));
    }
}
var $e9e439c110f17033$var$Pr = Object.defineProperty, $e9e439c110f17033$var$Bt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Or = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$xr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Vt = (r, e, t)=>e in r ? $e9e439c110f17033$var$Pr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$qt = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Or.call(e, t) && $e9e439c110f17033$var$Vt(r, t, e[t]);
    if ($e9e439c110f17033$var$Bt) for (var t of $e9e439c110f17033$var$Bt(e))$e9e439c110f17033$var$xr.call(e, t) && $e9e439c110f17033$var$Vt(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$2e2bcd8739ae039 extends (0, $g2mSD.ICore) {
    constructor(e){
        super(e), this.protocol = $e9e439c110f17033$export$51b1c900ac262bdf, this.version = $e9e439c110f17033$export$f30bd3c8747cdfbe, this.name = $e9e439c110f17033$export$d47601f9de5ee22b, this.events = new (0, $7etJZ.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a;
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $aY1FL.pino)((0, $aY1FL.getDefaultLoggerOptions)({
            level: e?.logger || $e9e439c110f17033$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $aY1FL.generateChildLogger)(t, this.name), this.heartbeat = new (0, $2Qwpn.HeartBeat), this.crypto = new $e9e439c110f17033$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $e9e439c110f17033$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $e9e439c110f17033$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, (/*@__PURE__*/$parcel$interopDefault($8uTvE)))($e9e439c110f17033$var$qt($e9e439c110f17033$var$qt({}, $e9e439c110f17033$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $e9e439c110f17033$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $e9e439c110f17033$export$3370ee24730992a3(this, this.logger), this.verify = new $e9e439c110f17033$export$91a8e56769aeb334(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $e9e439c110f17033$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($e9e439c110f17033$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $aY1FL.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $e9e439c110f17033$export$4143ab5b91744744 = $e9e439c110f17033$export$2e2bcd8739ae039;

});
parcelRequire.register("8uTvE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyValueStorage = void 0;

var $1shc9 = parcelRequire("1shc9");

var $lT07n = parcelRequire("lT07n");

const $62fc2f1c5fb46a11$var$localStorage_1 = $1shc9.__importDefault((parcelRequire("bKt7V")));

var $ftqhb = parcelRequire("ftqhb");
class $62fc2f1c5fb46a11$var$KeyValueStorage {
    constructor(){
        this.localStorage = $62fc2f1c5fb46a11$var$localStorage_1.default;
    }
    getKeys() {
        return $1shc9.__awaiter(this, void 0, void 0, function*() {
            return Object.keys(this.localStorage);
        });
    }
    getEntries() {
        return $1shc9.__awaiter(this, void 0, void 0, function*() {
            return Object.entries(this.localStorage).map($ftqhb.parseEntry);
        });
    }
    getItem(key) {
        return $1shc9.__awaiter(this, void 0, void 0, function*() {
            const item = this.localStorage.getItem(key);
            if (item === null) return undefined;
            return $lT07n.safeJsonParse(item);
        });
    }
    setItem(key, value) {
        return $1shc9.__awaiter(this, void 0, void 0, function*() {
            this.localStorage.setItem(key, $lT07n.safeJsonStringify(value));
        });
    }
    removeItem(key) {
        return $1shc9.__awaiter(this, void 0, void 0, function*() {
            this.localStorage.removeItem(key);
        });
    }
}
module.exports.KeyValueStorage = $62fc2f1c5fb46a11$var$KeyValueStorage;
module.exports.default = $62fc2f1c5fb46a11$var$KeyValueStorage;

});
parcelRequire.register("1shc9", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $10f5be862631e270$export$1050f835b63b671e);
$parcel$export(module.exports, "__exportStar", () => $10f5be862631e270$export$f33643c0debef087);
$parcel$export(module.exports, "__importDefault", () => $10f5be862631e270$export$da59b14a69baef04);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $10f5be862631e270$var$extendStatics = function(d, b) {
    $10f5be862631e270$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $10f5be862631e270$var$extendStatics(d, b);
};
function $10f5be862631e270$export$a8ba968b8961cb8a(d, b) {
    $10f5be862631e270$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $10f5be862631e270$export$18ce0697a983be9b = function() {
    $10f5be862631e270$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $10f5be862631e270$export$18ce0697a983be9b.apply(this, arguments);
};
function $10f5be862631e270$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $10f5be862631e270$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $10f5be862631e270$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $10f5be862631e270$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $10f5be862631e270$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $10f5be862631e270$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $10f5be862631e270$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $10f5be862631e270$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $10f5be862631e270$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $10f5be862631e270$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $10f5be862631e270$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($10f5be862631e270$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $10f5be862631e270$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $10f5be862631e270$export$10c90e4f7922046c(v) {
    return this instanceof $10f5be862631e270$export$10c90e4f7922046c ? (this.v = v, this) : new $10f5be862631e270$export$10c90e4f7922046c(v);
}
function $10f5be862631e270$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $10f5be862631e270$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $10f5be862631e270$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $10f5be862631e270$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $10f5be862631e270$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $10f5be862631e270$export$19a8beecd37a4c45 === "function" ? $10f5be862631e270$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $10f5be862631e270$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $10f5be862631e270$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $10f5be862631e270$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $10f5be862631e270$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $10f5be862631e270$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("lT07n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $feeed37a0b619d8b$var$safeJsonParse(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
module.exports.safeJsonParse = $feeed37a0b619d8b$var$safeJsonParse;
function $feeed37a0b619d8b$var$safeJsonStringify(value) {
    return typeof value === "string" ? value : JSON.stringify(value, (key, value)=>typeof value === "undefined" ? null : value);
}
module.exports.safeJsonStringify = $feeed37a0b619d8b$var$safeJsonStringify;

});

parcelRequire.register("bKt7V", function(module, exports) {
"use strict";
(function() {
    "use strict";
    let db;
    function LocalStorage() {}
    db = LocalStorage;
    db.prototype.getItem = function(key) {
        if (this.hasOwnProperty(key)) return String(this[key]);
        return null;
    };
    db.prototype.setItem = function(key, val) {
        this[key] = String(val);
    };
    db.prototype.removeItem = function(key) {
        delete this[key];
    };
    db.prototype.clear = function() {
        const self = this;
        Object.keys(self).forEach(function(key) {
            self[key] = undefined;
            delete self[key];
        });
    };
    db.prototype.key = function(i) {
        i = i || 0;
        return Object.keys(this)[i];
    };
    db.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    });
    if (typeof $parcel$global !== "undefined" && $parcel$global.localStorage) module.exports = $parcel$global.localStorage;
    else if (typeof window !== "undefined" && window.localStorage) module.exports = window.localStorage;
    else module.exports = new LocalStorage();
})();

});

parcelRequire.register("ftqhb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1shc9 = parcelRequire("1shc9");

$1shc9.__exportStar((parcelRequire("57Lgo")), module.exports);

$1shc9.__exportStar((parcelRequire("3ycQJ")), module.exports);

});
parcelRequire.register("57Lgo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IKeyValueStorage = void 0;
class $3bb244b70aa66fad$var$IKeyValueStorage {
}
module.exports.IKeyValueStorage = $3bb244b70aa66fad$var$IKeyValueStorage;

});

parcelRequire.register("3ycQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseEntry = void 0;

var $lT07n = parcelRequire("lT07n");
function $295e83bbcb24cf7b$var$parseEntry(entry) {
    var _a;
    return [
        entry[0],
        $lT07n.safeJsonParse((_a = entry[1]) !== null && _a !== void 0 ? _a : "")
    ];
}
module.exports.parseEntry = $295e83bbcb24cf7b$var$parseEntry;

});



parcelRequire.register("2Qwpn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dm6Bj = parcelRequire("dm6Bj");

$dm6Bj.__exportStar((parcelRequire("48YDT")), module.exports);

$dm6Bj.__exportStar((parcelRequire("5nu18")), module.exports);

$dm6Bj.__exportStar((parcelRequire("1nGZv")), module.exports);

});
parcelRequire.register("dm6Bj", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $9b927333a48cb877$export$1050f835b63b671e);
$parcel$export(module.exports, "__exportStar", () => $9b927333a48cb877$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $9b927333a48cb877$var$extendStatics = function(d, b) {
    $9b927333a48cb877$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $9b927333a48cb877$var$extendStatics(d, b);
};
function $9b927333a48cb877$export$a8ba968b8961cb8a(d, b) {
    $9b927333a48cb877$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9b927333a48cb877$export$18ce0697a983be9b = function() {
    $9b927333a48cb877$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b927333a48cb877$export$18ce0697a983be9b.apply(this, arguments);
};
function $9b927333a48cb877$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9b927333a48cb877$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9b927333a48cb877$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9b927333a48cb877$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9b927333a48cb877$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9b927333a48cb877$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $9b927333a48cb877$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $9b927333a48cb877$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $9b927333a48cb877$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9b927333a48cb877$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9b927333a48cb877$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9b927333a48cb877$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9b927333a48cb877$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9b927333a48cb877$export$10c90e4f7922046c(v) {
    return this instanceof $9b927333a48cb877$export$10c90e4f7922046c ? (this.v = v, this) : new $9b927333a48cb877$export$10c90e4f7922046c(v);
}
function $9b927333a48cb877$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9b927333a48cb877$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9b927333a48cb877$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9b927333a48cb877$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $9b927333a48cb877$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9b927333a48cb877$export$19a8beecd37a4c45 === "function" ? $9b927333a48cb877$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9b927333a48cb877$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $9b927333a48cb877$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $9b927333a48cb877$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9b927333a48cb877$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $9b927333a48cb877$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("48YDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $dm6Bj = parcelRequire("dm6Bj");

var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

var $5nu18 = parcelRequire("5nu18");

var $1nGZv = parcelRequire("1nGZv");
class $3046f31a17013644$var$HeartBeat extends $5nu18.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $7etJZ.EventEmitter();
        this.interval = $1nGZv.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $1nGZv.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $dm6Bj.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $3046f31a17013644$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $dm6Bj.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $dm6Bj.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $aG48A.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($1nGZv.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $3046f31a17013644$var$HeartBeat;

});
parcelRequire.register("5nu18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dm6Bj = parcelRequire("dm6Bj");

$dm6Bj.__exportStar((parcelRequire("bVfbs")), module.exports);

});
parcelRequire.register("bVfbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");
class $8ae0cbc8ca291b66$var$IHeartBeat extends $3VSyk.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $8ae0cbc8ca291b66$var$IHeartBeat;

});
parcelRequire.register("37EVq", function(module, exports) {
$parcel$export(module.exports, "IEvents", () => (parcelRequire("3VSyk")).IEvents);
parcelRequire("3VSyk");

});
parcelRequire.register("3VSyk", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $2dd102fe42a3c147$export$ab429ec7e240e546);
class $2dd102fe42a3c147$export$ab429ec7e240e546 {
}

});




parcelRequire.register("1nGZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dm6Bj = parcelRequire("dm6Bj");

$dm6Bj.__exportStar((parcelRequire("18uwn")), module.exports);

});
parcelRequire.register("18uwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $aG48A = parcelRequire("aG48A");
module.exports.HEARTBEAT_INTERVAL = $aG48A.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});




parcelRequire.register("aY1FL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pino = void 0;

var $40xiR = parcelRequire("40xiR");

const $7fc0ce2591a9daef$var$pino_1 = $40xiR.__importDefault((parcelRequire("kgxrf")));
Object.defineProperty(module.exports, "pino", {
    enumerable: true,
    get: function() {
        return $7fc0ce2591a9daef$var$pino_1.default;
    }
});

$40xiR.__exportStar((parcelRequire("glyO2")), module.exports);

$40xiR.__exportStar((parcelRequire("cyyD4")), module.exports);

});
parcelRequire.register("40xiR", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $2eb0fecfd7f1fc2d$export$f33643c0debef087);
$parcel$export(module.exports, "__importDefault", () => $2eb0fecfd7f1fc2d$export$da59b14a69baef04);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2eb0fecfd7f1fc2d$var$extendStatics = function(d, b) {
    $2eb0fecfd7f1fc2d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2eb0fecfd7f1fc2d$var$extendStatics(d, b);
};
function $2eb0fecfd7f1fc2d$export$a8ba968b8961cb8a(d, b) {
    $2eb0fecfd7f1fc2d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2eb0fecfd7f1fc2d$export$18ce0697a983be9b = function() {
    $2eb0fecfd7f1fc2d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2eb0fecfd7f1fc2d$export$18ce0697a983be9b.apply(this, arguments);
};
function $2eb0fecfd7f1fc2d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2eb0fecfd7f1fc2d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2eb0fecfd7f1fc2d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2eb0fecfd7f1fc2d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2eb0fecfd7f1fc2d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2eb0fecfd7f1fc2d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2eb0fecfd7f1fc2d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2eb0fecfd7f1fc2d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2eb0fecfd7f1fc2d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2eb0fecfd7f1fc2d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2eb0fecfd7f1fc2d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2eb0fecfd7f1fc2d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2eb0fecfd7f1fc2d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2eb0fecfd7f1fc2d$export$10c90e4f7922046c(v) {
    return this instanceof $2eb0fecfd7f1fc2d$export$10c90e4f7922046c ? (this.v = v, this) : new $2eb0fecfd7f1fc2d$export$10c90e4f7922046c(v);
}
function $2eb0fecfd7f1fc2d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2eb0fecfd7f1fc2d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2eb0fecfd7f1fc2d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2eb0fecfd7f1fc2d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2eb0fecfd7f1fc2d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2eb0fecfd7f1fc2d$export$19a8beecd37a4c45 === "function" ? $2eb0fecfd7f1fc2d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2eb0fecfd7f1fc2d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2eb0fecfd7f1fc2d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2eb0fecfd7f1fc2d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2eb0fecfd7f1fc2d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2eb0fecfd7f1fc2d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("kgxrf", function(module, exports) {
"use strict";

var $7h4xj = parcelRequire("7h4xj");
module.exports = $03ceb28a240053b3$var$pino;
const $03ceb28a240053b3$var$_console = $03ceb28a240053b3$var$pfGlobalThisOrFallback().console || {};
const $03ceb28a240053b3$var$stdSerializers = {
    mapHttpRequest: $03ceb28a240053b3$var$mock,
    mapHttpResponse: $03ceb28a240053b3$var$mock,
    wrapRequestSerializer: $03ceb28a240053b3$var$passthrough,
    wrapResponseSerializer: $03ceb28a240053b3$var$passthrough,
    wrapErrorSerializer: $03ceb28a240053b3$var$passthrough,
    req: $03ceb28a240053b3$var$mock,
    res: $03ceb28a240053b3$var$mock,
    err: $03ceb28a240053b3$var$asErrValue
};
function $03ceb28a240053b3$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $03ceb28a240053b3$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $03ceb28a240053b3$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $03ceb28a240053b3$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $03ceb28a240053b3$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $03ceb28a240053b3$var$getTimeFunction(opts)
    };
    logger.levels = $03ceb28a240053b3$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $03ceb28a240053b3$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $03ceb28a240053b3$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $03ceb28a240053b3$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $03ceb28a240053b3$var$set(setOpts, logger, "fatal", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "warn", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "info", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "debug", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $03ceb28a240053b3$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $03ceb28a240053b3$var$bind(parent, bindings, "error");
            this.fatal = $03ceb28a240053b3$var$bind(parent, bindings, "fatal");
            this.warn = $03ceb28a240053b3$var$bind(parent, bindings, "warn");
            this.info = $03ceb28a240053b3$var$bind(parent, bindings, "info");
            this.debug = $03ceb28a240053b3$var$bind(parent, bindings, "debug");
            this.trace = $03ceb28a240053b3$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $03ceb28a240053b3$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$03ceb28a240053b3$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$03ceb28a240053b3$var$pino.stdSerializers = $03ceb28a240053b3$var$stdSerializers;
$03ceb28a240053b3$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $03ceb28a240053b3$var$nullTime,
    epochTime: $03ceb28a240053b3$var$epochTime,
    unixTime: $03ceb28a240053b3$var$unixTime,
    isoTime: $03ceb28a240053b3$var$isoTime
});
function $03ceb28a240053b3$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $03ceb28a240053b3$var$noop : proto[level] ? proto[level] : $03ceb28a240053b3$var$_console[level] || $03ceb28a240053b3$var$_console[fallback] || $03ceb28a240053b3$var$noop;
    $03ceb28a240053b3$var$wrap(opts, logger, level);
}
function $03ceb28a240053b3$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $03ceb28a240053b3$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $03ceb28a240053b3$var$_console ? $03ceb28a240053b3$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $03ceb28a240053b3$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $03ceb28a240053b3$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $03ceb28a240053b3$var$pino.levels.values[transmitLevel];
                const methodValue = $03ceb28a240053b3$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $03ceb28a240053b3$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $03ceb28a240053b3$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $03ceb28a240053b3$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $03ceb28a240053b3$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $03ceb28a240053b3$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $7h4xj(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $7h4xj(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $03ceb28a240053b3$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $03ceb28a240053b3$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $03ceb28a240053b3$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $03ceb28a240053b3$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $03ceb28a240053b3$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $03ceb28a240053b3$var$createLogEventShape(bindings);
}
function $03ceb28a240053b3$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $03ceb28a240053b3$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $03ceb28a240053b3$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $03ceb28a240053b3$var$nullTime;
    return $03ceb28a240053b3$var$epochTime;
}
function $03ceb28a240053b3$var$mock() {
    return {};
}
function $03ceb28a240053b3$var$passthrough(a) {
    return a;
}
function $03ceb28a240053b3$var$noop() {}
function $03ceb28a240053b3$var$nullTime() {
    return false;
}
function $03ceb28a240053b3$var$epochTime() {
    return Date.now();
}
function $03ceb28a240053b3$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $03ceb28a240053b3$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $03ceb28a240053b3$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRequire.register("7h4xj", function(module, exports) {
"use strict";
function $54bda3badc858a5e$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $54bda3badc858a5e$var$format;
function $54bda3badc858a5e$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $54bda3badc858a5e$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRequire.register("glyO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRequire.register("cyyD4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $glyO2 = parcelRequire("glyO2");
function $924385a22f0d1fa4$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $glyO2.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $924385a22f0d1fa4$var$getDefaultLoggerOptions;
function $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $924385a22f0d1fa4$var$getBrowserLoggerContext;
function $924385a22f0d1fa4$var$setBrowserLoggerContext(logger, context, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $924385a22f0d1fa4$var$setBrowserLoggerContext;
function $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $924385a22f0d1fa4$var$getLoggerContext;
function $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $924385a22f0d1fa4$var$formatChildLoggerContext;
function $924385a22f0d1fa4$var$generateChildLogger(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $924385a22f0d1fa4$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $924385a22f0d1fa4$var$generateChildLogger;

});


parcelRequire.register("g2mSD", function(module, exports) {

$parcel$export(module.exports, "ICore", () => $bace94c1ef08d1bc$export$ed533416df113881);
$parcel$export(module.exports, "IJsonRpcHistory", () => $bace94c1ef08d1bc$export$45b2c2643615b67);
$parcel$export(module.exports, "IMessageTracker", () => $bace94c1ef08d1bc$export$e67570fe0a885c47);
$parcel$export(module.exports, "IPublisher", () => $bace94c1ef08d1bc$export$3b0872bbd7e675a2);
$parcel$export(module.exports, "IRelayer", () => $bace94c1ef08d1bc$export$9a0f755fd4f79434);
$parcel$export(module.exports, "IStore", () => $bace94c1ef08d1bc$export$a7f17ba6c54777e7);
$parcel$export(module.exports, "ISubscriber", () => $bace94c1ef08d1bc$export$300eed987e764b57);
$parcel$export(module.exports, "IExpirer", () => $bace94c1ef08d1bc$export$41aaa3c39f6f2861);
$parcel$export(module.exports, "IVerify", () => $bace94c1ef08d1bc$export$873b0b865d85ddb6);
$parcel$export(module.exports, "ISignClient", () => $bace94c1ef08d1bc$export$2ebcf6eeacedad44);
$parcel$export(module.exports, "IEngine", () => $bace94c1ef08d1bc$export$87df43c730effa30);
parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");

var $7etJZ = parcelRequire("7etJZ");
class $bace94c1ef08d1bc$export$ed533416df113881 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$45b2c2643615b67 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $bace94c1ef08d1bc$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$3b0872bbd7e675a2 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$9a0f755fd4f79434 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super();
    }
}
class $bace94c1ef08d1bc$export$a7f17ba6c54777e7 {
    constructor(s, t, o, w){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $bace94c1ef08d1bc$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $bace94c1ef08d1bc$export$300eed987e764b57 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$41aaa3c39f6f2861 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$623dd0f793f15643 extends (0, $7etJZ.EventEmitter) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}

});

parcelRequire.register("b8Ion", function(module, exports) {

$parcel$export(module.exports, "safeJsonParse", () => $81c2e06d24b89184$export$84137bb44359aed5);
$parcel$export(module.exports, "safeJsonStringify", () => $81c2e06d24b89184$export$abc3f407e87918a4);
const $81c2e06d24b89184$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $81c2e06d24b89184$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $81c2e06d24b89184$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $81c2e06d24b89184$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $81c2e06d24b89184$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $81c2e06d24b89184$var$JSONStringify(value) || "";
}

});

parcelRequire.register("fVWg2", function(module, exports) {
$parcel$export(module.exports, "generateKeyPair", () => (parcelRequire("2XFRM")).generateKeyPair);
$parcel$export(module.exports, "signJWT", () => (parcelRequire("2XFRM")).signJWT);
$parcel$export(module.exports, "encodeIss", () => (parcelRequire("lcitG")).encodeIss);
parcelRequire("2XFRM");
parcelRequire("7xk3o");

var $2QyAh = parcelRequire("2QyAh");
parcelRequire("lcitG");
$parcel$exportWildcard(module.exports, $2QyAh);

});
parcelRequire.register("2XFRM", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $2281914794d9e636$export$a949d36eab55b41f);
$parcel$export(module.exports, "signJWT", () => $2281914794d9e636$export$a8dda30659d36d45);

var $dTuj7 = parcelRequire("dTuj7");

var $9Ve5w = parcelRequire("9Ve5w");

var $aG48A = parcelRequire("aG48A");

var $7xk3o = parcelRequire("7xk3o");

var $lcitG = parcelRequire("lcitG");
function $2281914794d9e636$export$a949d36eab55b41f(seed = (0, $9Ve5w.randomBytes)((0, $7xk3o.KEY_PAIR_SEED_LENGTH))) {
    return $dTuj7.generateKeyPairFromSeed(seed);
}
async function $2281914794d9e636$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $aG48A.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $7xk3o.JWT_IRIDIUM_ALG),
        typ: (0, $7xk3o.JWT_IRIDIUM_TYP)
    };
    const iss = (0, $lcitG.encodeIss)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $lcitG.encodeData)({
        header: header,
        payload: payload
    });
    const signature = $dTuj7.sign(keyPair.secretKey, data);
    return (0, $lcitG.encodeJWT)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $2281914794d9e636$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $lcitG.decodeJWT)(jwt);
    if (header.alg !== (0, $7xk3o.JWT_IRIDIUM_ALG) || header.typ !== (0, $7xk3o.JWT_IRIDIUM_TYP)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $lcitG.decodeIss)(payload.iss);
    return $dTuj7.verify(publicKey, data, signature);
}

});
parcelRequire.register("dTuj7", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertSecretKeyToX25519 = module.exports.convertPublicKeyToX25519 = module.exports.verify = module.exports.sign = module.exports.extractPublicKeyFromSecretKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.SEED_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = module.exports.SIGNATURE_LENGTH = void 0;

var $9Ve5w = parcelRequire("9Ve5w");

var $3QldY = parcelRequire("3QldY");

var $3nJ3u = parcelRequire("3nJ3u");
module.exports.SIGNATURE_LENGTH = 64;
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 64;
module.exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $a1d7ebd43ba0a83c$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $a1d7ebd43ba0a83c$var$_9 = new Uint8Array(32);
$a1d7ebd43ba0a83c$var$_9[0] = 9;
const $a1d7ebd43ba0a83c$var$gf0 = $a1d7ebd43ba0a83c$var$gf();
const $a1d7ebd43ba0a83c$var$gf1 = $a1d7ebd43ba0a83c$var$gf([
    1
]);
const $a1d7ebd43ba0a83c$var$D = $a1d7ebd43ba0a83c$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $a1d7ebd43ba0a83c$var$D2 = $a1d7ebd43ba0a83c$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $a1d7ebd43ba0a83c$var$X = $a1d7ebd43ba0a83c$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $a1d7ebd43ba0a83c$var$Y = $a1d7ebd43ba0a83c$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $a1d7ebd43ba0a83c$var$I = $a1d7ebd43ba0a83c$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $a1d7ebd43ba0a83c$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $a1d7ebd43ba0a83c$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $a1d7ebd43ba0a83c$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $a1d7ebd43ba0a83c$var$pack25519(o, n) {
    const m = $a1d7ebd43ba0a83c$var$gf();
    const t = $a1d7ebd43ba0a83c$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $a1d7ebd43ba0a83c$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $a1d7ebd43ba0a83c$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $a1d7ebd43ba0a83c$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(c, a);
    $a1d7ebd43ba0a83c$var$pack25519(d, b);
    return $a1d7ebd43ba0a83c$var$verify32(c, d);
}
function $a1d7ebd43ba0a83c$var$par25519(a) {
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(d, a);
    return d[0] & 1;
}
function $a1d7ebd43ba0a83c$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $a1d7ebd43ba0a83c$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $a1d7ebd43ba0a83c$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $a1d7ebd43ba0a83c$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $a1d7ebd43ba0a83c$var$square(o, a) {
    $a1d7ebd43ba0a83c$var$mul(o, a, a);
}
function $a1d7ebd43ba0a83c$var$inv25519(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 2 && a !== 4) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$pow2523(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 1) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$edadd(p, q) {
    const a = $a1d7ebd43ba0a83c$var$gf(), b = $a1d7ebd43ba0a83c$var$gf(), c = $a1d7ebd43ba0a83c$var$gf(), d = $a1d7ebd43ba0a83c$var$gf(), e = $a1d7ebd43ba0a83c$var$gf(), f = $a1d7ebd43ba0a83c$var$gf(), g = $a1d7ebd43ba0a83c$var$gf(), h = $a1d7ebd43ba0a83c$var$gf(), t = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$sub(a, p[1], p[0]);
    $a1d7ebd43ba0a83c$var$sub(t, q[1], q[0]);
    $a1d7ebd43ba0a83c$var$mul(a, a, t);
    $a1d7ebd43ba0a83c$var$add(b, p[0], p[1]);
    $a1d7ebd43ba0a83c$var$add(t, q[0], q[1]);
    $a1d7ebd43ba0a83c$var$mul(b, b, t);
    $a1d7ebd43ba0a83c$var$mul(c, p[3], q[3]);
    $a1d7ebd43ba0a83c$var$mul(c, c, $a1d7ebd43ba0a83c$var$D2);
    $a1d7ebd43ba0a83c$var$mul(d, p[2], q[2]);
    $a1d7ebd43ba0a83c$var$add(d, d, d);
    $a1d7ebd43ba0a83c$var$sub(e, b, a);
    $a1d7ebd43ba0a83c$var$sub(f, d, c);
    $a1d7ebd43ba0a83c$var$add(g, d, c);
    $a1d7ebd43ba0a83c$var$add(h, b, a);
    $a1d7ebd43ba0a83c$var$mul(p[0], e, f);
    $a1d7ebd43ba0a83c$var$mul(p[1], h, g);
    $a1d7ebd43ba0a83c$var$mul(p[2], g, f);
    $a1d7ebd43ba0a83c$var$mul(p[3], e, h);
}
function $a1d7ebd43ba0a83c$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$a1d7ebd43ba0a83c$var$sel25519(p[i], q[i], b);
}
function $a1d7ebd43ba0a83c$var$pack(r, p) {
    const tx = $a1d7ebd43ba0a83c$var$gf(), ty = $a1d7ebd43ba0a83c$var$gf(), zi = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$inv25519(zi, p[2]);
    $a1d7ebd43ba0a83c$var$mul(tx, p[0], zi);
    $a1d7ebd43ba0a83c$var$mul(ty, p[1], zi);
    $a1d7ebd43ba0a83c$var$pack25519(r, ty);
    r[31] ^= $a1d7ebd43ba0a83c$var$par25519(tx) << 7;
}
function $a1d7ebd43ba0a83c$var$scalarmult(p, q, s) {
    $a1d7ebd43ba0a83c$var$set25519(p[0], $a1d7ebd43ba0a83c$var$gf0);
    $a1d7ebd43ba0a83c$var$set25519(p[1], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[3], $a1d7ebd43ba0a83c$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
        $a1d7ebd43ba0a83c$var$edadd(q, p);
        $a1d7ebd43ba0a83c$var$edadd(p, p);
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
    }
}
function $a1d7ebd43ba0a83c$var$scalarbase(p, s) {
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$set25519(q[0], $a1d7ebd43ba0a83c$var$X);
    $a1d7ebd43ba0a83c$var$set25519(q[1], $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$set25519(q[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$mul(q[3], $a1d7ebd43ba0a83c$var$X, $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${module.exports.SEED_LENGTH} bytes`);
    const d = (0, $3QldY.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$scalarbase(p, d);
    $a1d7ebd43ba0a83c$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed;
function $a1d7ebd43ba0a83c$var$generateKeyPair(prng) {
    const seed = (0, $9Ve5w.randomBytes)(32, prng);
    const result = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed);
    (0, $3nJ3u.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $a1d7ebd43ba0a83c$var$generateKeyPair;
function $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
module.exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey;
const $a1d7ebd43ba0a83c$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $a1d7ebd43ba0a83c$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $a1d7ebd43ba0a83c$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $a1d7ebd43ba0a83c$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $a1d7ebd43ba0a83c$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $a1d7ebd43ba0a83c$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $a1d7ebd43ba0a83c$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $a1d7ebd43ba0a83c$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const d = (0, $3QldY.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $3QldY.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $a1d7ebd43ba0a83c$var$reduce(r);
    $a1d7ebd43ba0a83c$var$scalarbase(p, r);
    $a1d7ebd43ba0a83c$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $a1d7ebd43ba0a83c$var$modL(signature.subarray(32), x);
    return signature;
}
module.exports.sign = $a1d7ebd43ba0a83c$var$sign;
function $a1d7ebd43ba0a83c$var$unpackneg(r, p) {
    const t = $a1d7ebd43ba0a83c$var$gf(), chk = $a1d7ebd43ba0a83c$var$gf(), num = $a1d7ebd43ba0a83c$var$gf(), den = $a1d7ebd43ba0a83c$var$gf(), den2 = $a1d7ebd43ba0a83c$var$gf(), den4 = $a1d7ebd43ba0a83c$var$gf(), den6 = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$set25519(r[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$unpack25519(r[1], p);
    $a1d7ebd43ba0a83c$var$square(num, r[1]);
    $a1d7ebd43ba0a83c$var$mul(den, num, $a1d7ebd43ba0a83c$var$D);
    $a1d7ebd43ba0a83c$var$sub(num, num, r[2]);
    $a1d7ebd43ba0a83c$var$add(den, r[2], den);
    $a1d7ebd43ba0a83c$var$square(den2, den);
    $a1d7ebd43ba0a83c$var$square(den4, den2);
    $a1d7ebd43ba0a83c$var$mul(den6, den4, den2);
    $a1d7ebd43ba0a83c$var$mul(t, den6, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$pow2523(t, t);
    $a1d7ebd43ba0a83c$var$mul(t, t, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(r[0], t, den);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) $a1d7ebd43ba0a83c$var$mul(r[0], r[0], $a1d7ebd43ba0a83c$var$I);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) return -1;
    if ($a1d7ebd43ba0a83c$var$par25519(r[0]) === p[31] >> 7) $a1d7ebd43ba0a83c$var$sub(r[0], $a1d7ebd43ba0a83c$var$gf0, r[0]);
    $a1d7ebd43ba0a83c$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $a1d7ebd43ba0a83c$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if (signature.length !== module.exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${module.exports.SIGNATURE_LENGTH} bytes`);
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) return false;
    const hs = new $3QldY.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, h);
    $a1d7ebd43ba0a83c$var$scalarbase(q, signature.subarray(32));
    $a1d7ebd43ba0a83c$var$edadd(p, q);
    $a1d7ebd43ba0a83c$var$pack(t, p);
    if ($a1d7ebd43ba0a83c$var$verify32(signature, t)) return false;
    return true;
}
module.exports.verify = $a1d7ebd43ba0a83c$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $a1d7ebd43ba0a83c$var$gf();
    let b = $a1d7ebd43ba0a83c$var$gf();
    let y = q[1];
    $a1d7ebd43ba0a83c$var$add(a, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$sub(b, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$inv25519(b, b);
    $a1d7ebd43ba0a83c$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(z, a);
    return z;
}
module.exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $3QldY.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $3nJ3u.wipe)(d);
    return o;
}
module.exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519;

});
parcelRequire.register("3QldY", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j2SFD = parcelRequire("j2SFD");

var $3nJ3u = parcelRequire("3nJ3u");
module.exports.DIGEST_LENGTH = 64;
module.exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $2cc6b12a8ccb780d$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $3nJ3u.wipe(this._buffer);
        $3nJ3u.wipe(this._tempHi);
        $3nJ3u.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < module.exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $j2SFD.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $j2SFD.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $j2SFD.writeUint32BE(this._stateHi[i], out, i * 8);
            $j2SFD.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $3nJ3u.wipe(savedState.stateHi);
        $3nJ3u.wipe(savedState.stateLo);
        if (savedState.buffer) $3nJ3u.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
module.exports.SHA512 = $2cc6b12a8ccb780d$var$SHA512;
// Constants
var $2cc6b12a8ccb780d$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $2cc6b12a8ccb780d$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $j2SFD.readUint32BE(m, j);
            wl[i] = $j2SFD.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $2cc6b12a8ccb780d$var$K[i * 2];
            l = $2cc6b12a8ccb780d$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $2cc6b12a8ccb780d$var$hash(data) {
    var h = new $2cc6b12a8ccb780d$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $2cc6b12a8ccb780d$var$hash;

});


parcelRequire.register("7xk3o", function(module, exports) {

$parcel$export(module.exports, "JWT_IRIDIUM_ALG", () => $57cb2bb50a99d8e7$export$51745f7832485c34);
$parcel$export(module.exports, "JWT_IRIDIUM_TYP", () => $57cb2bb50a99d8e7$export$f51b45e220f2ba98);
$parcel$export(module.exports, "JWT_DELIMITER", () => $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef);
$parcel$export(module.exports, "JWT_ENCODING", () => $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23);
$parcel$export(module.exports, "JSON_ENCODING", () => $57cb2bb50a99d8e7$export$c09c2801e10a2b95);
$parcel$export(module.exports, "DATA_ENCODING", () => $57cb2bb50a99d8e7$export$1e9219c0b91a4257);
$parcel$export(module.exports, "DID_DELIMITER", () => $57cb2bb50a99d8e7$export$d4057275de9d060b);
$parcel$export(module.exports, "DID_PREFIX", () => $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3);
$parcel$export(module.exports, "DID_METHOD", () => $57cb2bb50a99d8e7$export$b908fe81ccf30934);
$parcel$export(module.exports, "MULTICODEC_ED25519_ENCODING", () => $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471);
$parcel$export(module.exports, "MULTICODEC_ED25519_BASE", () => $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68);
$parcel$export(module.exports, "MULTICODEC_ED25519_HEADER", () => $57cb2bb50a99d8e7$export$9902a33a5776d1fc);
$parcel$export(module.exports, "MULTICODEC_ED25519_LENGTH", () => $57cb2bb50a99d8e7$export$ca477e91394a742a);
$parcel$export(module.exports, "KEY_PAIR_SEED_LENGTH", () => $57cb2bb50a99d8e7$export$f09ad228919f26fb);
const $57cb2bb50a99d8e7$export$51745f7832485c34 = "EdDSA";
const $57cb2bb50a99d8e7$export$f51b45e220f2ba98 = "JWT";
const $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef = ".";
const $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23 = "base64url";
const $57cb2bb50a99d8e7$export$c09c2801e10a2b95 = "utf8";
const $57cb2bb50a99d8e7$export$1e9219c0b91a4257 = "utf8";
const $57cb2bb50a99d8e7$export$d4057275de9d060b = ":";
const $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3 = "did";
const $57cb2bb50a99d8e7$export$b908fe81ccf30934 = "key";
const $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471 = "base58btc";
const $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68 = "z";
const $57cb2bb50a99d8e7$export$9902a33a5776d1fc = "K36";
const $57cb2bb50a99d8e7$export$ca477e91394a742a = 32;
const $57cb2bb50a99d8e7$export$f09ad228919f26fb = 32;

});

parcelRequire.register("lcitG", function(module, exports) {

$parcel$export(module.exports, "encodeIss", () => $f6e90d472e8dfc29$export$1b29ef9371459e10);
$parcel$export(module.exports, "decodeIss", () => $f6e90d472e8dfc29$export$86ac046d72244356);
$parcel$export(module.exports, "encodeData", () => $f6e90d472e8dfc29$export$cfdd1f2478131e3d);
$parcel$export(module.exports, "encodeJWT", () => $f6e90d472e8dfc29$export$1b70f4551c751d68);
$parcel$export(module.exports, "decodeJWT", () => $f6e90d472e8dfc29$export$9a62e6c0a30e00bc);

var $67QIB = parcelRequire("67QIB");

var $gj7w6 = parcelRequire("gj7w6");

var $e9TA6 = parcelRequire("e9TA6");

var $b8Ion = parcelRequire("b8Ion");

var $7xk3o = parcelRequire("7xk3o");
function $f6e90d472e8dfc29$export$2030d1af6cd0ef93(str) {
    return (0, $b8Ion.safeJsonParse)((0, $gj7w6.toString)((0, $e9TA6.fromString)(str, (0, $7xk3o.JWT_ENCODING)), (0, $7xk3o.JSON_ENCODING)));
}
function $f6e90d472e8dfc29$export$84046f8082657cdf(val) {
    return (0, $gj7w6.toString)((0, $e9TA6.fromString)((0, $b8Ion.safeJsonStringify)(val), (0, $7xk3o.JSON_ENCODING)), (0, $7xk3o.JWT_ENCODING));
}
function $f6e90d472e8dfc29$export$1b29ef9371459e10(publicKey) {
    const header = (0, $e9TA6.fromString)((0, $7xk3o.MULTICODEC_ED25519_HEADER), (0, $7xk3o.MULTICODEC_ED25519_ENCODING));
    const multicodec = (0, $7xk3o.MULTICODEC_ED25519_BASE) + (0, $gj7w6.toString)((0, $67QIB.concat)([
        header,
        publicKey
    ]), (0, $7xk3o.MULTICODEC_ED25519_ENCODING));
    return [
        (0, $7xk3o.DID_PREFIX),
        (0, $7xk3o.DID_METHOD),
        multicodec
    ].join((0, $7xk3o.DID_DELIMITER));
}
function $f6e90d472e8dfc29$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $7xk3o.DID_DELIMITER));
    if (prefix !== (0, $7xk3o.DID_PREFIX) || method !== (0, $7xk3o.DID_METHOD)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $7xk3o.MULTICODEC_ED25519_BASE)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $e9TA6.fromString)(multicodec.slice(1), (0, $7xk3o.MULTICODEC_ED25519_ENCODING));
    const type = (0, $gj7w6.toString)(bytes.slice(0, 2), (0, $7xk3o.MULTICODEC_ED25519_ENCODING));
    if (type !== (0, $7xk3o.MULTICODEC_ED25519_HEADER)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $7xk3o.MULTICODEC_ED25519_LENGTH)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $f6e90d472e8dfc29$export$d9746ef301b2089b(bytes) {
    return (0, $gj7w6.toString)(bytes, (0, $7xk3o.JWT_ENCODING));
}
function $f6e90d472e8dfc29$export$c37aeb372ac07c0e(encoded) {
    return (0, $e9TA6.fromString)(encoded, (0, $7xk3o.JWT_ENCODING));
}
function $f6e90d472e8dfc29$export$cfdd1f2478131e3d(params) {
    return (0, $e9TA6.fromString)([
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload)
    ].join((0, $7xk3o.JWT_DELIMITER)), (0, $7xk3o.DATA_ENCODING));
}
function $f6e90d472e8dfc29$export$13923bea59211b58(data) {
    const params = (0, $gj7w6.toString)(data, (0, $7xk3o.DATA_ENCODING)).split((0, $7xk3o.JWT_DELIMITER));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $f6e90d472e8dfc29$export$1b70f4551c751d68(params) {
    return [
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload),
        $f6e90d472e8dfc29$export$d9746ef301b2089b(params.signature)
    ].join((0, $7xk3o.JWT_DELIMITER));
}
function $f6e90d472e8dfc29$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $7xk3o.JWT_DELIMITER));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    const signature = $f6e90d472e8dfc29$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $e9TA6.fromString)(params.slice(0, 2).join((0, $7xk3o.JWT_DELIMITER)), (0, $7xk3o.DATA_ENCODING));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}

});


parcelRequire.register("2QyAh", function(module, exports) {

});


parcelRequire.register("7q0i6", function(module, exports) {
$parcel$export(module.exports, "JsonRpcProvider", () => (parcelRequire("1QugC")).JsonRpcProvider);

var $1QugC = parcelRequire("1QugC");
var $566b2fdf5e300ab1$export$2e2bcd8739ae039 = (0, $1QugC.default);

});
parcelRequire.register("1QugC", function(module, exports) {

$parcel$export(module.exports, "JsonRpcProvider", () => $1582203255a670cd$export$da28308012bf6748);
$parcel$export(module.exports, "default", () => $1582203255a670cd$export$2e2bcd8739ae039);

var $7etJZ = parcelRequire("7etJZ");
parcelRequire("2KWby");
var $57Nk6 = parcelRequire("57Nk6");
var $3YiWF = parcelRequire("3YiWF");
var $6se3b = parcelRequire("6se3b");
class $1582203255a670cd$export$da28308012bf6748 extends (0, $6se3b.IJsonRpcProvider) {
    constructor(connection){
        super(connection);
        this.events = new (0, $7etJZ.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $57Nk6.formatJsonRpcRequest)(request.method, request.params || [], request.id || (0, $57Nk6.getBigIntRpcId)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $3YiWF.isJsonRpcError)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $3YiWF.isJsonRpcResponse)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $1582203255a670cd$export$2e2bcd8739ae039 = $1582203255a670cd$export$da28308012bf6748;

});
parcelRequire.register("2KWby", function(module, exports) {
$parcel$export(module.exports, "parseConnectionError", () => (parcelRequire("eIWLS")).parseConnectionError);
$parcel$export(module.exports, "formatJsonRpcError", () => (parcelRequire("2UPOf")).formatJsonRpcError);
$parcel$export(module.exports, "formatJsonRpcRequest", () => (parcelRequire("2UPOf")).formatJsonRpcRequest);
$parcel$export(module.exports, "formatJsonRpcResult", () => (parcelRequire("2UPOf")).formatJsonRpcResult);
$parcel$export(module.exports, "getBigIntRpcId", () => (parcelRequire("2UPOf")).getBigIntRpcId);
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("2UPOf")).IJsonRpcProvider);
$parcel$export(module.exports, "isHttpUrl", () => (parcelRequire("2UPOf")).isHttpUrl);
$parcel$export(module.exports, "isJsonRpcError", () => (parcelRequire("2UPOf")).isJsonRpcError);
$parcel$export(module.exports, "isJsonRpcRequest", () => (parcelRequire("2UPOf")).isJsonRpcRequest);
$parcel$export(module.exports, "isJsonRpcResponse", () => (parcelRequire("2UPOf")).isJsonRpcResponse);
$parcel$export(module.exports, "isJsonRpcResult", () => (parcelRequire("2UPOf")).isJsonRpcResult);
$parcel$export(module.exports, "isLocalhostUrl", () => (parcelRequire("2UPOf")).isLocalhostUrl);
$parcel$export(module.exports, "isReactNative", () => (parcelRequire("2UPOf")).isReactNative);
$parcel$export(module.exports, "isWsUrl", () => (parcelRequire("2UPOf")).isWsUrl);
$parcel$export(module.exports, "parseConnectionError", () => (parcelRequire("2UPOf")).parseConnectionError);
$parcel$export(module.exports, "payloadId", () => (parcelRequire("2UPOf")).payloadId);
$parcel$export(module.exports, "formatJsonRpcError", () => (parcelRequire("57Nk6")).formatJsonRpcError);
$parcel$export(module.exports, "formatJsonRpcRequest", () => (parcelRequire("57Nk6")).formatJsonRpcRequest);
$parcel$export(module.exports, "formatJsonRpcResult", () => (parcelRequire("57Nk6")).formatJsonRpcResult);
$parcel$export(module.exports, "getBigIntRpcId", () => (parcelRequire("57Nk6")).getBigIntRpcId);
$parcel$export(module.exports, "payloadId", () => (parcelRequire("57Nk6")).payloadId);
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("6se3b")).IJsonRpcProvider);
$parcel$export(module.exports, "isHttpUrl", () => (parcelRequire("hKdqT")).isHttpUrl);
$parcel$export(module.exports, "isLocalhostUrl", () => (parcelRequire("hKdqT")).isLocalhostUrl);
$parcel$export(module.exports, "isWsUrl", () => (parcelRequire("hKdqT")).isWsUrl);
$parcel$export(module.exports, "isJsonRpcError", () => (parcelRequire("3YiWF")).isJsonRpcError);
$parcel$export(module.exports, "isJsonRpcRequest", () => (parcelRequire("3YiWF")).isJsonRpcRequest);
$parcel$export(module.exports, "isJsonRpcResponse", () => (parcelRequire("3YiWF")).isJsonRpcResponse);
$parcel$export(module.exports, "isJsonRpcResult", () => (parcelRequire("3YiWF")).isJsonRpcResult);
parcelRequire("ly7fR");
parcelRequire("eIWLS");
parcelRequire("gCUc0");
parcelRequire("57Nk6");
parcelRequire("ixSSi");
parcelRequire("320f4");
parcelRequire("hKdqT");
parcelRequire("3YiWF");

});
parcelRequire.register("ly7fR", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_ERROR", () => $fb0266a13f89cf1a$export$f6e3abf3038d348f);
$parcel$export(module.exports, "SERVER_ERROR", () => $fb0266a13f89cf1a$export$125ebd30471ac25c);
$parcel$export(module.exports, "RESERVED_ERROR_CODES", () => $fb0266a13f89cf1a$export$af84821b5448ca78);
$parcel$export(module.exports, "SERVER_ERROR_CODE_RANGE", () => $fb0266a13f89cf1a$export$fff5b44b15c75f69);
$parcel$export(module.exports, "STANDARD_ERROR_MAP", () => $fb0266a13f89cf1a$export$cca5387ab287e1ae);
$parcel$export(module.exports, "DEFAULT_ERROR", () => $fb0266a13f89cf1a$export$d166979eca925bce);
const $fb0266a13f89cf1a$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $fb0266a13f89cf1a$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $fb0266a13f89cf1a$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $fb0266a13f89cf1a$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $fb0266a13f89cf1a$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $fb0266a13f89cf1a$export$125ebd30471ac25c = "SERVER_ERROR";
const $fb0266a13f89cf1a$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $fb0266a13f89cf1a$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $fb0266a13f89cf1a$export$cca5387ab287e1ae = {
    [$fb0266a13f89cf1a$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$fb0266a13f89cf1a$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$fb0266a13f89cf1a$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$fb0266a13f89cf1a$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$fb0266a13f89cf1a$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$fb0266a13f89cf1a$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $fb0266a13f89cf1a$export$d166979eca925bce = $fb0266a13f89cf1a$export$125ebd30471ac25c;

});

parcelRequire.register("eIWLS", function(module, exports) {

$parcel$export(module.exports, "isReservedErrorCode", () => $ab82c37acb5ed82a$export$2ae0ec6393ab16c3);
$parcel$export(module.exports, "getError", () => $ab82c37acb5ed82a$export$e1599abf47b5b568);
$parcel$export(module.exports, "getErrorByCode", () => $ab82c37acb5ed82a$export$60a3bac005957e12);
$parcel$export(module.exports, "parseConnectionError", () => $ab82c37acb5ed82a$export$f555d7d8f922e407);

var $ly7fR = parcelRequire("ly7fR");
function $ab82c37acb5ed82a$export$e463129eb4bc487f(code) {
    return code <= (0, $ly7fR.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, $ly7fR.SERVER_ERROR_CODE_RANGE)[1];
}
function $ab82c37acb5ed82a$export$2ae0ec6393ab16c3(code) {
    return (0, $ly7fR.RESERVED_ERROR_CODES).includes(code);
}
function $ab82c37acb5ed82a$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $ab82c37acb5ed82a$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $ly7fR.STANDARD_ERROR_MAP)).includes(type)) return (0, $ly7fR.STANDARD_ERROR_MAP)[0, $ly7fR.DEFAULT_ERROR];
    return (0, $ly7fR.STANDARD_ERROR_MAP)[type];
}
function $ab82c37acb5ed82a$export$60a3bac005957e12(code) {
    const match = Object.values((0, $ly7fR.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, $ly7fR.STANDARD_ERROR_MAP)[0, $ly7fR.DEFAULT_ERROR];
    return match;
}
function $ab82c37acb5ed82a$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$ab82c37acb5ed82a$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($ab82c37acb5ed82a$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $ab82c37acb5ed82a$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $ly7fR.STANDARD_ERROR_MAP)[0, $ly7fR.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $ab82c37acb5ed82a$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

});

parcelRequire.register("gCUc0", function(module, exports) {

var $2UPOf = parcelRequire("2UPOf");
const $c1abc8a6542d5235$export$d1694901a048d7c8 = (0, $2UPOf.isNode);
$parcel$exportWildcard(module.exports, $2UPOf);

});
parcelRequire.register("2UPOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h1yMJ = parcelRequire("h1yMJ");

$h1yMJ.__exportStar((parcelRequire("ljFVp")), module.exports);

$h1yMJ.__exportStar((parcelRequire("5vmD7")), module.exports);

});
parcelRequire.register("h1yMJ", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $c64d8340b8567f5d$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c64d8340b8567f5d$var$extendStatics = function(d, b) {
    $c64d8340b8567f5d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c64d8340b8567f5d$var$extendStatics(d, b);
};
function $c64d8340b8567f5d$export$a8ba968b8961cb8a(d, b) {
    $c64d8340b8567f5d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c64d8340b8567f5d$export$18ce0697a983be9b = function() {
    $c64d8340b8567f5d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c64d8340b8567f5d$export$18ce0697a983be9b.apply(this, arguments);
};
function $c64d8340b8567f5d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c64d8340b8567f5d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c64d8340b8567f5d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c64d8340b8567f5d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c64d8340b8567f5d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c64d8340b8567f5d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c64d8340b8567f5d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c64d8340b8567f5d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c64d8340b8567f5d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c64d8340b8567f5d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c64d8340b8567f5d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c64d8340b8567f5d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c64d8340b8567f5d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c64d8340b8567f5d$export$10c90e4f7922046c(v) {
    return this instanceof $c64d8340b8567f5d$export$10c90e4f7922046c ? (this.v = v, this) : new $c64d8340b8567f5d$export$10c90e4f7922046c(v);
}
function $c64d8340b8567f5d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c64d8340b8567f5d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c64d8340b8567f5d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c64d8340b8567f5d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c64d8340b8567f5d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c64d8340b8567f5d$export$19a8beecd37a4c45 === "function" ? $c64d8340b8567f5d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c64d8340b8567f5d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c64d8340b8567f5d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c64d8340b8567f5d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c64d8340b8567f5d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c64d8340b8567f5d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("ljFVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $f84be4b966947ef2$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $f84be4b966947ef2$var$getBrowerCrypto;
function $f84be4b966947ef2$var$getSubtleCrypto() {
    const browserCrypto = $f84be4b966947ef2$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $f84be4b966947ef2$var$getSubtleCrypto;
function $f84be4b966947ef2$var$isBrowserCryptoAvailable() {
    return !!$f84be4b966947ef2$var$getBrowerCrypto() && !!$f84be4b966947ef2$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $f84be4b966947ef2$var$isBrowserCryptoAvailable;

});

parcelRequire.register("5vmD7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $402166cfd1e26574$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $402166cfd1e26574$var$isReactNative;
function $402166cfd1e26574$var$isNode() {
    return typeof $hPtJY !== "undefined" && typeof $hPtJY.versions !== "undefined" && typeof $hPtJY.versions.node !== "undefined";
}
module.exports.isNode = $402166cfd1e26574$var$isNode;
function $402166cfd1e26574$var$isBrowser() {
    return !$402166cfd1e26574$var$isReactNative() && !$402166cfd1e26574$var$isNode();
}
module.exports.isBrowser = $402166cfd1e26574$var$isBrowser;

});



parcelRequire.register("57Nk6", function(module, exports) {

$parcel$export(module.exports, "payloadId", () => $3bb3ddc7bbc938cc$export$2f5364a5d4b80251);
$parcel$export(module.exports, "getBigIntRpcId", () => $3bb3ddc7bbc938cc$export$799a3db5df197877);
$parcel$export(module.exports, "formatJsonRpcRequest", () => $3bb3ddc7bbc938cc$export$11d081ebb32d4398);
$parcel$export(module.exports, "formatJsonRpcResult", () => $3bb3ddc7bbc938cc$export$478fdea01c2a3198);
$parcel$export(module.exports, "formatJsonRpcError", () => $3bb3ddc7bbc938cc$export$9f7302ae26c3f77);

var $eIWLS = parcelRequire("eIWLS");

var $ly7fR = parcelRequire("ly7fR");
function $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $3bb3ddc7bbc938cc$export$799a3db5df197877(entropy = 6) {
    return BigInt($3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy));
}
function $3bb3ddc7bbc938cc$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $3bb3ddc7bbc938cc$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $3bb3ddc7bbc938cc$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data)
    };
}
function $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $eIWLS.getError)((0, $ly7fR.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $eIWLS.getError)((0, $ly7fR.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $eIWLS.isReservedErrorCode)(error.code)) error = (0, $eIWLS.getErrorByCode)(error.code);
    return error;
}

});

parcelRequire.register("ixSSi", function(module, exports) {
function $d805e0076f614f48$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $d805e0076f614f48$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $d805e0076f614f48$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $d805e0076f614f48$export$8e8b9bea55b56df2(route) {
    if ($d805e0076f614f48$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $d805e0076f614f48$export$2d48faaafcc8fbdc(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $d805e0076f614f48$export$be298a4710fab756(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}

});

parcelRequire.register("320f4", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("6se3b")).IJsonRpcProvider);
parcelRequire("1319y");

});
parcelRequire.register("1319y", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("6se3b")).IJsonRpcProvider);
parcelRequire("1A0Jx");
parcelRequire("2WdM7");
parcelRequire("6se3b");
parcelRequire("ys1dW");

});
parcelRequire.register("1A0Jx", function(module, exports) {

});

parcelRequire.register("2WdM7", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $223baefd0cc0a951$export$ab429ec7e240e546);
class $223baefd0cc0a951$export$ab429ec7e240e546 {
}

});

parcelRequire.register("6se3b", function(module, exports) {

$parcel$export(module.exports, "IJsonRpcProvider", () => $4b3041b8db0f8b25$export$46957420a688a16d);

var $2WdM7 = parcelRequire("2WdM7");
class $4b3041b8db0f8b25$export$77d426dd89724fbe extends (0, $2WdM7.IEvents) {
    constructor(opts){
        super();
    }
}
class $4b3041b8db0f8b25$export$cb916a2eed49af33 extends (0, $2WdM7.IEvents) {
    constructor(){
        super();
    }
}
class $4b3041b8db0f8b25$export$46957420a688a16d extends $4b3041b8db0f8b25$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}

});

parcelRequire.register("ys1dW", function(module, exports) {

});



parcelRequire.register("hKdqT", function(module, exports) {

$parcel$export(module.exports, "isHttpUrl", () => $ceb127018999f416$export$206c3129b8bb1b4f);
$parcel$export(module.exports, "isWsUrl", () => $ceb127018999f416$export$4e4463e75eccf20c);
$parcel$export(module.exports, "isLocalhostUrl", () => $ceb127018999f416$export$8eb4a0a481601f29);
const $ceb127018999f416$var$HTTP_REGEX = "^https?:";
const $ceb127018999f416$var$WS_REGEX = "^wss?:";
function $ceb127018999f416$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $ceb127018999f416$var$matchRegexProtocol(url, regex) {
    const protocol = $ceb127018999f416$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $ceb127018999f416$export$206c3129b8bb1b4f(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$HTTP_REGEX);
}
function $ceb127018999f416$export$4e4463e75eccf20c(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$WS_REGEX);
}
function $ceb127018999f416$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

});

parcelRequire.register("3YiWF", function(module, exports) {

$parcel$export(module.exports, "isJsonRpcRequest", () => $2e45abd1d679ec32$export$f6e4034abe07d2a5);
$parcel$export(module.exports, "isJsonRpcResponse", () => $2e45abd1d679ec32$export$308ba927de2bcbe8);
$parcel$export(module.exports, "isJsonRpcResult", () => $2e45abd1d679ec32$export$cb3d3b20e3223d77);
$parcel$export(module.exports, "isJsonRpcError", () => $2e45abd1d679ec32$export$5662a1047b4d1d15);
function $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $2e45abd1d679ec32$export$f6e4034abe07d2a5(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $2e45abd1d679ec32$export$308ba927de2bcbe8(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && ($2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) || $2e45abd1d679ec32$export$5662a1047b4d1d15(payload));
}
function $2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $2e45abd1d679ec32$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $2e45abd1d679ec32$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}

});




parcelRequire.register("80onO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d413cc341fdd8f8$export$2e2bcd8739ae039);

var $fnJff = parcelRequire("fnJff");
var $5d413cc341fdd8f8$export$2e2bcd8739ae039 = (0, $fnJff.default);

});
parcelRequire.register("fnJff", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32c19adc47af628$export$2e2bcd8739ae039);

var $7etJZ = parcelRequire("7etJZ");

var $b8Ion = parcelRequire("b8Ion");
parcelRequire("2KWby");
var $hKdqT = parcelRequire("hKdqT");
var $2UPOf = parcelRequire("2UPOf");
var $57Nk6 = parcelRequire("57Nk6");
var $eIWLS = parcelRequire("eIWLS");

var $igM3O = parcelRequire("igM3O");
const $b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
const $b32c19adc47af628$var$WS = (0, $igM3O.resolveWebSocketImplementation)();
class $b32c19adc47af628$export$ea0df116fa892998 {
    constructor(url){
        this.url = url;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.registering = false;
        if (!(0, $hKdqT.isWsUrl)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        this.url = url;
    }
    get connected() {
        return typeof this.socket !== "undefined";
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        return new Promise((resolve, reject)=>{
            if (typeof this.socket === "undefined") {
                reject(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (event)=>{
                this.onClose(event);
                resolve();
            };
            this.socket.close();
        });
    }
    async send(payload, context) {
        if (typeof this.socket === "undefined") this.socket = await this.register();
        try {
            this.socket.send((0, $b8Ion.safeJsonStringify)(payload));
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    register(url = this.url) {
        if (!(0, $hKdqT.isWsUrl)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.socket === "undefined") return reject(new Error("WebSocket connection is missing or invalid"));
                    resolve(this.socket);
                });
            });
        }
        this.url = url;
        this.registering = true;
        return new Promise((resolve, reject)=>{
            const opts = !(0, $2UPOf.isReactNative)() ? {
                rejectUnauthorized: !(0, $hKdqT.isLocalhostUrl)(url)
            } : undefined;
            const socket = new $b32c19adc47af628$var$WS(url, [], opts);
            if ((0, $igM3O.hasBuiltInWebSocket)()) socket.onerror = (event)=>{
                const errorEvent = event;
                reject(this.emitError(errorEvent.error));
            };
            else socket.on("error", (errorEvent)=>{
                reject(this.emitError(errorEvent));
            });
            socket.onopen = ()=>{
                this.onOpen(socket);
                resolve(socket);
            };
        });
    }
    onOpen(socket) {
        socket.onmessage = (event)=>this.onPayload(event);
        socket.onclose = (event)=>this.onClose(event);
        this.socket = socket;
        this.registering = false;
        this.events.emit("open");
    }
    onClose(event) {
        this.socket = undefined;
        this.registering = false;
        this.events.emit("close", event);
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, $b8Ion.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, $57Nk6.formatJsonRpcError)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, $eIWLS.parseConnectionError)(e, (0, $igM3O.truncateQuery)(url), "WS");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > $b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners($b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
    emitError(errorEvent) {
        const error = this.parseError(new Error((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.message) || `WebSocket connection failed for host: ${(0, $igM3O.truncateQuery)(this.url)}`));
        this.events.emit("register_error", error);
        return error;
    }
}
var $b32c19adc47af628$export$2e2bcd8739ae039 = $b32c19adc47af628$export$ea0df116fa892998;

});
parcelRequire.register("igM3O", function(module, exports) {

$parcel$export(module.exports, "resolveWebSocketImplementation", () => $d4cf0068a97a66e2$export$a82e41cf513c80da);
$parcel$export(module.exports, "hasBuiltInWebSocket", () => $d4cf0068a97a66e2$export$6497c65e1ab5df4b);
$parcel$export(module.exports, "truncateQuery", () => $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2);

const $d4cf0068a97a66e2$export$a82e41cf513c80da = ()=>{
    if (typeof WebSocket !== "undefined") return WebSocket;
    else if (typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    else if (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") return window.WebSocket;
    else if (typeof self !== "undefined" && typeof self.WebSocket !== "undefined") return self.WebSocket;
    return (parcelRequire("fvaAM"));
};
const $d4cf0068a97a66e2$export$6497c65e1ab5df4b = ()=>typeof WebSocket !== "undefined" || typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined" || typeof window !== "undefined" && typeof window.WebSocket !== "undefined" || typeof self !== "undefined" && typeof self.WebSocket !== "undefined";
const $d4cf0068a97a66e2$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined";
const $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2 = (wssUrl)=>wssUrl.split("?")[0];

});
parcelRequire.register("fvaAM", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});




parcelRequire.register("6cqMT", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});



parcelRequire.register("dHHSL", function(module, exports) {
$parcel$export(module.exports, "HttpConnection", () => (parcelRequire("iIS2Z")).HttpConnection);

$parcel$export(module.exports, "default", () => $9fa154a0253fc04e$export$2e2bcd8739ae039);

var $iIS2Z = parcelRequire("iIS2Z");
var $9fa154a0253fc04e$export$2e2bcd8739ae039 = (0, $iIS2Z.default);

});
parcelRequire.register("iIS2Z", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", () => $da1642b2b5d2a2fb$export$13c1f9cf8a283575);
$parcel$export(module.exports, "default", () => $da1642b2b5d2a2fb$export$2e2bcd8739ae039);

var $7etJZ = parcelRequire("7etJZ");

var $R5nvG = parcelRequire("R5nvG");

var $b8Ion = parcelRequire("b8Ion");
parcelRequire("2KWby");
var $hKdqT = parcelRequire("hKdqT");
var $57Nk6 = parcelRequire("57Nk6");
var $eIWLS = parcelRequire("eIWLS");
const $da1642b2b5d2a2fb$var$DEFAULT_HTTP_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json"
};
const $da1642b2b5d2a2fb$var$DEFAULT_HTTP_METHOD = "POST";
const $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS = {
    headers: $da1642b2b5d2a2fb$var$DEFAULT_HTTP_HEADERS,
    method: $da1642b2b5d2a2fb$var$DEFAULT_HTTP_METHOD
};
const $da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
class $da1642b2b5d2a2fb$export$13c1f9cf8a283575 {
    constructor(url, disableProviderPing = false){
        this.url = url;
        this.disableProviderPing = disableProviderPing;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.isAvailable = false;
        this.registering = false;
        if (!(0, $hKdqT.isHttpUrl)(url)) throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
        this.url = url;
        this.disableProviderPing = disableProviderPing;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(payload, context) {
        if (!this.isAvailable) await this.register();
        try {
            const body = (0, $b8Ion.safeJsonStringify)(payload);
            const res = await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(this.url, Object.assign(Object.assign({}, $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS), {
                body: body
            }));
            const data = await res.json();
            this.onPayload({
                data: data
            });
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    async register(url = this.url) {
        if (!(0, $hKdqT.isHttpUrl)(url)) throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.isAvailable === "undefined") return reject(new Error("HTTP connection is missing or invalid"));
                    resolve();
                });
            });
        }
        this.url = url;
        this.registering = true;
        try {
            if (!this.disableProviderPing) {
                const body = (0, $b8Ion.safeJsonStringify)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(url, Object.assign(Object.assign({}, $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS), {
                    body: body
                }));
            }
            this.onOpen();
        } catch (e) {
            const error = this.parseError(e);
            this.events.emit("register_error", error);
            this.onClose();
            throw error;
        }
    }
    onOpen() {
        this.isAvailable = true;
        this.registering = false;
        this.events.emit("open");
    }
    onClose() {
        this.isAvailable = false;
        this.registering = false;
        this.events.emit("close");
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, $b8Ion.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, $57Nk6.formatJsonRpcError)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, $eIWLS.parseConnectionError)(e, url, "HTTP");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > $da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners($da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
}
var $da1642b2b5d2a2fb$export$2e2bcd8739ae039 = $da1642b2b5d2a2fb$export$13c1f9cf8a283575;

});
parcelRequire.register("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});




parcelRequire.register("yQvku", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("jicEo")).then(()=>parcelRequire("lUOEJ"));

});



//# sourceMappingURL=index.es.771304a6.js.map
